import * as vkontakteIcons from '@vkontakte/icons';

import * as additionalIcons from './additionalIcons';

export const vkIconsMap = {
  add: {
    12: vkontakteIcons.Icon12Add,
    16: vkontakteIcons.Icon16Add,
    20: vkontakteIcons.Icon20Add,
    24: vkontakteIcons.Icon24Add,
    36: vkontakteIcons.Icon36Add,
  },
  album_filled: {
    12: vkontakteIcons.Icon12AlbumFilled,
  },
  arrow_down: {
    12: vkontakteIcons.Icon12ArrowDown,
  },
  arrow_down_circle: {
    12: vkontakteIcons.Icon12ArrowDownCircle,
    16: vkontakteIcons.Icon16ArrowDownCircle,
  },
  arrow_down_left: {
    12: vkontakteIcons.Icon12ArrowDownLeft,
  },
  arrow_right: {
    12: vkontakteIcons.Icon12ArrowRight,
  },
  arrow_up: {
    12: vkontakteIcons.Icon12ArrowUp,
    24: vkontakteIcons.Icon24ArrowUp,
  },
  arrow_up_right: {
    12: vkontakteIcons.Icon12ArrowUpRight,
  },
  arrow_up_right_out_square_outline: {
    12: vkontakteIcons.Icon12ArrowUpRightOutSquareOutline,
    20: vkontakteIcons.Icon20ArrowUpRightOutSquareOutline,
    28: vkontakteIcons.Icon28ArrowUpRightOutSquareOutline,
    56: vkontakteIcons.Icon56ArrowUpRightOutSquareOutline,
  },
  arrow_uturn_right: {
    12: vkontakteIcons.Icon12ArrowUturnRight,
  },
  arrowshape_right: {
    12: vkontakteIcons.Icon12ArrowshapeRight,
  },
  article_box_outline: {
    12: vkontakteIcons.Icon12ArticleBoxOutline,
    16: vkontakteIcons.Icon16ArticleBoxOutline,
    20: vkontakteIcons.Icon20ArticleBoxOutline,
    24: vkontakteIcons.Icon24ArticleBoxOutline,
  },
  articles: {
    12: vkontakteIcons.Icon12Articles,
    20: vkontakteIcons.Icon20Articles,
  },
  articles_outline: {
    12: vkontakteIcons.Icon12ArticlesOutline,
    16: vkontakteIcons.Icon16ArticlesOutline,
    20: vkontakteIcons.Icon20ArticlesOutline,
    24: vkontakteIcons.Icon24ArticlesOutline,
    28: vkontakteIcons.Icon28ArticlesOutline,
    56: vkontakteIcons.Icon56ArticlesOutline,
  },
  block: {
    12: vkontakteIcons.Icon12Block,
    16: vkontakteIcons.Icon16Block,
    24: vkontakteIcons.Icon24Block,
    48: vkontakteIcons.Icon48Block,
  },
  bomb: {
    12: vkontakteIcons.Icon12Bomb,
    16: vkontakteIcons.Icon16Bomb,
  },
  bookmark_outline: {
    12: vkontakteIcons.Icon12BookmarkOutline,
    16: vkontakteIcons.Icon16BookmarkOutline,
    20: vkontakteIcons.Icon20BookmarkOutline,
    24: vkontakteIcons.Icon24BookmarkOutline,
    28: vkontakteIcons.Icon28BookmarkOutline,
    56: vkontakteIcons.Icon56BookmarkOutline,
  },
  cake: {
    12: vkontakteIcons.Icon12Cake,
  },
  cancel: {
    12: vkontakteIcons.Icon12Cancel,
    16: vkontakteIcons.Icon16Cancel,
    20: vkontakteIcons.Icon20Cancel,
    24: vkontakteIcons.Icon24Cancel,
    28: vkontakteIcons.Icon28Cancel,
    36: vkontakteIcons.Icon36Cancel,
  },
  cancel_circle_fill_red: {
    12: vkontakteIcons.Icon12CancelCircleFillRed,
    20: vkontakteIcons.Icon20CancelCircleFillRed,
    24: vkontakteIcons.Icon24CancelCircleFillRed,
    28: vkontakteIcons.Icon28CancelCircleFillRed,
  },
  cancel_outline: {
    12: vkontakteIcons.Icon12CancelOutline,
    24: vkontakteIcons.Icon24CancelOutline,
    28: vkontakteIcons.Icon28CancelOutline,
    36: vkontakteIcons.Icon36CancelOutline,
    48: vkontakteIcons.Icon48CancelOutline,
  },
  cards_2: {
    12: vkontakteIcons.Icon12Cards2,
    16: vkontakteIcons.Icon16Cards2,
    24: vkontakteIcons.Icon24Cards2,
    28: vkontakteIcons.Icon28Cards2,
  },
  chain: {
    12: vkontakteIcons.Icon12Chain,
    20: vkontakteIcons.Icon20Chain,
  },
  check: {
    12: vkontakteIcons.Icon12Check,
    20: vkontakteIcons.Icon20Check,
  },
  check_alt: {
    12: vkontakteIcons.Icon12CheckAlt,
    20: vkontakteIcons.Icon20CheckAlt,
  },
  check_circle: {
    12: vkontakteIcons.Icon12CheckCircle,
    16: vkontakteIcons.Icon16CheckCircle,
    32: vkontakteIcons.Icon32CheckCircle,
  },
  check_circle_fill: {
    12: vkontakteIcons.Icon12CheckCircleFill,
    28: vkontakteIcons.Icon28CheckCircleFill,
  },
  chevron: {
    12: vkontakteIcons.Icon12Chevron,
    16: vkontakteIcons.Icon16Chevron,
    24: vkontakteIcons.Icon24Chevron,
  },
  chevron_down_small: {
    12: vkontakteIcons.Icon12ChevronDownSmall,
    24: vkontakteIcons.Icon24ChevronDownSmall,
  },
  chevron_left: {
    12: vkontakteIcons.Icon12ChevronLeft,
    16: vkontakteIcons.Icon16ChevronLeft,
    20: vkontakteIcons.Icon20ChevronLeft,
    24: vkontakteIcons.Icon24ChevronLeft,
    28: vkontakteIcons.Icon28ChevronLeft,
  },
  chevron_outline: {
    12: vkontakteIcons.Icon12ChevronOutline,
    16: vkontakteIcons.Icon16ChevronOutline,
  },
  chevron_right: {
    12: vkontakteIcons.Icon12ChevronRight,
    20: vkontakteIcons.Icon20ChevronRight,
    24: vkontakteIcons.Icon24ChevronRight,
  },
  chevron_up: {
    12: vkontakteIcons.Icon12ChevronUp,
    20: vkontakteIcons.Icon20ChevronUp,
    24: vkontakteIcons.Icon24ChevronUp,
  },
  chevron_up_small: {
    12: vkontakteIcons.Icon12ChevronUpSmall,
    24: vkontakteIcons.Icon24ChevronUpSmall,
  },
  circle: {
    12: vkontakteIcons.Icon12Circle,
  },
  circle_outline: {
    12: vkontakteIcons.Icon12CircleOutline,
    20: vkontakteIcons.Icon20CircleOutline,
  },
  clock: {
    12: vkontakteIcons.Icon12Clock,
    16: vkontakteIcons.Icon16Clock,
    20: vkontakteIcons.Icon20Clock,
    24: vkontakteIcons.Icon24Clock,
    28: vkontakteIcons.Icon28Clock,
  },
  clock_outline: {
    12: vkontakteIcons.Icon12ClockOutline,
    16: vkontakteIcons.Icon16ClockOutline,
    20: vkontakteIcons.Icon20ClockOutline,
    24: vkontakteIcons.Icon24ClockOutline,
    28: vkontakteIcons.Icon28ClockOutline,
    36: vkontakteIcons.Icon36ClockOutline,
  },
  coins: {
    12: vkontakteIcons.Icon12Coins,
    24: vkontakteIcons.Icon24Coins,
    36: vkontakteIcons.Icon36Coins,
  },
  crown: {
    12: vkontakteIcons.Icon12Crown,
    16: vkontakteIcons.Icon16Crown,
    24: vkontakteIcons.Icon24Crown,
    28: vkontakteIcons.Icon28Crown,
  },
  delete: {
    12: vkontakteIcons.Icon12Delete,
    16: vkontakteIcons.Icon16Delete,
    24: vkontakteIcons.Icon24Delete,
    28: vkontakteIcons.Icon28Delete,
    36: vkontakteIcons.Icon36Delete,
  },
  dots_vertical: {
    12: vkontakteIcons.Icon12DotsVertical,
    20: vkontakteIcons.Icon20DotsVertical,
    24: vkontakteIcons.Icon24DotsVertical,
  },
  download: {
    12: vkontakteIcons.Icon12Download,
    24: vkontakteIcons.Icon24Download,
  },
  drop: {
    12: vkontakteIcons.Icon12Drop,
    16: vkontakteIcons.Icon16Drop,
  },
  dropdown: {
    12: vkontakteIcons.Icon12Dropdown,
    16: vkontakteIcons.Icon16Dropdown,
    20: vkontakteIcons.Icon20Dropdown,
    24: vkontakteIcons.Icon24Dropdown,
  },
  education: {
    12: vkontakteIcons.Icon12Education,
    16: vkontakteIcons.Icon16Education,
    24: vkontakteIcons.Icon24Education,
  },
  equalizer: {
    12: vkontakteIcons.Icon12Equalizer,
    16: vkontakteIcons.Icon16Equalizer,
  },
  error_circle: {
    12: vkontakteIcons.Icon12ErrorCircle,
    16: vkontakteIcons.Icon16ErrorCircle,
    20: vkontakteIcons.Icon20ErrorCircle,
    24: vkontakteIcons.Icon24ErrorCircle,
    32: vkontakteIcons.Icon32ErrorCircle,
    40: vkontakteIcons.Icon40ErrorCircle,
  },
  error_circle_fill: {
    12: vkontakteIcons.Icon12ErrorCircleFill,
    16: vkontakteIcons.Icon16ErrorCircleFill,
  },
  error_circle_fill_gray: {
    12: vkontakteIcons.Icon12ErrorCircleFillGray,
    24: vkontakteIcons.Icon24ErrorCircleFillGray,
  },
  error_circle_fill_overlay: {
    12: vkontakteIcons.Icon12ErrorCircleFillOverlay,
    16: vkontakteIcons.Icon16ErrorCircleFillOverlay,
  },
  error_circle_fill_yellow: {
    12: vkontakteIcons.Icon12ErrorCircleFillYellow,
    16: vkontakteIcons.Icon16ErrorCircleFillYellow,
    20: vkontakteIcons.Icon20ErrorCircleFillYellow,
  },
  explicit: {
    12: vkontakteIcons.Icon12Explicit,
    16: vkontakteIcons.Icon16Explicit,
    24: vkontakteIcons.Icon24Explicit,
  },
  eye_slash_outline: {
    12: vkontakteIcons.Icon12EyeSlashOutline,
  },
  favorite: {
    12: vkontakteIcons.Icon12Favorite,
    16: vkontakteIcons.Icon16Favorite,
    20: vkontakteIcons.Icon20Favorite,
    24: vkontakteIcons.Icon24Favorite,
    28: vkontakteIcons.Icon28Favorite,
    36: vkontakteIcons.Icon36Favorite,
  },
  fire: {
    12: vkontakteIcons.Icon12Fire,
    16: vkontakteIcons.Icon16Fire,
    24: vkontakteIcons.Icon24Fire,
    28: vkontakteIcons.Icon28Fire,
    56: vkontakteIcons.Icon56Fire,
  },
  fire_alt: {
    12: vkontakteIcons.Icon12FireAlt,
    16: vkontakteIcons.Icon16FireAlt,
  },
  fire_verified: {
    12: vkontakteIcons.Icon12FireVerified,
    16: vkontakteIcons.Icon16FireVerified,
  },
  flag: {
    12: vkontakteIcons.Icon12Flag,
    16: vkontakteIcons.Icon16Flag,
  },
  flash: {
    12: vkontakteIcons.Icon12Flash,
    16: vkontakteIcons.Icon16Flash,
    20: vkontakteIcons.Icon20Flash,
    24: vkontakteIcons.Icon24Flash,
    28: vkontakteIcons.Icon28Flash,
  },
  flash_circle: {
    12: vkontakteIcons.Icon12FlashCircle,
  },
  gavel: {
    12: vkontakteIcons.Icon12Gavel,
  },
  ghost: {
    12: vkontakteIcons.Icon12Ghost,
    16: vkontakteIcons.Icon16Ghost,
    20: vkontakteIcons.Icon20Ghost,
    24: vkontakteIcons.Icon24Ghost,
    28: vkontakteIcons.Icon28Ghost,
  },
  gift: {
    12: vkontakteIcons.Icon12Gift,
    16: vkontakteIcons.Icon16Gift,
    20: vkontakteIcons.Icon20Gift,
    24: vkontakteIcons.Icon24Gift,
    28: vkontakteIcons.Icon28Gift,
    32: vkontakteIcons.Icon32Gift,
    36: vkontakteIcons.Icon36Gift,
  },
  government: {
    12: vkontakteIcons.Icon12Government,
  },
  hand: {
    12: vkontakteIcons.Icon12Hand,
    16: vkontakteIcons.Icon16Hand,
    20: vkontakteIcons.Icon20Hand,
    28: vkontakteIcons.Icon28Hand,
  },
  hand_point_up: {
    12: vkontakteIcons.Icon12HandPointUp,
    24: vkontakteIcons.Icon24HandPointUp,
  },
  headphones: {
    12: vkontakteIcons.Icon12Headphones,
    16: vkontakteIcons.Icon16Headphones,
    24: vkontakteIcons.Icon24Headphones,
  },
  help: {
    12: vkontakteIcons.Icon12Help,
    16: vkontakteIcons.Icon16Help,
    24: vkontakteIcons.Icon24Help,
  },
  hieroglyph_character_outline: {
    12: vkontakteIcons.Icon12HieroglyphCharacterOutline,
    16: vkontakteIcons.Icon16HieroglyphCharacterOutline,
    20: vkontakteIcons.Icon20HieroglyphCharacterOutline,
    24: vkontakteIcons.Icon24HieroglyphCharacterOutline,
    28: vkontakteIcons.Icon28HieroglyphCharacterOutline,
  },
  home: {
    12: vkontakteIcons.Icon12Home,
    24: vkontakteIcons.Icon24Home,
  },
  info_circle: {
    12: vkontakteIcons.Icon12InfoCircle,
    16: vkontakteIcons.Icon16InfoCircle,
    28: vkontakteIcons.Icon28InfoCircle,
  },
  like: {
    12: vkontakteIcons.Icon12Like,
    16: vkontakteIcons.Icon16Like,
    20: vkontakteIcons.Icon20Like,
    24: vkontakteIcons.Icon24Like,
    28: vkontakteIcons.Icon28Like,
    36: vkontakteIcons.Icon36Like,
    48: vkontakteIcons.Icon48Like,
  },
  like_outline: {
    12: vkontakteIcons.Icon12LikeOutline,
    16: vkontakteIcons.Icon16LikeOutline,
    20: vkontakteIcons.Icon20LikeOutline,
    24: vkontakteIcons.Icon24LikeOutline,
    28: vkontakteIcons.Icon28LikeOutline,
    36: vkontakteIcons.Icon36LikeOutline,
    56: vkontakteIcons.Icon56LikeOutline,
  },
  list_play_outline: {
    12: vkontakteIcons.Icon12ListPlayOutline,
    16: vkontakteIcons.Icon16ListPlayOutline,
    20: vkontakteIcons.Icon20ListPlayOutline,
    28: vkontakteIcons.Icon28ListPlayOutline,
    36: vkontakteIcons.Icon36ListPlayOutline,
    56: vkontakteIcons.Icon56ListPlayOutline,
  },
  lock: {
    12: vkontakteIcons.Icon12Lock,
    16: vkontakteIcons.Icon16Lock,
    20: vkontakteIcons.Icon20Lock,
    24: vkontakteIcons.Icon24Lock,
  },
  logo_clips: {
    12: vkontakteIcons.Icon12LogoClips,
    16: vkontakteIcons.Icon16LogoClips,
  },
  logo_vk_ads: {
    12: vkontakteIcons.Icon12LogoVkAds,
    16: vkontakteIcons.Icon16LogoVkAds,
  },
  market: {
    12: vkontakteIcons.Icon12Market,
    16: vkontakteIcons.Icon16Market,
    24: vkontakteIcons.Icon24Market,
    28: vkontakteIcons.Icon28Market,
    36: vkontakteIcons.Icon36Market,
  },
  market_slash: {
    12: vkontakteIcons.Icon12MarketSlash,
  },
  mask: {
    12: vkontakteIcons.Icon12Mask,
    16: vkontakteIcons.Icon16Mask,
  },
  mention: {
    12: vkontakteIcons.Icon12Mention,
    16: vkontakteIcons.Icon16Mention,
    24: vkontakteIcons.Icon24Mention,
    28: vkontakteIcons.Icon28Mention,
  },
  message: {
    12: vkontakteIcons.Icon12Message,
    16: vkontakteIcons.Icon16Message,
    20: vkontakteIcons.Icon20Message,
    24: vkontakteIcons.Icon24Message,
    28: vkontakteIcons.Icon28Message,
  },
  message_cross: {
    12: vkontakteIcons.Icon12MessageCross,
    16: vkontakteIcons.Icon16MessageCross,
  },
  message_heart: {
    12: vkontakteIcons.Icon12MessageHeart,
    16: vkontakteIcons.Icon16MessageHeart,
    20: vkontakteIcons.Icon20MessageHeart,
    24: vkontakteIcons.Icon24MessageHeart,
    28: vkontakteIcons.Icon28MessageHeart,
    36: vkontakteIcons.Icon36MessageHeart,
  },
  message_outline: {
    12: vkontakteIcons.Icon12MessageOutline,
    16: vkontakteIcons.Icon16MessageOutline,
    20: vkontakteIcons.Icon20MessageOutline,
    24: vkontakteIcons.Icon24MessageOutline,
    28: vkontakteIcons.Icon28MessageOutline,
    36: vkontakteIcons.Icon36MessageOutline,
    56: vkontakteIcons.Icon56MessageOutline,
  },
  money_circle: {
    12: vkontakteIcons.Icon12MoneyCircle,
    16: vkontakteIcons.Icon16MoneyCircle,
    24: vkontakteIcons.Icon24MoneyCircle,
  },
  moon: {
    12: vkontakteIcons.Icon12Moon,
    16: vkontakteIcons.Icon16Moon,
    24: vkontakteIcons.Icon24Moon,
  },
  music: {
    12: vkontakteIcons.Icon12Music,
    16: vkontakteIcons.Icon16Music,
    24: vkontakteIcons.Icon24Music,
    28: vkontakteIcons.Icon28Music,
    32: vkontakteIcons.Icon32Music,
    36: vkontakteIcons.Icon36Music,
  },
  music_mic: {
    12: vkontakteIcons.Icon12MusicMic,
    16: vkontakteIcons.Icon16MusicMic,
    20: vkontakteIcons.Icon20MusicMic,
    24: vkontakteIcons.Icon24MusicMic,
  },
  music_note: {
    12: vkontakteIcons.Icon12MusicNote,
    20: vkontakteIcons.Icon20MusicNote,
    24: vkontakteIcons.Icon24MusicNote,
  },
  narrative_active_outline: {
    12: vkontakteIcons.Icon12NarrativeActiveOutline,
    24: vkontakteIcons.Icon24NarrativeActiveOutline,
    28: vkontakteIcons.Icon28NarrativeActiveOutline,
  },
  nft_heptagon: {
    12: vkontakteIcons.Icon12NftHeptagon,
    16: vkontakteIcons.Icon16NftHeptagon,
  },
  notebook: {
    12: vkontakteIcons.Icon12Notebook,
    16: vkontakteIcons.Icon16Notebook,
  },
  notebook_check_outline: {
    12: vkontakteIcons.Icon12NotebookCheckOutline,
    16: vkontakteIcons.Icon16NotebookCheckOutline,
    20: vkontakteIcons.Icon20NotebookCheckOutline,
    24: vkontakteIcons.Icon24NotebookCheckOutline,
    28: vkontakteIcons.Icon28NotebookCheckOutline,
    36: vkontakteIcons.Icon36NotebookCheckOutline,
    56: vkontakteIcons.Icon56NotebookCheckOutline,
  },
  online_mobile: {
    12: vkontakteIcons.Icon12OnlineMobile,
    16: vkontakteIcons.Icon16OnlineMobile,
  },
  online_vkmobile: {
    12: vkontakteIcons.Icon12OnlineVkmobile,
  },
  palette: {
    12: vkontakteIcons.Icon12Palette,
    24: vkontakteIcons.Icon24Palette,
    48: vkontakteIcons.Icon48Palette,
  },
  pause: {
    12: vkontakteIcons.Icon12Pause,
    16: vkontakteIcons.Icon16Pause,
    20: vkontakteIcons.Icon20Pause,
    24: vkontakteIcons.Icon24Pause,
    28: vkontakteIcons.Icon28Pause,
    32: vkontakteIcons.Icon32Pause,
    36: vkontakteIcons.Icon36Pause,
    48: vkontakteIcons.Icon48Pause,
    64: vkontakteIcons.Icon64Pause,
  },
  payment_card_outline: {
    12: vkontakteIcons.Icon12PaymentCardOutline,
    16: vkontakteIcons.Icon16PaymentCardOutline,
    20: vkontakteIcons.Icon20PaymentCardOutline,
    24: vkontakteIcons.Icon24PaymentCardOutline,
    28: vkontakteIcons.Icon28PaymentCardOutline,
    56: vkontakteIcons.Icon56PaymentCardOutline,
  },
  pencil: {
    12: vkontakteIcons.Icon12Pencil,
  },
  percent_outline: {
    12: vkontakteIcons.Icon12PercentOutline,
    16: vkontakteIcons.Icon16PercentOutline,
  },
  phone: {
    12: vkontakteIcons.Icon12Phone,
    16: vkontakteIcons.Icon16Phone,
    20: vkontakteIcons.Icon20Phone,
    24: vkontakteIcons.Icon24Phone,
    28: vkontakteIcons.Icon28Phone,
    32: vkontakteIcons.Icon32Phone,
    36: vkontakteIcons.Icon36Phone,
  },
  picture: {
    12: vkontakteIcons.Icon12Picture,
    16: vkontakteIcons.Icon16Picture,
    24: vkontakteIcons.Icon24Picture,
    36: vkontakteIcons.Icon36Picture,
  },
  picture_outline: {
    12: vkontakteIcons.Icon12PictureOutline,
    16: vkontakteIcons.Icon16PictureOutline,
    20: vkontakteIcons.Icon20PictureOutline,
    24: vkontakteIcons.Icon24PictureOutline,
    28: vkontakteIcons.Icon28PictureOutline,
    32: vkontakteIcons.Icon32PictureOutline,
    36: vkontakteIcons.Icon36PictureOutline,
    48: vkontakteIcons.Icon48PictureOutline,
  },
  pin: {
    12: vkontakteIcons.Icon12Pin,
    16: vkontakteIcons.Icon16Pin,
    20: vkontakteIcons.Icon20Pin,
    24: vkontakteIcons.Icon24Pin,
  },
  place: {
    12: vkontakteIcons.Icon12Place,
    16: vkontakteIcons.Icon16Place,
    24: vkontakteIcons.Icon24Place,
    28: vkontakteIcons.Icon28Place,
    32: vkontakteIcons.Icon32Place,
  },
  play: {
    12: vkontakteIcons.Icon12Play,
    16: vkontakteIcons.Icon16Play,
    20: vkontakteIcons.Icon20Play,
    24: vkontakteIcons.Icon24Play,
    28: vkontakteIcons.Icon28Play,
    32: vkontakteIcons.Icon32Play,
    36: vkontakteIcons.Icon36Play,
    48: vkontakteIcons.Icon48Play,
    64: vkontakteIcons.Icon64Play,
  },
  play_circle: {
    12: vkontakteIcons.Icon12PlayCircle,
    16: vkontakteIcons.Icon16PlayCircle,
    20: vkontakteIcons.Icon20PlayCircle,
    24: vkontakteIcons.Icon24PlayCircle,
    28: vkontakteIcons.Icon28PlayCircle,
    32: vkontakteIcons.Icon32PlayCircle,
    40: vkontakteIcons.Icon40PlayCircle,
  },
  play_circle_fill_gray: {
    12: vkontakteIcons.Icon12PlayCircleFillGray,
    16: vkontakteIcons.Icon16PlayCircleFillGray,
    28: vkontakteIcons.Icon28PlayCircleFillGray,
  },
  podcast_outline: {
    12: vkontakteIcons.Icon12PodcastOutline,
    16: vkontakteIcons.Icon16PodcastOutline,
    20: vkontakteIcons.Icon20PodcastOutline,
    28: vkontakteIcons.Icon28PodcastOutline,
  },
  poll: {
    12: vkontakteIcons.Icon12Poll,
    16: vkontakteIcons.Icon16Poll,
    24: vkontakteIcons.Icon24Poll,
    32: vkontakteIcons.Icon32Poll,
  },
  popup_stickers_circle_fill_raspberry_pink_product: {
    12: vkontakteIcons.Icon12PopupStickersCircleFillRaspberryPinkProduct,
    16: vkontakteIcons.Icon16PopupStickersCircleFillRaspberryPinkProduct,
    28: vkontakteIcons.Icon28PopupStickersCircleFillRaspberryPinkProduct,
  },
  question: {
    12: vkontakteIcons.Icon12Question,
    16: vkontakteIcons.Icon16Question,
    24: vkontakteIcons.Icon24Question,
  },
  quote_closing: {
    12: vkontakteIcons.Icon12QuoteClosing,
    20: vkontakteIcons.Icon20QuoteClosing,
    24: vkontakteIcons.Icon24QuoteClosing,
    28: vkontakteIcons.Icon28QuoteClosing,
  },
  rectrangle_hand_point_up: {
    12: vkontakteIcons.Icon12RectrangleHandPointUp,
    28: vkontakteIcons.Icon28RectrangleHandPointUp,
  },
  reply: {
    12: vkontakteIcons.Icon12Reply,
    16: vkontakteIcons.Icon16Reply,
    24: vkontakteIcons.Icon24Reply,
  },
  repost: {
    12: vkontakteIcons.Icon12Repost,
    16: vkontakteIcons.Icon16Repost,
    24: vkontakteIcons.Icon24Repost,
  },
  rocket: {
    12: vkontakteIcons.Icon12Rocket,
    16: vkontakteIcons.Icon16Rocket,
    24: vkontakteIcons.Icon24Rocket,
    28: vkontakteIcons.Icon28Rocket,
  },
  scribble_pencil_rectangle: {
    12: vkontakteIcons.Icon12ScribblePencilRectangle,
    16: vkontakteIcons.Icon16ScribblePencilRectangle,
    24: vkontakteIcons.Icon24ScribblePencilRectangle,
  },
  scribble_pencil_rectangle_outline: {
    12: vkontakteIcons.Icon12ScribblePencilRectangleOutline,
    16: vkontakteIcons.Icon16ScribblePencilRectangleOutline,
    24: vkontakteIcons.Icon24ScribblePencilRectangleOutline,
  },
  services: {
    12: vkontakteIcons.Icon12Services,
    16: vkontakteIcons.Icon16Services,
    24: vkontakteIcons.Icon24Services,
    28: vkontakteIcons.Icon28Services,
    48: vkontakteIcons.Icon48Services,
  },
  smile_filled: {
    12: vkontakteIcons.Icon12SmileFilled,
    16: vkontakteIcons.Icon16SmileFilled,
  },
  spinner: {
    12: vkontakteIcons.Icon12Spinner,
    16: vkontakteIcons.Icon16Spinner,
    20: vkontakteIcons.Icon20Spinner,
    24: vkontakteIcons.Icon24Spinner,
    28: vkontakteIcons.Icon28Spinner,
    32: vkontakteIcons.Icon32Spinner,
    36: vkontakteIcons.Icon36Spinner,
    44: vkontakteIcons.Icon44Spinner,
    56: vkontakteIcons.Icon56Spinner,
  },
  square_filled: {
    12: vkontakteIcons.Icon12SquareFilled,
    20: vkontakteIcons.Icon20SquareFilled,
    24: vkontakteIcons.Icon24SquareFilled,
  },
  square_outline: {
    12: vkontakteIcons.Icon12SquareOutline,
    20: vkontakteIcons.Icon20SquareOutline,
    24: vkontakteIcons.Icon24SquareOutline,
  },
  star: {
    12: vkontakteIcons.Icon12Star,
  },
  star_circle: {
    12: vkontakteIcons.Icon12StarCircle,
    16: vkontakteIcons.Icon16StarCircle,
  },
  star_circle_fill_yellow: {
    12: vkontakteIcons.Icon12StarCircleFillYellow,
    16: vkontakteIcons.Icon16StarCircleFillYellow,
    24: vkontakteIcons.Icon24StarCircleFillYellow,
  },
  stars: {
    12: vkontakteIcons.Icon12Stars,
    16: vkontakteIcons.Icon16Stars,
    20: vkontakteIcons.Icon20Stars,
  },
  story: {
    12: vkontakteIcons.Icon12Story,
    16: vkontakteIcons.Icon16Story,
    20: vkontakteIcons.Icon20Story,
    24: vkontakteIcons.Icon24Story,
    28: vkontakteIcons.Icon28Story,
    36: vkontakteIcons.Icon36Story,
    48: vkontakteIcons.Icon48Story,
  },
  subtitles: {
    12: vkontakteIcons.Icon12Subtitles,
    16: vkontakteIcons.Icon16Subtitles,
    24: vkontakteIcons.Icon24Subtitles,
    28: vkontakteIcons.Icon28Subtitles,
    48: vkontakteIcons.Icon48Subtitles,
  },
  switch: {
    12: vkontakteIcons.Icon12Switch,
    24: vkontakteIcons.Icon24Switch,
  },
  tag: {
    12: vkontakteIcons.Icon12Tag,
    16: vkontakteIcons.Icon16Tag,
    24: vkontakteIcons.Icon24Tag,
  },
  unlock: {
    12: vkontakteIcons.Icon12Unlock,
  },
  user: {
    12: vkontakteIcons.Icon12User,
    16: vkontakteIcons.Icon16User,
    20: vkontakteIcons.Icon20User,
    24: vkontakteIcons.Icon24User,
    28: vkontakteIcons.Icon28User,
  },
  user_tag: {
    12: vkontakteIcons.Icon12UserTag,
  },
  users: {
    12: vkontakteIcons.Icon12Users,
    16: vkontakteIcons.Icon16Users,
    20: vkontakteIcons.Icon20Users,
    24: vkontakteIcons.Icon24Users,
    28: vkontakteIcons.Icon28Users,
    36: vkontakteIcons.Icon36Users,
  },
  verified: {
    12: vkontakteIcons.Icon12Verified,
    16: vkontakteIcons.Icon16Verified,
    20: vkontakteIcons.Icon20Verified,
  },
  verified_alt: {
    12: vkontakteIcons.Icon12VerifiedAlt,
  },
  video: {
    12: vkontakteIcons.Icon12Video,
    16: vkontakteIcons.Icon16Video,
    24: vkontakteIcons.Icon24Video,
    28: vkontakteIcons.Icon28Video,
    36: vkontakteIcons.Icon36Video,
    48: vkontakteIcons.Icon48Video,
  },
  video_square_outline: {
    12: vkontakteIcons.Icon12VideoSquareOutline,
    16: vkontakteIcons.Icon16VideoSquareOutline,
    20: vkontakteIcons.Icon20VideoSquareOutline,
    24: vkontakteIcons.Icon24VideoSquareOutline,
    28: vkontakteIcons.Icon28VideoSquareOutline,
    32: vkontakteIcons.Icon32VideoSquareOutline,
  },
  view: {
    12: vkontakteIcons.Icon12View,
    16: vkontakteIcons.Icon16View,
    20: vkontakteIcons.Icon20View,
    24: vkontakteIcons.Icon24View,
    28: vkontakteIcons.Icon28View,
  },
  achievement_circle_fill_blue: {
    16: vkontakteIcons.Icon16AchievementCircleFillBlue,
    20: vkontakteIcons.Icon20AchievementCircleFillBlue,
    24: vkontakteIcons.Icon24AchievementCircleFillBlue,
    28: vkontakteIcons.Icon28AchievementCircleFillBlue,
  },
  add_circle: {
    16: vkontakteIcons.Icon16AddCircle,
    20: vkontakteIcons.Icon20AddCircle,
    24: vkontakteIcons.Icon24AddCircle,
  },
  add_circle_fill_blue: {
    16: vkontakteIcons.Icon16AddCircleFillBlue,
    20: vkontakteIcons.Icon20AddCircleFillBlue,
    24: vkontakteIcons.Icon24AddCircleFillBlue,
    28: vkontakteIcons.Icon28AddCircleFillBlue,
  },
  add_circle_fill_red: {
    16: vkontakteIcons.Icon16AddCircleFillRed,
  },
  add_circle_fill_white: {
    16: vkontakteIcons.Icon16AddCircleFillWhite,
  },
  add_circle_outline: {
    16: vkontakteIcons.Icon16AddCircleOutline,
    20: vkontakteIcons.Icon20AddCircleOutline,
    24: vkontakteIcons.Icon24AddCircleOutline,
    28: vkontakteIcons.Icon28AddCircleOutline,
    56: vkontakteIcons.Icon56AddCircleOutline,
  },
  add_rectangle_line: {
    16: vkontakteIcons.Icon16AddRectangleLine,
    24: vkontakteIcons.Icon24AddRectangleLine,
  },
  add_square_outline: {
    16: vkontakteIcons.Icon16AddSquareOutline,
    20: vkontakteIcons.Icon20AddSquareOutline,
    24: vkontakteIcons.Icon24AddSquareOutline,
    28: vkontakteIcons.Icon28AddSquareOutline,
  },
  advertising: {
    16: vkontakteIcons.Icon16Advertising,
    24: vkontakteIcons.Icon24Advertising,
  },
  alarm_outline: {
    16: vkontakteIcons.Icon16AlarmOutline,
    20: vkontakteIcons.Icon20AlarmOutline,
  },
  archive_outline: {
    16: vkontakteIcons.Icon16ArchiveOutline,
    20: vkontakteIcons.Icon20ArchiveOutline,
    24: vkontakteIcons.Icon24ArchiveOutline,
    28: vkontakteIcons.Icon28ArchiveOutline,
    56: vkontakteIcons.Icon56ArchiveOutline,
  },
  arrow_down_outline: {
    16: vkontakteIcons.Icon16ArrowDownOutline,
    20: vkontakteIcons.Icon20ArrowDownOutline,
    24: vkontakteIcons.Icon24ArrowDownOutline,
    28: vkontakteIcons.Icon28ArrowDownOutline,
    48: vkontakteIcons.Icon48ArrowDownOutline,
  },
  arrow_left_outline: {
    16: vkontakteIcons.Icon16ArrowLeftOutline,
    20: vkontakteIcons.Icon20ArrowLeftOutline,
    24: vkontakteIcons.Icon24ArrowLeftOutline,
    28: vkontakteIcons.Icon28ArrowLeftOutline,
    48: vkontakteIcons.Icon48ArrowLeftOutline,
  },
  arrow_right_circle: {
    16: vkontakteIcons.Icon16ArrowRightCircle,
  },
  arrow_right_outline: {
    16: vkontakteIcons.Icon16ArrowRightOutline,
    20: vkontakteIcons.Icon20ArrowRightOutline,
    24: vkontakteIcons.Icon24ArrowRightOutline,
    28: vkontakteIcons.Icon28ArrowRightOutline,
    48: vkontakteIcons.Icon48ArrowRightOutline,
  },
  arrow_triangle_down: {
    16: vkontakteIcons.Icon16ArrowTriangleDown,
  },
  arrow_triangle_up: {
    16: vkontakteIcons.Icon16ArrowTriangleUp,
  },
  arrow_up_circle: {
    16: vkontakteIcons.Icon16ArrowUpCircle,
  },
  arrow_up_outline: {
    16: vkontakteIcons.Icon16ArrowUpOutline,
    20: vkontakteIcons.Icon20ArrowUpOutline,
    24: vkontakteIcons.Icon24ArrowUpOutline,
    28: vkontakteIcons.Icon28ArrowUpOutline,
    48: vkontakteIcons.Icon48ArrowUpOutline,
  },
  arrow_up_rectangle: {
    16: vkontakteIcons.Icon16ArrowUpRectangle,
    20: vkontakteIcons.Icon20ArrowUpRectangle,
    24: vkontakteIcons.Icon24ArrowUpRectangle,
    28: vkontakteIcons.Icon28ArrowUpRectangle,
  },
  arrow_uturn_left_outline: {
    16: vkontakteIcons.Icon16ArrowUturnLeftOutline,
    20: vkontakteIcons.Icon20ArrowUturnLeftOutline,
    24: vkontakteIcons.Icon24ArrowUturnLeftOutline,
    28: vkontakteIcons.Icon28ArrowUturnLeftOutline,
    36: vkontakteIcons.Icon36ArrowUturnLeftOutline,
    56: vkontakteIcons.Icon56ArrowUturnLeftOutline,
  },
  arrows_4_outward: {
    16: vkontakteIcons.Icon16Arrows4Outward,
  },
  arrows_up_down: {
    16: vkontakteIcons.Icon16ArrowsUpDown,
  },
  arrowshape_left_right: {
    16: vkontakteIcons.Icon16ArrowshapeLeftRight,
    20: vkontakteIcons.Icon20ArrowshapeLeftRight,
  },
  arrowshape_right_outline: {
    16: vkontakteIcons.Icon16ArrowshapeRightOutline,
    20: vkontakteIcons.Icon20ArrowshapeRightOutline,
  },
  article_outline: {
    16: vkontakteIcons.Icon16ArticleOutline,
    20: vkontakteIcons.Icon20ArticleOutline,
    24: vkontakteIcons.Icon24ArticleOutline,
    28: vkontakteIcons.Icon28ArticleOutline,
    56: vkontakteIcons.Icon56ArticleOutline,
  },
  attach: {
    16: vkontakteIcons.Icon16Attach,
    20: vkontakteIcons.Icon20Attach,
    24: vkontakteIcons.Icon24Attach,
  },
  backpack: {
    16: vkontakteIcons.Icon16Backpack,
  },
  blogger_mark_10k_outline: {
    16: vkontakteIcons.Icon16BloggerMark10kOutline,
  },
  bomb_circle_fill_purple: {
    16: vkontakteIcons.Icon16BombCircleFillPurple,
  },
  book_spread: {
    16: vkontakteIcons.Icon16BookSpread,
  },
  book_spread_outline: {
    16: vkontakteIcons.Icon16BookSpreadOutline,
    20: vkontakteIcons.Icon20BookSpreadOutline,
    24: vkontakteIcons.Icon24BookSpreadOutline,
    28: vkontakteIcons.Icon28BookSpreadOutline,
  },
  bookmark: {
    16: vkontakteIcons.Icon16Bookmark,
    20: vkontakteIcons.Icon20Bookmark,
    24: vkontakteIcons.Icon24Bookmark,
    28: vkontakteIcons.Icon28Bookmark,
  },
  brush_outline: {
    16: vkontakteIcons.Icon16BrushOutline,
    20: vkontakteIcons.Icon20BrushOutline,
    24: vkontakteIcons.Icon24BrushOutline,
    28: vkontakteIcons.Icon28BrushOutline,
    56: vkontakteIcons.Icon56BrushOutline,
  },
  bug_outline: {
    16: vkontakteIcons.Icon16BugOutline,
    20: vkontakteIcons.Icon20BugOutline,
    24: vkontakteIcons.Icon24BugOutline,
    28: vkontakteIcons.Icon28BugOutline,
  },
  building_outline: {
    16: vkontakteIcons.Icon16BuildingOutline,
    20: vkontakteIcons.Icon20BuildingOutline,
    24: vkontakteIcons.Icon24BuildingOutline,
    28: vkontakteIcons.Icon28BuildingOutline,
    36: vkontakteIcons.Icon36BuildingOutline,
    56: vkontakteIcons.Icon56BuildingOutline,
  },
  cake_circle_fill_purple: {
    16: vkontakteIcons.Icon16CakeCircleFillPurple,
    20: vkontakteIcons.Icon20CakeCircleFillPurple,
    28: vkontakteIcons.Icon28CakeCircleFillPurple,
    32: vkontakteIcons.Icon32CakeCircleFillPurple,
    56: vkontakteIcons.Icon56CakeCircleFillPurple,
  },
  calendar_outline: {
    16: vkontakteIcons.Icon16CalendarOutline,
    20: vkontakteIcons.Icon20CalendarOutline,
    24: vkontakteIcons.Icon24CalendarOutline,
    28: vkontakteIcons.Icon28CalendarOutline,
    36: vkontakteIcons.Icon36CalendarOutline,
    56: vkontakteIcons.Icon56CalendarOutline,
  },
  cam_slash: {
    16: vkontakteIcons.Icon16CamSlash,
  },
  camera: {
    16: vkontakteIcons.Icon16Camera,
    20: vkontakteIcons.Icon20Camera,
    24: vkontakteIcons.Icon24Camera,
    28: vkontakteIcons.Icon28Camera,
    32: vkontakteIcons.Icon32Camera,
    36: vkontakteIcons.Icon36Camera,
    48: vkontakteIcons.Icon48Camera,
  },
  cancel_circle: {
    16: vkontakteIcons.Icon16CancelCircle,
    36: vkontakteIcons.Icon36CancelCircle,
  },
  cancel_circle_outline: {
    16: vkontakteIcons.Icon16CancelCircleOutline,
    20: vkontakteIcons.Icon20CancelCircleOutline,
    24: vkontakteIcons.Icon24CancelCircleOutline,
    28: vkontakteIcons.Icon28CancelCircleOutline,
    56: vkontakteIcons.Icon56CancelCircleOutline,
  },
  carousel_outline: {
    16: vkontakteIcons.Icon16CarouselOutline,
    20: vkontakteIcons.Icon20CarouselOutline,
    56: vkontakteIcons.Icon56CarouselOutline,
  },
  chain_outline: {
    16: vkontakteIcons.Icon16ChainOutline,
    24: vkontakteIcons.Icon24ChainOutline,
    28: vkontakteIcons.Icon28ChainOutline,
    36: vkontakteIcons.Icon36ChainOutline,
    56: vkontakteIcons.Icon56ChainOutline,
  },
  check_circle_fill_green: {
    16: vkontakteIcons.Icon16CheckCircleFillGreen,
    20: vkontakteIcons.Icon20CheckCircleFillGreen,
    24: vkontakteIcons.Icon24CheckCircleFillGreen,
  },
  check_circle_large: {
    16: vkontakteIcons.Icon16CheckCircleLarge,
  },
  check_circle_outline: {
    16: vkontakteIcons.Icon16CheckCircleOutline,
    20: vkontakteIcons.Icon20CheckCircleOutline,
    24: vkontakteIcons.Icon24CheckCircleOutline,
    28: vkontakteIcons.Icon28CheckCircleOutline,
    56: vkontakteIcons.Icon56CheckCircleOutline,
  },
  check_double_outline: {
    16: vkontakteIcons.Icon16CheckDoubleOutline,
  },
  check_outline: {
    16: vkontakteIcons.Icon16CheckOutline,
  },
  check_shield_blue: {
    16: vkontakteIcons.Icon16CheckShieldBlue,
  },
  check_square_outline: {
    16: vkontakteIcons.Icon16CheckSquareOutline,
    20: vkontakteIcons.Icon20CheckSquareOutline,
    24: vkontakteIcons.Icon24CheckSquareOutline,
    28: vkontakteIcons.Icon28CheckSquareOutline,
  },
  chevron_down_circle: {
    16: vkontakteIcons.Icon16ChevronDownCircle,
  },
  chevron_right_circle_outline: {
    16: vkontakteIcons.Icon16ChevronRightCircleOutline,
    28: vkontakteIcons.Icon28ChevronRightCircleOutline,
  },
  chevron_up_circle: {
    16: vkontakteIcons.Icon16ChevronUpCircle,
  },
  circle_dot_slash_outline: {
    16: vkontakteIcons.Icon16CircleDotSlashOutline,
  },
  circle_small_outline: {
    16: vkontakteIcons.Icon16CircleSmallOutline,
    20: vkontakteIcons.Icon20CircleSmallOutline,
    24: vkontakteIcons.Icon24CircleSmallOutline,
  },
  clear: {
    16: vkontakteIcons.Icon16Clear,
    20: vkontakteIcons.Icon20Clear,
  },
  clock_circle_fill: {
    16: vkontakteIcons.Icon16ClockCircleFill,
  },
  cloud: {
    16: vkontakteIcons.Icon16Cloud,
  },
  cloud_lighting: {
    16: vkontakteIcons.Icon16CloudLighting,
  },
  cloud_moon: {
    16: vkontakteIcons.Icon16CloudMoon,
  },
  cloud_moon_lighting: {
    16: vkontakteIcons.Icon16CloudMoonLighting,
  },
  cloud_moon_rain: {
    16: vkontakteIcons.Icon16CloudMoonRain,
  },
  cloud_moon_snow: {
    16: vkontakteIcons.Icon16CloudMoonSnow,
  },
  cloud_rain: {
    16: vkontakteIcons.Icon16CloudRain,
  },
  cloud_rain_snow: {
    16: vkontakteIcons.Icon16CloudRainSnow,
  },
  cloud_sun: {
    16: vkontakteIcons.Icon16CloudSun,
  },
  cloud_sun_lighting: {
    16: vkontakteIcons.Icon16CloudSunLighting,
  },
  cloud_sun_rain: {
    16: vkontakteIcons.Icon16CloudSunRain,
  },
  cloud_sun_snow: {
    16: vkontakteIcons.Icon16CloudSunSnow,
  },
  color_picker_outline: {
    16: vkontakteIcons.Icon16ColorPickerOutline,
    20: vkontakteIcons.Icon20ColorPickerOutline,
    24: vkontakteIcons.Icon24ColorPickerOutline,
  },
  comment: {
    16: vkontakteIcons.Icon16Comment,
    24: vkontakteIcons.Icon24Comment,
  },
  comment_outline: {
    16: vkontakteIcons.Icon16CommentOutline,
    20: vkontakteIcons.Icon20CommentOutline,
    24: vkontakteIcons.Icon24CommentOutline,
    28: vkontakteIcons.Icon28CommentOutline,
    56: vkontakteIcons.Icon56CommentOutline,
  },
  comment_slash: {
    16: vkontakteIcons.Icon16CommentSlash,
  },
  comment_slash_outline: {
    16: vkontakteIcons.Icon16CommentSlashOutline,
    24: vkontakteIcons.Icon24CommentSlashOutline,
    56: vkontakteIcons.Icon56CommentSlashOutline,
  },
  compass: {
    16: vkontakteIcons.Icon16Compass,
    24: vkontakteIcons.Icon24Compass,
    34: vkontakteIcons.Icon34Compass,
    36: vkontakteIcons.Icon36Compass,
    48: vkontakteIcons.Icon48Compass,
  },
  connection: {
    16: vkontakteIcons.Icon16Connection,
    24: vkontakteIcons.Icon24Connection,
  },
  copy_outline: {
    16: vkontakteIcons.Icon16CopyOutline,
    20: vkontakteIcons.Icon20CopyOutline,
    24: vkontakteIcons.Icon24CopyOutline,
    28: vkontakteIcons.Icon28CopyOutline,
  },
  corner_bottom_left_inset_outline: {
    16: vkontakteIcons.Icon16CornerBottomLeftInsetOutline,
  },
  crop: {
    16: vkontakteIcons.Icon16Crop,
    24: vkontakteIcons.Icon24Crop,
    28: vkontakteIcons.Icon28Crop,
    32: vkontakteIcons.Icon32Crop,
  },
  crop_outline: {
    16: vkontakteIcons.Icon16CropOutline,
    20: vkontakteIcons.Icon20CropOutline,
  },
  cross_circle_small: {
    16: vkontakteIcons.Icon16CrossCircleSmall,
  },
  crown_circle_fill_neon_pink: {
    16: vkontakteIcons.Icon16CrownCircleFillNeonPink,
  },
  crown_circle_fill_vk_dating: {
    16: vkontakteIcons.Icon16CrownCircleFillVkDating,
    20: vkontakteIcons.Icon20CrownCircleFillVkDating,
    24: vkontakteIcons.Icon24CrownCircleFillVkDating,
  },
  crown_verified: {
    16: vkontakteIcons.Icon16CrownVerified,
    20: vkontakteIcons.Icon20CrownVerified,
    28: vkontakteIcons.Icon28CrownVerified,
    56: vkontakteIcons.Icon56CrownVerified,
  },
  cube_box_outline: {
    16: vkontakteIcons.Icon16CubeBoxOutline,
    20: vkontakteIcons.Icon20CubeBoxOutline,
    24: vkontakteIcons.Icon24CubeBoxOutline,
    28: vkontakteIcons.Icon28CubeBoxOutline,
  },
  dash: {
    16: vkontakteIcons.Icon16Dash,
  },
  delete_outline: {
    16: vkontakteIcons.Icon16DeleteOutline,
    20: vkontakteIcons.Icon20DeleteOutline,
    24: vkontakteIcons.Icon24DeleteOutline,
    28: vkontakteIcons.Icon28DeleteOutline,
    36: vkontakteIcons.Icon36DeleteOutline,
    56: vkontakteIcons.Icon56DeleteOutline,
  },
  diamond_outline: {
    16: vkontakteIcons.Icon16DiamondOutline,
    20: vkontakteIcons.Icon20DiamondOutline,
    28: vkontakteIcons.Icon28DiamondOutline,
    36: vkontakteIcons.Icon36DiamondOutline,
    56: vkontakteIcons.Icon56DiamondOutline,
  },
  document_outline: {
    16: vkontakteIcons.Icon16DocumentOutline,
    20: vkontakteIcons.Icon20DocumentOutline,
    24: vkontakteIcons.Icon24DocumentOutline,
    28: vkontakteIcons.Icon28DocumentOutline,
    32: vkontakteIcons.Icon32DocumentOutline,
    56: vkontakteIcons.Icon56DocumentOutline,
  },
  dollar_outline: {
    16: vkontakteIcons.Icon16DollarOutline,
    20: vkontakteIcons.Icon20DollarOutline,
    24: vkontakteIcons.Icon24DollarOutline,
    28: vkontakteIcons.Icon28DollarOutline,
  },
  donate_outline: {
    16: vkontakteIcons.Icon16DonateOutline,
    20: vkontakteIcons.Icon20DonateOutline,
    24: vkontakteIcons.Icon24DonateOutline,
    28: vkontakteIcons.Icon28DonateOutline,
    32: vkontakteIcons.Icon32DonateOutline,
    48: vkontakteIcons.Icon48DonateOutline,
    56: vkontakteIcons.Icon56DonateOutline,
  },
  done: {
    16: vkontakteIcons.Icon16Done,
    24: vkontakteIcons.Icon24Done,
    28: vkontakteIcons.Icon28Done,
    36: vkontakteIcons.Icon36Done,
  },
  done_circle: {
    16: vkontakteIcons.Icon16DoneCircle,
    40: vkontakteIcons.Icon40DoneCircle,
  },
  door_enter_arrow_right_outline: {
    16: vkontakteIcons.Icon16DoorEnterArrowRightOutline,
    20: vkontakteIcons.Icon20DoorEnterArrowRightOutline,
  },
  dot_viewfinder: {
    16: vkontakteIcons.Icon16DotViewfinder,
    20: vkontakteIcons.Icon20DotViewfinder,
  },
  dots_vertical_6: {
    16: vkontakteIcons.Icon16DotsVertical6,
  },
  down: {
    16: vkontakteIcons.Icon16Down,
  },
  download_dashed_outline: {
    16: vkontakteIcons.Icon16DownloadDashedOutline,
    24: vkontakteIcons.Icon24DownloadDashedOutline,
  },
  download_outline: {
    16: vkontakteIcons.Icon16DownloadOutline,
    20: vkontakteIcons.Icon20DownloadOutline,
    24: vkontakteIcons.Icon24DownloadOutline,
    28: vkontakteIcons.Icon28DownloadOutline,
    56: vkontakteIcons.Icon56DownloadOutline,
  },
  drop_outline: {
    16: vkontakteIcons.Icon16DropOutline,
  },
  dropdown_flipped: {
    16: vkontakteIcons.Icon16DropdownFlipped,
  },
  dropdown_flipped_outline: {
    16: vkontakteIcons.Icon16DropdownFlippedOutline,
  },
  dropdown_outline: {
    16: vkontakteIcons.Icon16DropdownOutline,
  },
  education_outline: {
    16: vkontakteIcons.Icon16EducationOutline,
    20: vkontakteIcons.Icon20EducationOutline,
    24: vkontakteIcons.Icon24EducationOutline,
    28: vkontakteIcons.Icon28EducationOutline,
  },
  eraser_outline: {
    16: vkontakteIcons.Icon16EraserOutline,
    20: vkontakteIcons.Icon20EraserOutline,
    24: vkontakteIcons.Icon24EraserOutline,
    28: vkontakteIcons.Icon28EraserOutline,
  },
  error_circle_outline: {
    16: vkontakteIcons.Icon16ErrorCircleOutline,
    20: vkontakteIcons.Icon20ErrorCircleOutline,
    24: vkontakteIcons.Icon24ErrorCircleOutline,
    28: vkontakteIcons.Icon28ErrorCircleOutline,
    32: vkontakteIcons.Icon32ErrorCircleOutline,
  },
  euro_outline: {
    16: vkontakteIcons.Icon16EuroOutline,
    20: vkontakteIcons.Icon20EuroOutline,
    24: vkontakteIcons.Icon24EuroOutline,
    28: vkontakteIcons.Icon28EuroOutline,
  },
  exclamation_mark_outline: {
    16: vkontakteIcons.Icon16ExclamationMarkOutline,
    20: vkontakteIcons.Icon20ExclamationMarkOutline,
  },
  favorite_outline: {
    16: vkontakteIcons.Icon16FavoriteOutline,
    20: vkontakteIcons.Icon20FavoriteOutline,
    24: vkontakteIcons.Icon24FavoriteOutline,
    28: vkontakteIcons.Icon28FavoriteOutline,
    36: vkontakteIcons.Icon36FavoriteOutline,
    56: vkontakteIcons.Icon56FavoriteOutline,
  },
  film_strip_outline: {
    16: vkontakteIcons.Icon16FilmStripOutline,
    28: vkontakteIcons.Icon28FilmStripOutline,
    32: vkontakteIcons.Icon32FilmStripOutline,
  },
  fire_small: {
    16: vkontakteIcons.Icon16FireSmall,
  },
  flag_finish: {
    16: vkontakteIcons.Icon16FlagFinish,
    20: vkontakteIcons.Icon20FlagFinish,
    24: vkontakteIcons.Icon24FlagFinish,
  },
  flag_start: {
    16: vkontakteIcons.Icon16FlagStart,
    20: vkontakteIcons.Icon20FlagStart,
    24: vkontakteIcons.Icon24FlagStart,
  },
  fog: {
    16: vkontakteIcons.Icon16Fog,
  },
  fog_moon: {
    16: vkontakteIcons.Icon16FogMoon,
  },
  fog_sun: {
    16: vkontakteIcons.Icon16FogSun,
  },
  folder_outline: {
    16: vkontakteIcons.Icon16FolderOutline,
    20: vkontakteIcons.Icon20FolderOutline,
    24: vkontakteIcons.Icon24FolderOutline,
    28: vkontakteIcons.Icon28FolderOutline,
    56: vkontakteIcons.Icon56FolderOutline,
  },
  forward_10: {
    16: vkontakteIcons.Icon16Forward10,
    24: vkontakteIcons.Icon24Forward10,
    28: vkontakteIcons.Icon28Forward10,
  },
  fullscreen: {
    16: vkontakteIcons.Icon16Fullscreen,
    24: vkontakteIcons.Icon24Fullscreen,
    56: vkontakteIcons.Icon56Fullscreen,
  },
  game: {
    16: vkontakteIcons.Icon16Game,
    24: vkontakteIcons.Icon24Game,
    28: vkontakteIcons.Icon28Game,
    48: vkontakteIcons.Icon48Game,
  },
  gear_outline: {
    16: vkontakteIcons.Icon16GearOutline,
    20: vkontakteIcons.Icon20GearOutline,
    24: vkontakteIcons.Icon24GearOutline,
  },
  gift_outline: {
    16: vkontakteIcons.Icon16GiftOutline,
    20: vkontakteIcons.Icon20GiftOutline,
    24: vkontakteIcons.Icon24GiftOutline,
    28: vkontakteIcons.Icon28GiftOutline,
    32: vkontakteIcons.Icon32GiftOutline,
    36: vkontakteIcons.Icon36GiftOutline,
    44: vkontakteIcons.Icon44GiftOutline,
    56: vkontakteIcons.Icon56GiftOutline,
  },
  globe: {
    16: vkontakteIcons.Icon16Globe,
    24: vkontakteIcons.Icon24Globe,
  },
  globe_outline: {
    16: vkontakteIcons.Icon16GlobeOutline,
    20: vkontakteIcons.Icon20GlobeOutline,
    24: vkontakteIcons.Icon24GlobeOutline,
    28: vkontakteIcons.Icon28GlobeOutline,
    56: vkontakteIcons.Icon56GlobeOutline,
  },
  government_outline: {
    16: vkontakteIcons.Icon16GovernmentOutline,
    20: vkontakteIcons.Icon20GovernmentOutline,
    24: vkontakteIcons.Icon24GovernmentOutline,
    28: vkontakteIcons.Icon28GovernmentOutline,
  },
  grid_of_four: {
    16: vkontakteIcons.Icon16GridOfFour,
  },
  grid_of_three: {
    16: vkontakteIcons.Icon16GridOfThree,
  },
  grid_outline: {
    16: vkontakteIcons.Icon16GridOutline,
  },
  hand_heart_filled: {
    16: vkontakteIcons.Icon16HandHeartFilled,
    24: vkontakteIcons.Icon24HandHeartFilled,
    28: vkontakteIcons.Icon28HandHeartFilled,
  },
  hand_outline: {
    16: vkontakteIcons.Icon16HandOutline,
    20: vkontakteIcons.Icon20HandOutline,
    24: vkontakteIcons.Icon24HandOutline,
  },
  hand_point_up_outline: {
    16: vkontakteIcons.Icon16HandPointUpOutline,
    20: vkontakteIcons.Icon20HandPointUpOutline,
    24: vkontakteIcons.Icon24HandPointUpOutline,
    28: vkontakteIcons.Icon28HandPointUpOutline,
  },
  hashtag: {
    16: vkontakteIcons.Icon16Hashtag,
  },
  headphones_outline: {
    16: vkontakteIcons.Icon16HeadphonesOutline,
    20: vkontakteIcons.Icon20HeadphonesOutline,
    28: vkontakteIcons.Icon28HeadphonesOutline,
    56: vkontakteIcons.Icon56HeadphonesOutline,
  },
  help_outline: {
    16: vkontakteIcons.Icon16HelpOutline,
    20: vkontakteIcons.Icon20HelpOutline,
    24: vkontakteIcons.Icon24HelpOutline,
    28: vkontakteIcons.Icon28HelpOutline,
    36: vkontakteIcons.Icon36HelpOutline,
    56: vkontakteIcons.Icon56HelpOutline,
  },
  hide_outline: {
    16: vkontakteIcons.Icon16HideOutline,
    20: vkontakteIcons.Icon20HideOutline,
    24: vkontakteIcons.Icon24HideOutline,
    28: vkontakteIcons.Icon28HideOutline,
    48: vkontakteIcons.Icon48HideOutline,
    56: vkontakteIcons.Icon56HideOutline,
  },
  history_backward_outline: {
    16: vkontakteIcons.Icon16HistoryBackwardOutline,
    20: vkontakteIcons.Icon20HistoryBackwardOutline,
    24: vkontakteIcons.Icon24HistoryBackwardOutline,
    28: vkontakteIcons.Icon28HistoryBackwardOutline,
  },
  home_arrow_down_outline: {
    16: vkontakteIcons.Icon16HomeArrowDownOutline,
    20: vkontakteIcons.Icon20HomeArrowDownOutline,
    24: vkontakteIcons.Icon24HomeArrowDownOutline,
    28: vkontakteIcons.Icon28HomeArrowDownOutline,
  },
  horse_toy_outline: {
    16: vkontakteIcons.Icon16HorseToyOutline,
    20: vkontakteIcons.Icon20HorseToyOutline,
    24: vkontakteIcons.Icon24HorseToyOutline,
    28: vkontakteIcons.Icon28HorseToyOutline,
  },
  hourglass: {
    16: vkontakteIcons.Icon16Hourglass,
  },
  image_filter: {
    16: vkontakteIcons.Icon16ImageFilter,
    32: vkontakteIcons.Icon32ImageFilter,
  },
  incognito_filled: {
    16: vkontakteIcons.Icon16IncognitoFilled,
  },
  indent_decrease_outline: {
    16: vkontakteIcons.Icon16IndentDecreaseOutline,
    20: vkontakteIcons.Icon20IndentDecreaseOutline,
    24: vkontakteIcons.Icon24IndentDecreaseOutline,
    28: vkontakteIcons.Icon28IndentDecreaseOutline,
  },
  indent_increase_outline: {
    16: vkontakteIcons.Icon16IndentIncreaseOutline,
    20: vkontakteIcons.Icon20IndentIncreaseOutline,
    24: vkontakteIcons.Icon24IndentIncreaseOutline,
    28: vkontakteIcons.Icon28IndentIncreaseOutline,
  },
  info_outline: {
    16: vkontakteIcons.Icon16InfoOutline,
    28: vkontakteIcons.Icon28InfoOutline,
    56: vkontakteIcons.Icon56InfoOutline,
  },
  installment_outline: {
    16: vkontakteIcons.Icon16InstallmentOutline,
  },
  key_outline: {
    16: vkontakteIcons.Icon16KeyOutline,
    20: vkontakteIcons.Icon20KeyOutline,
    24: vkontakteIcons.Icon24KeyOutline,
    28: vkontakteIcons.Icon28KeyOutline,
    56: vkontakteIcons.Icon56KeyOutline,
  },
  line: {
    16: vkontakteIcons.Icon16Line,
  },
  link: {
    16: vkontakteIcons.Icon16Link,
    24: vkontakteIcons.Icon24Link,
  },
  link_outline: {
    16: vkontakteIcons.Icon16LinkOutline,
    28: vkontakteIcons.Icon28LinkOutline,
    36: vkontakteIcons.Icon36LinkOutline,
  },
  linked: {
    16: vkontakteIcons.Icon16Linked,
    24: vkontakteIcons.Icon24Linked,
    48: vkontakteIcons.Icon48Linked,
  },
  list_bullet_outline: {
    16: vkontakteIcons.Icon16ListBulletOutline,
    20: vkontakteIcons.Icon20ListBulletOutline,
    24: vkontakteIcons.Icon24ListBulletOutline,
  },
  list_letter_eng_outline: {
    16: vkontakteIcons.Icon16ListLetterEngOutline,
  },
  list_letter_outline: {
    16: vkontakteIcons.Icon16ListLetterOutline,
    20: vkontakteIcons.Icon20ListLetterOutline,
    24: vkontakteIcons.Icon24ListLetterOutline,
    28: vkontakteIcons.Icon28ListLetterOutline,
  },
  list_number_outline: {
    16: vkontakteIcons.Icon16ListNumberOutline,
    20: vkontakteIcons.Icon20ListNumberOutline,
    24: vkontakteIcons.Icon24ListNumberOutline,
    28: vkontakteIcons.Icon28ListNumberOutline,
  },
  list_plus_outline: {
    16: vkontakteIcons.Icon16ListPlusOutline,
    20: vkontakteIcons.Icon20ListPlusOutline,
  },
  location: {
    16: vkontakteIcons.Icon16Location,
    24: vkontakteIcons.Icon24Location,
  },
  lock_circle_fill_blue: {
    16: vkontakteIcons.Icon16LockCircleFillBlue,
  },
  lock_open: {
    16: vkontakteIcons.Icon16LockOpen,
  },
  lock_outline: {
    16: vkontakteIcons.Icon16LockOutline,
    20: vkontakteIcons.Icon20LockOutline,
    24: vkontakteIcons.Icon24LockOutline,
    28: vkontakteIcons.Icon28LockOutline,
    36: vkontakteIcons.Icon36LockOutline,
    56: vkontakteIcons.Icon56LockOutline,
  },
  logo_android: {
    16: vkontakteIcons.Icon16LogoAndroid,
  },
  logo_apple: {
    16: vkontakteIcons.Icon16LogoApple,
  },
  logo_vk: {
    16: vkontakteIcons.Icon16LogoVk,
    20: vkontakteIcons.Icon20LogoVk,
    24: vkontakteIcons.Icon24LogoVk,
    28: vkontakteIcons.Icon28LogoVk,
    32: vkontakteIcons.Icon32LogoVk,
    36: vkontakteIcons.Icon36LogoVk,
    44: vkontakteIcons.Icon44LogoVk,
    48: vkontakteIcons.Icon48LogoVk,
    56: vkontakteIcons.Icon56LogoVk,
  },
  logo_vk_video: {
    16: vkontakteIcons.Icon16LogoVkVideo,
    20: vkontakteIcons.Icon20LogoVkVideo,
    24: vkontakteIcons.Icon24LogoVkVideo,
    28: vkontakteIcons.Icon28LogoVkVideo,
  },
  mail_outline: {
    16: vkontakteIcons.Icon16MailOutline,
    20: vkontakteIcons.Icon20MailOutline,
    24: vkontakteIcons.Icon24MailOutline,
    28: vkontakteIcons.Icon28MailOutline,
    36: vkontakteIcons.Icon36MailOutline,
    56: vkontakteIcons.Icon56MailOutline,
  },
  mail_stack_outline: {
    16: vkontakteIcons.Icon16MailStackOutline,
    20: vkontakteIcons.Icon20MailStackOutline,
    24: vkontakteIcons.Icon24MailStackOutline,
    28: vkontakteIcons.Icon28MailStackOutline,
  },
  markdown: {
    16: vkontakteIcons.Icon16Markdown,
  },
  market_outline: {
    16: vkontakteIcons.Icon16MarketOutline,
    20: vkontakteIcons.Icon20MarketOutline,
    24: vkontakteIcons.Icon24MarketOutline,
    28: vkontakteIcons.Icon28MarketOutline,
    36: vkontakteIcons.Icon36MarketOutline,
    56: vkontakteIcons.Icon56MarketOutline,
  },
  menu_outline: {
    16: vkontakteIcons.Icon16MenuOutline,
    20: vkontakteIcons.Icon20MenuOutline,
    24: vkontakteIcons.Icon24MenuOutline,
    28: vkontakteIcons.Icon28MenuOutline,
  },
  message_forward_outline: {
    16: vkontakteIcons.Icon16MessageForwardOutline,
    24: vkontakteIcons.Icon24MessageForwardOutline,
  },
  messages_circle_fill_green: {
    16: vkontakteIcons.Icon16MessagesCircleFillGreen,
  },
  microphone: {
    16: vkontakteIcons.Icon16Microphone,
    32: vkontakteIcons.Icon32Microphone,
  },
  microphone_slash: {
    16: vkontakteIcons.Icon16MicrophoneSlash,
    24: vkontakteIcons.Icon24MicrophoneSlash,
    28: vkontakteIcons.Icon28MicrophoneSlash,
  },
  minus: {
    16: vkontakteIcons.Icon16Minus,
  },
  minus_circle: {
    16: vkontakteIcons.Icon16MinusCircle,
  },
  minus_circle_outline: {
    16: vkontakteIcons.Icon16MinusCircleOutline,
  },
  money_circle_outline: {
    16: vkontakteIcons.Icon16MoneyCircleOutline,
    20: vkontakteIcons.Icon20MoneyCircleOutline,
    24: vkontakteIcons.Icon24MoneyCircleOutline,
    28: vkontakteIcons.Icon28MoneyCircleOutline,
    36: vkontakteIcons.Icon36MoneyCircleOutline,
  },
  more_horizontal: {
    16: vkontakteIcons.Icon16MoreHorizontal,
    20: vkontakteIcons.Icon20MoreHorizontal,
    24: vkontakteIcons.Icon24MoreHorizontal,
    28: vkontakteIcons.Icon28MoreHorizontal,
  },
  more_vertical: {
    16: vkontakteIcons.Icon16MoreVertical,
    20: vkontakteIcons.Icon20MoreVertical,
    24: vkontakteIcons.Icon24MoreVertical,
    28: vkontakteIcons.Icon28MoreVertical,
  },
  music_mic_outline: {
    16: vkontakteIcons.Icon16MusicMicOutline,
    20: vkontakteIcons.Icon20MusicMicOutline,
    24: vkontakteIcons.Icon24MusicMicOutline,
    28: vkontakteIcons.Icon28MusicMicOutline,
    36: vkontakteIcons.Icon36MusicMicOutline,
    56: vkontakteIcons.Icon56MusicMicOutline,
  },
  music_outline: {
    16: vkontakteIcons.Icon16MusicOutline,
    20: vkontakteIcons.Icon20MusicOutline,
    24: vkontakteIcons.Icon24MusicOutline,
    28: vkontakteIcons.Icon28MusicOutline,
    32: vkontakteIcons.Icon32MusicOutline,
    36: vkontakteIcons.Icon36MusicOutline,
    44: vkontakteIcons.Icon44MusicOutline,
    56: vkontakteIcons.Icon56MusicOutline,
  },
  mute_cross: {
    16: vkontakteIcons.Icon16MuteCross,
    24: vkontakteIcons.Icon24MuteCross,
  },
  muted: {
    16: vkontakteIcons.Icon16Muted,
  },
  neutral_face_outline: {
    16: vkontakteIcons.Icon16NeutralFaceOutline,
    28: vkontakteIcons.Icon28NeutralFaceOutline,
  },
  new: {
    16: vkontakteIcons.Icon16New,
  },
  newsfeed_outline: {
    16: vkontakteIcons.Icon16NewsfeedOutline,
    20: vkontakteIcons.Icon20NewsfeedOutline,
    24: vkontakteIcons.Icon24NewsfeedOutline,
    28: vkontakteIcons.Icon28NewsfeedOutline,
    48: vkontakteIcons.Icon48NewsfeedOutline,
    56: vkontakteIcons.Icon56NewsfeedOutline,
  },
  nft_heptagon_outline: {
    16: vkontakteIcons.Icon16NftHeptagonOutline,
    20: vkontakteIcons.Icon20NftHeptagonOutline,
    24: vkontakteIcons.Icon24NftHeptagonOutline,
    28: vkontakteIcons.Icon28NftHeptagonOutline,
    36: vkontakteIcons.Icon36NftHeptagonOutline,
    56: vkontakteIcons.Icon56NftHeptagonOutline,
  },
  notification: {
    16: vkontakteIcons.Icon16Notification,
    24: vkontakteIcons.Icon24Notification,
    28: vkontakteIcons.Icon28Notification,
  },
  notification_slash: {
    16: vkontakteIcons.Icon16NotificationSlash,
  },
  notification_waves: {
    16: vkontakteIcons.Icon16NotificationWaves,
    20: vkontakteIcons.Icon20NotificationWaves,
    24: vkontakteIcons.Icon24NotificationWaves,
    28: vkontakteIcons.Icon28NotificationWaves,
  },
  palette_outline: {
    16: vkontakteIcons.Icon16PaletteOutline,
    24: vkontakteIcons.Icon24PaletteOutline,
    28: vkontakteIcons.Icon28PaletteOutline,
    56: vkontakteIcons.Icon56PaletteOutline,
  },
  pause_circle: {
    16: vkontakteIcons.Icon16PauseCircle,
    20: vkontakteIcons.Icon20PauseCircle,
    24: vkontakteIcons.Icon24PauseCircle,
    28: vkontakteIcons.Icon28PauseCircle,
    32: vkontakteIcons.Icon32PauseCircle,
    40: vkontakteIcons.Icon40PauseCircle,
  },
  pen: {
    16: vkontakteIcons.Icon16Pen,
  },
  pen_outline: {
    16: vkontakteIcons.Icon16PenOutline,
    24: vkontakteIcons.Icon24PenOutline,
  },
  phone_circle: {
    16: vkontakteIcons.Icon16PhoneCircle,
    40: vkontakteIcons.Icon40PhoneCircle,
  },
  phone_outgoing: {
    16: vkontakteIcons.Icon16PhoneOutgoing,
  },
  phone_outline: {
    16: vkontakteIcons.Icon16PhoneOutline,
    20: vkontakteIcons.Icon20PhoneOutline,
    24: vkontakteIcons.Icon24PhoneOutline,
    28: vkontakteIcons.Icon28PhoneOutline,
    36: vkontakteIcons.Icon36PhoneOutline,
    56: vkontakteIcons.Icon56PhoneOutline,
  },
  pin_dot: {
    16: vkontakteIcons.Icon16PinDot,
  },
  pin_outline: {
    16: vkontakteIcons.Icon16PinOutline,
    20: vkontakteIcons.Icon20PinOutline,
    24: vkontakteIcons.Icon24PinOutline,
    28: vkontakteIcons.Icon28PinOutline,
    56: vkontakteIcons.Icon56PinOutline,
  },
  place_outline: {
    16: vkontakteIcons.Icon16PlaceOutline,
    20: vkontakteIcons.Icon20PlaceOutline,
    24: vkontakteIcons.Icon24PlaceOutline,
    28: vkontakteIcons.Icon28PlaceOutline,
    32: vkontakteIcons.Icon32PlaceOutline,
    36: vkontakteIcons.Icon36PlaceOutline,
    56: vkontakteIcons.Icon56PlaceOutline,
  },
  plane_outline: {
    16: vkontakteIcons.Icon16PlaneOutline,
    20: vkontakteIcons.Icon20PlaneOutline,
    24: vkontakteIcons.Icon24PlaneOutline,
    28: vkontakteIcons.Icon28PlaneOutline,
  },
  play_circle_fill_azure: {
    16: vkontakteIcons.Icon16PlayCircleFillAzure,
    28: vkontakteIcons.Icon28PlayCircleFillAzure,
  },
  play_circle_fill_pink: {
    16: vkontakteIcons.Icon16PlayCircleFillPink,
  },
  pop_up_sticker_circle_fill_raspberry_pink: {
    16: vkontakteIcons.Icon16PopUpStickerCircleFillRaspberryPink,
    24: vkontakteIcons.Icon24PopUpStickerCircleFillRaspberryPink,
    28: vkontakteIcons.Icon28PopUpStickerCircleFillRaspberryPink,
  },
  pop_up_sticker_outline: {
    16: vkontakteIcons.Icon16PopUpStickerOutline,
    20: vkontakteIcons.Icon20PopUpStickerOutline,
    28: vkontakteIcons.Icon28PopUpStickerOutline,
  },
  qr_code: {
    16: vkontakteIcons.Icon16QrCode,
  },
  recent: {
    16: vkontakteIcons.Icon16Recent,
    24: vkontakteIcons.Icon24Recent,
  },
  recording_circle_fill: {
    16: vkontakteIcons.Icon16RecordingCircleFill,
    20: vkontakteIcons.Icon20RecordingCircleFill,
  },
  rectangle_line: {
    16: vkontakteIcons.Icon16RectangleLine,
    20: vkontakteIcons.Icon20RectangleLine,
    24: vkontakteIcons.Icon24RectangleLine,
    28: vkontakteIcons.Icon28RectangleLine,
  },
  replay_10: {
    16: vkontakteIcons.Icon16Replay10,
    24: vkontakteIcons.Icon24Replay10,
    28: vkontakteIcons.Icon28Replay10,
  },
  replay: {
    16: vkontakteIcons.Icon16Replay,
    24: vkontakteIcons.Icon24Replay,
    28: vkontakteIcons.Icon28Replay,
    36: vkontakteIcons.Icon36Replay,
    48: vkontakteIcons.Icon48Replay,
  },
  reply_outline: {
    16: vkontakteIcons.Icon16ReplyOutline,
    20: vkontakteIcons.Icon20ReplyOutline,
    24: vkontakteIcons.Icon24ReplyOutline,
    28: vkontakteIcons.Icon28ReplyOutline,
  },
  report_outline: {
    16: vkontakteIcons.Icon16ReportOutline,
    20: vkontakteIcons.Icon20ReportOutline,
    24: vkontakteIcons.Icon24ReportOutline,
    28: vkontakteIcons.Icon28ReportOutline,
    56: vkontakteIcons.Icon56ReportOutline,
  },
  repost_circle_fill_red: {
    16: vkontakteIcons.Icon16RepostCircleFillRed,
  },
  repost_outline: {
    16: vkontakteIcons.Icon16RepostOutline,
  },
  rouble_arrow_backward_outline: {
    16: vkontakteIcons.Icon16RoubleArrowBackwardOutline,
  },
  rouble_circle_fill_blue: {
    16: vkontakteIcons.Icon16RoubleCircleFillBlue,
    20: vkontakteIcons.Icon20RoubleCircleFillBlue,
    28: vkontakteIcons.Icon28RoubleCircleFillBlue,
  },
  rouble_outline: {
    16: vkontakteIcons.Icon16RoubleOutline,
    20: vkontakteIcons.Icon20RoubleOutline,
  },
  sad_face_outline: {
    16: vkontakteIcons.Icon16SadFaceOutline,
    24: vkontakteIcons.Icon24SadFaceOutline,
    28: vkontakteIcons.Icon28SadFaceOutline,
  },
  search: {
    16: vkontakteIcons.Icon16Search,
    20: vkontakteIcons.Icon20Search,
    24: vkontakteIcons.Icon24Search,
    28: vkontakteIcons.Icon28Search,
  },
  search_outline: {
    16: vkontakteIcons.Icon16SearchOutline,
    24: vkontakteIcons.Icon24SearchOutline,
    28: vkontakteIcons.Icon28SearchOutline,
    32: vkontakteIcons.Icon32SearchOutline,
    56: vkontakteIcons.Icon56SearchOutline,
  },
  search_stars_outline: {
    16: vkontakteIcons.Icon16SearchStarsOutline,
    24: vkontakteIcons.Icon24SearchStarsOutline,
    28: vkontakteIcons.Icon28SearchStarsOutline,
  },
  services_outline: {
    16: vkontakteIcons.Icon16ServicesOutline,
    20: vkontakteIcons.Icon20ServicesOutline,
    24: vkontakteIcons.Icon24ServicesOutline,
    28: vkontakteIcons.Icon28ServicesOutline,
    36: vkontakteIcons.Icon36ServicesOutline,
    56: vkontakteIcons.Icon56ServicesOutline,
  },
  share: {
    16: vkontakteIcons.Icon16Share,
    24: vkontakteIcons.Icon24Share,
  },
  share_outline: {
    16: vkontakteIcons.Icon16ShareOutline,
    20: vkontakteIcons.Icon20ShareOutline,
    24: vkontakteIcons.Icon24ShareOutline,
    28: vkontakteIcons.Icon28ShareOutline,
    56: vkontakteIcons.Icon56ShareOutline,
  },
  shopping_cart_outline: {
    16: vkontakteIcons.Icon16ShoppingCartOutline,
    20: vkontakteIcons.Icon20ShoppingCartOutline,
    24: vkontakteIcons.Icon24ShoppingCartOutline,
    28: vkontakteIcons.Icon28ShoppingCartOutline,
  },
  shuffle_outline: {
    16: vkontakteIcons.Icon16ShuffleOutline,
    20: vkontakteIcons.Icon20ShuffleOutline,
    24: vkontakteIcons.Icon24ShuffleOutline,
    28: vkontakteIcons.Icon28ShuffleOutline,
    56: vkontakteIcons.Icon56ShuffleOutline,
  },
  skip_forward: {
    16: vkontakteIcons.Icon16SkipForward,
    20: vkontakteIcons.Icon20SkipForward,
    24: vkontakteIcons.Icon24SkipForward,
    28: vkontakteIcons.Icon28SkipForward,
    36: vkontakteIcons.Icon36SkipForward,
    48: vkontakteIcons.Icon48SkipForward,
  },
  sliders_outline: {
    16: vkontakteIcons.Icon16SlidersOutline,
    20: vkontakteIcons.Icon20SlidersOutline,
    28: vkontakteIcons.Icon28SlidersOutline,
    56: vkontakteIcons.Icon56SlidersOutline,
  },
  smile: {
    16: vkontakteIcons.Icon16Smile,
    24: vkontakteIcons.Icon24Smile,
    28: vkontakteIcons.Icon28Smile,
  },
  smile_add_outline: {
    16: vkontakteIcons.Icon16SmileAddOutline,
    20: vkontakteIcons.Icon20SmileAddOutline,
    24: vkontakteIcons.Icon24SmileAddOutline,
    28: vkontakteIcons.Icon28SmileAddOutline,
  },
  snowflake: {
    16: vkontakteIcons.Icon16Snowflake,
  },
  sort_horizontal_outline: {
    16: vkontakteIcons.Icon16SortHorizontalOutline,
    24: vkontakteIcons.Icon24SortHorizontalOutline,
    28: vkontakteIcons.Icon28SortHorizontalOutline,
  },
  sort_outline: {
    16: vkontakteIcons.Icon16SortOutline,
    20: vkontakteIcons.Icon20SortOutline,
    24: vkontakteIcons.Icon24SortOutline,
    28: vkontakteIcons.Icon28SortOutline,
  },
  sound_wave_slash_outline: {
    16: vkontakteIcons.Icon16SoundWaveSlashOutline,
    28: vkontakteIcons.Icon28SoundWaveSlashOutline,
  },
  sparkle: {
    16: vkontakteIcons.Icon16Sparkle,
    24: vkontakteIcons.Icon24Sparkle,
    28: vkontakteIcons.Icon28Sparkle,
  },
  square: {
    16: vkontakteIcons.Icon16Square,
  },
  square_4_outline: {
    16: vkontakteIcons.Icon16Square4Outline,
    20: vkontakteIcons.Icon20Square4Outline,
    24: vkontakteIcons.Icon24Square4Outline,
    28: vkontakteIcons.Icon28Square4Outline,
    32: vkontakteIcons.Icon32Square4Outline,
  },
  star_alt: {
    16: vkontakteIcons.Icon16StarAlt,
  },
  star_circle_fill_blue: {
    16: vkontakteIcons.Icon16StarCircleFillBlue,
    20: vkontakteIcons.Icon20StarCircleFillBlue,
    28: vkontakteIcons.Icon28StarCircleFillBlue,
  },
  star_circle_fill_gray: {
    16: vkontakteIcons.Icon16StarCircleFillGray,
    20: vkontakteIcons.Icon20StarCircleFillGray,
  },
  storefront_outline: {
    16: vkontakteIcons.Icon16StorefrontOutline,
    20: vkontakteIcons.Icon20StorefrontOutline,
    24: vkontakteIcons.Icon24StorefrontOutline,
    28: vkontakteIcons.Icon28StorefrontOutline,
  },
  story_outline: {
    16: vkontakteIcons.Icon16StoryOutline,
    20: vkontakteIcons.Icon20StoryOutline,
    24: vkontakteIcons.Icon24StoryOutline,
    28: vkontakteIcons.Icon28StoryOutline,
    32: vkontakteIcons.Icon32StoryOutline,
    36: vkontakteIcons.Icon36StoryOutline,
    56: vkontakteIcons.Icon56StoryOutline,
  },
  subscriptions_outline: {
    16: vkontakteIcons.Icon16SubscriptionsOutline,
    20: vkontakteIcons.Icon20SubscriptionsOutline,
    24: vkontakteIcons.Icon24SubscriptionsOutline,
    28: vkontakteIcons.Icon28SubscriptionsOutline,
  },
  subtitles_slash: {
    16: vkontakteIcons.Icon16SubtitlesSlash,
    24: vkontakteIcons.Icon24SubtitlesSlash,
    48: vkontakteIcons.Icon48SubtitlesSlash,
  },
  sun: {
    16: vkontakteIcons.Icon16Sun,
  },
  sync: {
    16: vkontakteIcons.Icon16Sync,
    20: vkontakteIcons.Icon20Sync,
  },
  sync_circle_fill_black: {
    16: vkontakteIcons.Icon16SyncCircleFillBlack,
  },
  table_outline: {
    16: vkontakteIcons.Icon16TableOutline,
  },
  tear_off_flyer: {
    16: vkontakteIcons.Icon16TearOffFlyer,
  },
  tear_off_flyer_outline: {
    16: vkontakteIcons.Icon16TearOffFlyerOutline,
    20: vkontakteIcons.Icon20TearOffFlyerOutline,
    24: vkontakteIcons.Icon24TearOffFlyerOutline,
    28: vkontakteIcons.Icon28TearOffFlyerOutline,
    32: vkontakteIcons.Icon32TearOffFlyerOutline,
    36: vkontakteIcons.Icon36TearOffFlyerOutline,
    56: vkontakteIcons.Icon56TearOffFlyerOutline,
  },
  text: {
    16: vkontakteIcons.Icon16Text,
  },
  text_bold_eng_outline: {
    16: vkontakteIcons.Icon16TextBoldEngOutline,
  },
  text_bold_outline: {
    16: vkontakteIcons.Icon16TextBoldOutline,
    20: vkontakteIcons.Icon20TextBoldOutline,
    24: vkontakteIcons.Icon24TextBoldOutline,
    28: vkontakteIcons.Icon28TextBoldOutline,
  },
  text_center_outline: {
    16: vkontakteIcons.Icon16TextCenterOutline,
    20: vkontakteIcons.Icon20TextCenterOutline,
    28: vkontakteIcons.Icon28TextCenterOutline,
  },
  text_italic_eng_outline: {
    16: vkontakteIcons.Icon16TextItalicEngOutline,
  },
  text_italic_outline: {
    16: vkontakteIcons.Icon16TextItalicOutline,
    20: vkontakteIcons.Icon20TextItalicOutline,
    24: vkontakteIcons.Icon24TextItalicOutline,
    28: vkontakteIcons.Icon28TextItalicOutline,
  },
  text_outline: {
    16: vkontakteIcons.Icon16TextOutline,
    20: vkontakteIcons.Icon20TextOutline,
    24: vkontakteIcons.Icon24TextOutline,
    28: vkontakteIcons.Icon28TextOutline,
    48: vkontakteIcons.Icon48TextOutline,
  },
  text_right_outline: {
    16: vkontakteIcons.Icon16TextRightOutline,
    20: vkontakteIcons.Icon20TextRightOutline,
    28: vkontakteIcons.Icon28TextRightOutline,
  },
  text_strikethrough_outline: {
    16: vkontakteIcons.Icon16TextStrikethroughOutline,
    20: vkontakteIcons.Icon20TextStrikethroughOutline,
    24: vkontakteIcons.Icon24TextStrikethroughOutline,
    28: vkontakteIcons.Icon28TextStrikethroughOutline,
  },
  text_underline_eng_outline: {
    16: vkontakteIcons.Icon16TextUnderlineEngOutline,
  },
  text_underline_outline: {
    16: vkontakteIcons.Icon16TextUnderlineOutline,
    20: vkontakteIcons.Icon20TextUnderlineOutline,
    24: vkontakteIcons.Icon24TextUnderlineOutline,
    28: vkontakteIcons.Icon28TextUnderlineOutline,
  },
  text_viewfinder_outline: {
    16: vkontakteIcons.Icon16TextViewfinderOutline,
    20: vkontakteIcons.Icon20TextViewfinderOutline,
    24: vkontakteIcons.Icon24TextViewfinderOutline,
    28: vkontakteIcons.Icon28TextViewfinderOutline,
  },
  thumbs_down_outline: {
    16: vkontakteIcons.Icon16ThumbsDownOutline,
    20: vkontakteIcons.Icon20ThumbsDownOutline,
    24: vkontakteIcons.Icon24ThumbsDownOutline,
    28: vkontakteIcons.Icon28ThumbsDownOutline,
    56: vkontakteIcons.Icon56ThumbsDownOutline,
  },
  thumbs_up_outline: {
    16: vkontakteIcons.Icon16ThumbsUpOutline,
    20: vkontakteIcons.Icon20ThumbsUpOutline,
    24: vkontakteIcons.Icon24ThumbsUpOutline,
    28: vkontakteIcons.Icon28ThumbsUpOutline,
    56: vkontakteIcons.Icon56ThumbsUpOutline,
  },
  ticket_outline: {
    16: vkontakteIcons.Icon16TicketOutline,
    20: vkontakteIcons.Icon20TicketOutline,
    24: vkontakteIcons.Icon24TicketOutline,
    28: vkontakteIcons.Icon28TicketOutline,
    32: vkontakteIcons.Icon32TicketOutline,
    56: vkontakteIcons.Icon56TicketOutline,
  },
  truck_outline: {
    16: vkontakteIcons.Icon16TruckOutline,
    20: vkontakteIcons.Icon20TruckOutline,
    28: vkontakteIcons.Icon28TruckOutline,
  },
  unavailable_call_circle_fill_red: {
    16: vkontakteIcons.Icon16UnavailableCallCircleFillRed,
  },
  unfavorite: {
    16: vkontakteIcons.Icon16Unfavorite,
  },
  unfavorite_outline: {
    16: vkontakteIcons.Icon16UnfavoriteOutline,
    20: vkontakteIcons.Icon20UnfavoriteOutline,
    24: vkontakteIcons.Icon24UnfavoriteOutline,
    28: vkontakteIcons.Icon28UnfavoriteOutline,
  },
  unlock_outline: {
    16: vkontakteIcons.Icon16UnlockOutline,
    20: vkontakteIcons.Icon20UnlockOutline,
  },
  up: {
    16: vkontakteIcons.Icon16Up,
    24: vkontakteIcons.Icon24Up,
  },
  upload_outline: {
    16: vkontakteIcons.Icon16UploadOutline,
    20: vkontakteIcons.Icon20UploadOutline,
    24: vkontakteIcons.Icon24UploadOutline,
    28: vkontakteIcons.Icon28UploadOutline,
  },
  user_add: {
    16: vkontakteIcons.Icon16UserAdd,
    24: vkontakteIcons.Icon24UserAdd,
  },
  user_check: {
    16: vkontakteIcons.Icon16UserCheck,
  },
  user_check_outline: {
    16: vkontakteIcons.Icon16UserCheckOutline,
    20: vkontakteIcons.Icon20UserCheckOutline,
  },
  user_circle_alt_outline: {
    16: vkontakteIcons.Icon16UserCircleAltOutline,
  },
  user_outline: {
    16: vkontakteIcons.Icon16UserOutline,
    20: vkontakteIcons.Icon20UserOutline,
    24: vkontakteIcons.Icon24UserOutline,
    28: vkontakteIcons.Icon28UserOutline,
    36: vkontakteIcons.Icon36UserOutline,
  },
  user_square_outline: {
    16: vkontakteIcons.Icon16UserSquareOutline,
    20: vkontakteIcons.Icon20UserSquareOutline,
    24: vkontakteIcons.Icon24UserSquareOutline,
    28: vkontakteIcons.Icon28UserSquareOutline,
    56: vkontakteIcons.Icon56UserSquareOutline,
  },
  users_2_outline: {
    16: vkontakteIcons.Icon16Users2Outline,
  },
  verified_centered: {
    16: vkontakteIcons.Icon16VerifiedCentered,
    28: vkontakteIcons.Icon28VerifiedCentered,
  },
  video_advertisement: {
    16: vkontakteIcons.Icon16VideoAdvertisement,
    24: vkontakteIcons.Icon24VideoAdvertisement,
  },
  videocam: {
    16: vkontakteIcons.Icon16Videocam,
    20: vkontakteIcons.Icon20Videocam,
    24: vkontakteIcons.Icon24Videocam,
    28: vkontakteIcons.Icon28Videocam,
    36: vkontakteIcons.Icon36Videocam,
  },
  videocam_outline: {
    16: vkontakteIcons.Icon16VideocamOutline,
    20: vkontakteIcons.Icon20VideocamOutline,
    24: vkontakteIcons.Icon24VideocamOutline,
    28: vkontakteIcons.Icon28VideocamOutline,
    56: vkontakteIcons.Icon56VideocamOutline,
  },
  view_outline: {
    16: vkontakteIcons.Icon16ViewOutline,
    20: vkontakteIcons.Icon20ViewOutline,
    24: vkontakteIcons.Icon24ViewOutline,
    28: vkontakteIcons.Icon28ViewOutline,
    56: vkontakteIcons.Icon56ViewOutline,
  },
  vmoji_outline: {
    16: vkontakteIcons.Icon16VmojiOutline,
    20: vkontakteIcons.Icon20VmojiOutline,
  },
  volume: {
    16: vkontakteIcons.Icon16Volume,
    20: vkontakteIcons.Icon20Volume,
    24: vkontakteIcons.Icon24Volume,
    48: vkontakteIcons.Icon48Volume,
  },
  wallet_outline: {
    16: vkontakteIcons.Icon16WalletOutline,
    20: vkontakteIcons.Icon20WalletOutline,
    24: vkontakteIcons.Icon24WalletOutline,
    28: vkontakteIcons.Icon28WalletOutline,
    56: vkontakteIcons.Icon56WalletOutline,
  },
  warning_triangle: {
    16: vkontakteIcons.Icon16WarningTriangle,
  },
  warning_triangle_outline: {
    16: vkontakteIcons.Icon16WarningTriangleOutline,
    20: vkontakteIcons.Icon20WarningTriangleOutline,
    24: vkontakteIcons.Icon24WarningTriangleOutline,
    28: vkontakteIcons.Icon28WarningTriangleOutline,
  },
  wifi_outline: {
    16: vkontakteIcons.Icon16WifiOutline,
    56: vkontakteIcons.Icon56WifiOutline,
  },
  wifi_slash_outline: {
    16: vkontakteIcons.Icon16WifiSlashOutline,
  },
  wind: {
    16: vkontakteIcons.Icon16Wind,
  },
  wind_rain: {
    16: vkontakteIcons.Icon16WindRain,
  },
  wind_rain_snow: {
    16: vkontakteIcons.Icon16WindRainSnow,
  },
  wind_snow: {
    16: vkontakteIcons.Icon16WindSnow,
  },
  work_outline: {
    16: vkontakteIcons.Icon16WorkOutline,
    20: vkontakteIcons.Icon20WorkOutline,
    24: vkontakteIcons.Icon24WorkOutline,
    28: vkontakteIcons.Icon28WorkOutline,
  },
  wrench_outline: {
    16: vkontakteIcons.Icon16WrenchOutline,
    20: vkontakteIcons.Icon20WrenchOutline,
    28: vkontakteIcons.Icon28WrenchOutline,
    56: vkontakteIcons.Icon56WrenchOutline,
  },
  '1_circle_fill_gold': {
    20: vkontakteIcons.Icon201CircleFillGold,
  },
  '2_circle_fill_silver': {
    20: vkontakteIcons.Icon202CircleFillSilver,
  },
  '3_circle_fill_bronze': {
    20: vkontakteIcons.Icon203CircleFillBronze,
  },
  '3_square': {
    20: vkontakteIcons.Icon203Square,
  },
  '4_square': {
    20: vkontakteIcons.Icon204Square,
  },
  accessibility_outline: {
    20: vkontakteIcons.Icon20AccessibilityOutline,
    24: vkontakteIcons.Icon24AccessibilityOutline,
    28: vkontakteIcons.Icon28AccessibilityOutline,
    56: vkontakteIcons.Icon56AccessibilityOutline,
  },
  add_alt: {
    20: vkontakteIcons.Icon20AddAlt,
  },
  add_circle_fill: {
    20: vkontakteIcons.Icon20AddCircleFill,
    36: vkontakteIcons.Icon36AddCircleFill,
  },
  add_circle_fill_gray: {
    20: vkontakteIcons.Icon20AddCircleFillGray,
  },
  add_circle_fill_green: {
    20: vkontakteIcons.Icon20AddCircleFillGreen,
  },
  advertising_check_outline: {
    20: vkontakteIcons.Icon20AdvertisingCheckOutline,
    24: vkontakteIcons.Icon24AdvertisingCheckOutline,
  },
  advertising_circle_fill_red: {
    20: vkontakteIcons.Icon20AdvertisingCircleFillRed,
    28: vkontakteIcons.Icon28AdvertisingCircleFillRed,
  },
  advertising_outline: {
    20: vkontakteIcons.Icon20AdvertisingOutline,
    24: vkontakteIcons.Icon24AdvertisingOutline,
    28: vkontakteIcons.Icon28AdvertisingOutline,
    32: vkontakteIcons.Icon32AdvertisingOutline,
    36: vkontakteIcons.Icon36AdvertisingOutline,
    56: vkontakteIcons.Icon56AdvertisingOutline,
  },
  api_outline: {
    20: vkontakteIcons.Icon20ApiOutline,
  },
  app_badge_outline: {
    20: vkontakteIcons.Icon20AppBadgeOutline,
    24: vkontakteIcons.Icon24AppBadgeOutline,
    28: vkontakteIcons.Icon28AppBadgeOutline,
  },
  apple_outline: {
    20: vkontakteIcons.Icon20AppleOutline,
    24: vkontakteIcons.Icon24AppleOutline,
    28: vkontakteIcons.Icon28AppleOutline,
  },
  apple_watch_outline: {
    20: vkontakteIcons.Icon20AppleWatchOutline,
    28: vkontakteIcons.Icon28AppleWatchOutline,
  },
  archive_arrow_down_outline: {
    20: vkontakteIcons.Icon20ArchiveArrowDownOutline,
  },
  armchair_outline: {
    20: vkontakteIcons.Icon20ArmchairOutline,
    24: vkontakteIcons.Icon24ArmchairOutline,
    28: vkontakteIcons.Icon28ArmchairOutline,
  },
  arrow_2_squarepath_outline: {
    20: vkontakteIcons.Icon20Arrow2SquarepathOutline,
    24: vkontakteIcons.Icon24Arrow2SquarepathOutline,
  },
  arrow_left_right_corners_outline: {
    20: vkontakteIcons.Icon20ArrowLeftRightCornersOutline,
    24: vkontakteIcons.Icon24ArrowLeftRightCornersOutline,
  },
  arrow_right_left_corners_outline: {
    20: vkontakteIcons.Icon20ArrowRightLeftCornersOutline,
    24: vkontakteIcons.Icon24ArrowRightLeftCornersOutline,
  },
  arrow_right_square_outline: {
    20: vkontakteIcons.Icon20ArrowRightSquareOutline,
    24: vkontakteIcons.Icon24ArrowRightSquareOutline,
    28: vkontakteIcons.Icon28ArrowRightSquareOutline,
  },
  arrow_turn_right_outline: {
    20: vkontakteIcons.Icon20ArrowTurnRightOutline,
  },
  arrow_up_rectangle_outline: {
    20: vkontakteIcons.Icon20ArrowUpRectangleOutline,
    24: vkontakteIcons.Icon24ArrowUpRectangleOutline,
    28: vkontakteIcons.Icon28ArrowUpRectangleOutline,
    56: vkontakteIcons.Icon56ArrowUpRectangleOutline,
  },
  arrow_up_rectangle_slash_outline: {
    20: vkontakteIcons.Icon20ArrowUpRectangleSlashOutline,
    28: vkontakteIcons.Icon28ArrowUpRectangleSlashOutline,
  },
  arrow_uturn_right_outline: {
    20: vkontakteIcons.Icon20ArrowUturnRightOutline,
    24: vkontakteIcons.Icon24ArrowUturnRightOutline,
    28: vkontakteIcons.Icon28ArrowUturnRightOutline,
    36: vkontakteIcons.Icon36ArrowUturnRightOutline,
  },
  arrows_2_left_right_inward: {
    20: vkontakteIcons.Icon20Arrows2LeftRightInward,
  },
  arrows_2_left_right_outward: {
    20: vkontakteIcons.Icon20Arrows2LeftRightOutward,
  },
  arrowshape_left_2_outline: {
    20: vkontakteIcons.Icon20ArrowshapeLeft2Outline,
    24: vkontakteIcons.Icon24ArrowshapeLeft2Outline,
  },
  arrowshape_up_right_outline: {
    20: vkontakteIcons.Icon20ArrowshapeUpRightOutline,
  },
  article_box_simple_outline: {
    20: vkontakteIcons.Icon20ArticleBoxSimpleOutline,
  },
  auction_circle_fill_purple: {
    20: vkontakteIcons.Icon20AuctionCircleFillPurple,
  },
  audiobook_outline: {
    20: vkontakteIcons.Icon20AudiobookOutline,
    24: vkontakteIcons.Icon24AudiobookOutline,
    28: vkontakteIcons.Icon28AudiobookOutline,
  },
  award_add_outline: {
    20: vkontakteIcons.Icon20AwardAddOutline,
  },
  baby_bottle_outline: {
    20: vkontakteIcons.Icon20BabyBottleOutline,
    24: vkontakteIcons.Icon24BabyBottleOutline,
    28: vkontakteIcons.Icon28BabyBottleOutline,
  },
  ball_number_2_outline: {
    20: vkontakteIcons.Icon20BallNumber2Outline,
    28: vkontakteIcons.Icon28BallNumber2Outline,
  },
  basketball_outline: {
    20: vkontakteIcons.Icon20BasketballOutline,
  },
  beauty_outline: {
    20: vkontakteIcons.Icon20BeautyOutline,
    24: vkontakteIcons.Icon24BeautyOutline,
    28: vkontakteIcons.Icon28BeautyOutline,
  },
  block_outline: {
    20: vkontakteIcons.Icon20BlockOutline,
    24: vkontakteIcons.Icon24BlockOutline,
    28: vkontakteIcons.Icon28BlockOutline,
    48: vkontakteIcons.Icon48BlockOutline,
    56: vkontakteIcons.Icon56BlockOutline,
  },
  body_outline: {
    20: vkontakteIcons.Icon20BodyOutline,
    28: vkontakteIcons.Icon28BodyOutline,
  },
  bomb_outline: {
    20: vkontakteIcons.Icon20BombOutline,
    24: vkontakteIcons.Icon24BombOutline,
    28: vkontakteIcons.Icon28BombOutline,
  },
  book_outline: {
    20: vkontakteIcons.Icon20BookOutline,
    28: vkontakteIcons.Icon28BookOutline,
  },
  book_spread_simple_outline: {
    20: vkontakteIcons.Icon20BookSpreadSimpleOutline,
  },
  bookmark_lock_outline: {
    20: vkontakteIcons.Icon20BookmarkLockOutline,
    28: vkontakteIcons.Icon28BookmarkLockOutline,
  },
  bookmark_slash_outline: {
    20: vkontakteIcons.Icon20BookmarkSlashOutline,
    24: vkontakteIcons.Icon24BookmarkSlashOutline,
    28: vkontakteIcons.Icon28BookmarkSlashOutline,
  },
  box_circle_fill_blue: {
    20: vkontakteIcons.Icon20BoxCircleFillBlue,
    28: vkontakteIcons.Icon28BoxCircleFillBlue,
  },
  brackets_slash_outline: {
    20: vkontakteIcons.Icon20BracketsSlashOutline,
    24: vkontakteIcons.Icon24BracketsSlashOutline,
  },
  broken_heart_outline: {
    20: vkontakteIcons.Icon20BrokenHeartOutline,
  },
  bubble_lol_outline: {
    20: vkontakteIcons.Icon20BubbleLolOutline,
    28: vkontakteIcons.Icon28BubbleLolOutline,
  },
  cake_circle_fill_raspberry_pink: {
    20: vkontakteIcons.Icon20CakeCircleFillRaspberryPink,
    28: vkontakteIcons.Icon28CakeCircleFillRaspberryPink,
    32: vkontakteIcons.Icon32CakeCircleFillRaspberryPink,
    56: vkontakteIcons.Icon56CakeCircleFillRaspberryPink,
  },
  cake_outline: {
    20: vkontakteIcons.Icon20CakeOutline,
    24: vkontakteIcons.Icon24CakeOutline,
    28: vkontakteIcons.Icon28CakeOutline,
    56: vkontakteIcons.Icon56CakeOutline,
  },
  calendar_check_outline: {
    20: vkontakteIcons.Icon20CalendarCheckOutline,
    28: vkontakteIcons.Icon28CalendarCheckOutline,
  },
  calendar_circle_fill_red: {
    20: vkontakteIcons.Icon20CalendarCircleFillRed,
    28: vkontakteIcons.Icon28CalendarCircleFillRed,
  },
  calendar_large_outline: {
    20: vkontakteIcons.Icon20CalendarLargeOutline,
  },
  camera_circle_fill_green: {
    20: vkontakteIcons.Icon20CameraCircleFillGreen,
    28: vkontakteIcons.Icon28CameraCircleFillGreen,
  },
  camera_outline: {
    20: vkontakteIcons.Icon20CameraOutline,
    24: vkontakteIcons.Icon24CameraOutline,
    28: vkontakteIcons.Icon28CameraOutline,
    32: vkontakteIcons.Icon32CameraOutline,
    36: vkontakteIcons.Icon36CameraOutline,
    48: vkontakteIcons.Icon48CameraOutline,
    56: vkontakteIcons.Icon56CameraOutline,
  },
  canister_outline: {
    20: vkontakteIcons.Icon20CanisterOutline,
    28: vkontakteIcons.Icon28CanisterOutline,
  },
  car_outline: {
    20: vkontakteIcons.Icon20CarOutline,
    24: vkontakteIcons.Icon24CarOutline,
    28: vkontakteIcons.Icon28CarOutline,
  },
  cards_2_outline: {
    20: vkontakteIcons.Icon20Cards2Outline,
    24: vkontakteIcons.Icon24Cards2Outline,
    28: vkontakteIcons.Icon28Cards2Outline,
    32: vkontakteIcons.Icon32Cards2Outline,
  },
  cash_out_outline: {
    20: vkontakteIcons.Icon20CashOutOutline,
    24: vkontakteIcons.Icon24CashOutOutline,
    28: vkontakteIcons.Icon28CashOutOutline,
  },
  check_box_indetermanate: {
    20: vkontakteIcons.Icon20CheckBoxIndetermanate,
  },
  check_box_off: {
    20: vkontakteIcons.Icon20CheckBoxOff,
    24: vkontakteIcons.Icon24CheckBoxOff,
  },
  check_box_on: {
    20: vkontakteIcons.Icon20CheckBoxOn,
    24: vkontakteIcons.Icon24CheckBoxOn,
  },
  check_circle_fill_turquoise: {
    20: vkontakteIcons.Icon20CheckCircleFillTurquoise,
  },
  check_circle_fill_yellow: {
    20: vkontakteIcons.Icon20CheckCircleFillYellow,
    28: vkontakteIcons.Icon28CheckCircleFillYellow,
  },
  check_circle_off: {
    20: vkontakteIcons.Icon20CheckCircleOff,
    24: vkontakteIcons.Icon24CheckCircleOff,
    28: vkontakteIcons.Icon28CheckCircleOff,
  },
  check_circle_on: {
    20: vkontakteIcons.Icon20CheckCircleOn,
    24: vkontakteIcons.Icon24CheckCircleOn,
    28: vkontakteIcons.Icon28CheckCircleOn,
  },
  check_comment_outline: {
    20: vkontakteIcons.Icon20CheckCommentOutline,
  },
  check_newsfeed_outline: {
    20: vkontakteIcons.Icon20CheckNewsfeedOutline,
  },
  check_shield_green: {
    20: vkontakteIcons.Icon20CheckShieldGreen,
  },
  check_shield_outline: {
    20: vkontakteIcons.Icon20CheckShieldOutline,
    24: vkontakteIcons.Icon24CheckShieldOutline,
    28: vkontakteIcons.Icon28CheckShieldOutline,
    56: vkontakteIcons.Icon56CheckShieldOutline,
  },
  check_small_outline: {
    20: vkontakteIcons.Icon20CheckSmallOutline,
  },
  checkback_prize_outline: {
    20: vkontakteIcons.Icon20CheckbackPrizeOutline,
    28: vkontakteIcons.Icon28CheckbackPrizeOutline,
  },
  checks_outline: {
    20: vkontakteIcons.Icon20ChecksOutline,
    24: vkontakteIcons.Icon24ChecksOutline,
    28: vkontakteIcons.Icon28ChecksOutline,
  },
  checks_small_outline: {
    20: vkontakteIcons.Icon20ChecksSmallOutline,
  },
  chevron_circle_outline: {
    20: vkontakteIcons.Icon20ChevronCircleOutline,
  },
  chevron_left_2: {
    20: vkontakteIcons.Icon20ChevronLeft2,
  },
  chevron_left_outline: {
    20: vkontakteIcons.Icon20ChevronLeftOutline,
    24: vkontakteIcons.Icon24ChevronLeftOutline,
    28: vkontakteIcons.Icon28ChevronLeftOutline,
    36: vkontakteIcons.Icon36ChevronLeftOutline,
    48: vkontakteIcons.Icon48ChevronLeftOutline,
  },
  chevron_right_2: {
    20: vkontakteIcons.Icon20ChevronRight2,
  },
  chevron_right_outline: {
    20: vkontakteIcons.Icon20ChevronRightOutline,
    24: vkontakteIcons.Icon24ChevronRightOutline,
    28: vkontakteIcons.Icon28ChevronRightOutline,
    36: vkontakteIcons.Icon36ChevronRightOutline,
    48: vkontakteIcons.Icon48ChevronRightOutline,
  },
  chevron_up_outline: {
    20: vkontakteIcons.Icon20ChevronUpOutline,
    28: vkontakteIcons.Icon28ChevronUpOutline,
    48: vkontakteIcons.Icon48ChevronUpOutline,
  },
  cigarette_outline: {
    20: vkontakteIcons.Icon20CigaretteOutline,
    24: vkontakteIcons.Icon24CigaretteOutline,
    28: vkontakteIcons.Icon28CigaretteOutline,
  },
  circle_small: {
    20: vkontakteIcons.Icon20CircleSmall,
    24: vkontakteIcons.Icon24CircleSmall,
  },
  circle_small_filled: {
    20: vkontakteIcons.Icon20CircleSmallFilled,
  },
  clear_data_outline: {
    20: vkontakteIcons.Icon20ClearDataOutline,
    28: vkontakteIcons.Icon28ClearDataOutline,
  },
  clip_circle_fill_violet: {
    20: vkontakteIcons.Icon20ClipCircleFillViolet,
    28: vkontakteIcons.Icon28ClipCircleFillViolet,
  },
  clock_circle_fill_raspberry_pink: {
    20: vkontakteIcons.Icon20ClockCircleFillRaspberryPink,
    28: vkontakteIcons.Icon28ClockCircleFillRaspberryPink,
  },
  cloud_arrow_up_outline: {
    20: vkontakteIcons.Icon20CloudArrowUpOutline,
    24: vkontakteIcons.Icon24CloudArrowUpOutline,
    28: vkontakteIcons.Icon28CloudArrowUpOutline,
  },
  cloud_outline: {
    20: vkontakteIcons.Icon20CloudOutline,
    24: vkontakteIcons.Icon24CloudOutline,
    28: vkontakteIcons.Icon28CloudOutline,
  },
  cloud_plus_outline: {
    20: vkontakteIcons.Icon20CloudPlusOutline,
    24: vkontakteIcons.Icon24CloudPlusOutline,
    28: vkontakteIcons.Icon28CloudPlusOutline,
  },
  cloud_slash_outline: {
    20: vkontakteIcons.Icon20CloudSlashOutline,
    24: vkontakteIcons.Icon24CloudSlashOutline,
    28: vkontakteIcons.Icon28CloudSlashOutline,
  },
  coins_outline: {
    20: vkontakteIcons.Icon20CoinsOutline,
    24: vkontakteIcons.Icon24CoinsOutline,
    28: vkontakteIcons.Icon28CoinsOutline,
    44: vkontakteIcons.Icon44CoinsOutline,
  },
  columns_square: {
    20: vkontakteIcons.Icon20ColumnsSquare,
  },
  comment_add_badge_outline: {
    20: vkontakteIcons.Icon20CommentAddBadgeOutline,
    24: vkontakteIcons.Icon24CommentAddBadgeOutline,
  },
  comment_circle_fill_gray: {
    20: vkontakteIcons.Icon20CommentCircleFillGray,
  },
  comment_circle_fill_green: {
    20: vkontakteIcons.Icon20CommentCircleFillGreen,
    28: vkontakteIcons.Icon28CommentCircleFillGreen,
  },
  comment_disable_outline: {
    20: vkontakteIcons.Icon20CommentDisableOutline,
    28: vkontakteIcons.Icon28CommentDisableOutline,
  },
  community_name: {
    20: vkontakteIcons.Icon20CommunityName,
  },
  compass_outline: {
    20: vkontakteIcons.Icon20CompassOutline,
    24: vkontakteIcons.Icon24CompassOutline,
    28: vkontakteIcons.Icon28CompassOutline,
    56: vkontakteIcons.Icon56CompassOutline,
  },
  computer_outline: {
    20: vkontakteIcons.Icon20ComputerOutline,
    24: vkontakteIcons.Icon24ComputerOutline,
    28: vkontakteIcons.Icon28ComputerOutline,
    56: vkontakteIcons.Icon56ComputerOutline,
  },
  computer_smartphone_outline: {
    20: vkontakteIcons.Icon20ComputerSmartphoneOutline,
    24: vkontakteIcons.Icon24ComputerSmartphoneOutline,
    28: vkontakteIcons.Icon28ComputerSmartphoneOutline,
  },
  cookie_outline: {
    20: vkontakteIcons.Icon20CookieOutline,
  },
  copyright_outline: {
    20: vkontakteIcons.Icon20CopyrightOutline,
  },
  cup_outline: {
    20: vkontakteIcons.Icon20CupOutline,
    24: vkontakteIcons.Icon24CupOutline,
    28: vkontakteIcons.Icon28CupOutline,
    56: vkontakteIcons.Icon56CupOutline,
  },
  cursor_outline: {
    20: vkontakteIcons.Icon20CursorOutline,
  },
  delete_clock_alt_outline: {
    20: vkontakteIcons.Icon20DeleteClockAltOutline,
  },
  delete_clock_outline: {
    20: vkontakteIcons.Icon20DeleteClockOutline,
    24: vkontakteIcons.Icon24DeleteClockOutline,
    28: vkontakteIcons.Icon28DeleteClockOutline,
  },
  delete_outline_android: {
    20: vkontakteIcons.Icon20DeleteOutlineAndroid,
    24: vkontakteIcons.Icon24DeleteOutlineAndroid,
    28: vkontakteIcons.Icon28DeleteOutlineAndroid,
    56: vkontakteIcons.Icon56DeleteOutlineAndroid,
  },
  discount_outline: {
    20: vkontakteIcons.Icon20DiscountOutline,
    24: vkontakteIcons.Icon24DiscountOutline,
    28: vkontakteIcons.Icon28DiscountOutline,
    32: vkontakteIcons.Icon32DiscountOutline,
    36: vkontakteIcons.Icon36DiscountOutline,
  },
  discussions_circle_fill_blue: {
    20: vkontakteIcons.Icon20DiscussionsCircleFillBlue,
  },
  dismiss_dark: {
    20: vkontakteIcons.Icon20DismissDark,
    24: vkontakteIcons.Icon24DismissDark,
  },
  document_arrow_up_outline: {
    20: vkontakteIcons.Icon20DocumentArrowUpOutline,
    24: vkontakteIcons.Icon24DocumentArrowUpOutline,
    28: vkontakteIcons.Icon28DocumentArrowUpOutline,
    48: vkontakteIcons.Icon48DocumentArrowUpOutline,
    56: vkontakteIcons.Icon56DocumentArrowUpOutline,
  },
  document_list_outline: {
    20: vkontakteIcons.Icon20DocumentListOutline,
    24: vkontakteIcons.Icon24DocumentListOutline,
    28: vkontakteIcons.Icon28DocumentListOutline,
  },
  document_plus_outline: {
    20: vkontakteIcons.Icon20DocumentPlusOutline,
    24: vkontakteIcons.Icon24DocumentPlusOutline,
    28: vkontakteIcons.Icon28DocumentPlusOutline,
  },
  document_stats_outline: {
    20: vkontakteIcons.Icon20DocumentStatsOutline,
    24: vkontakteIcons.Icon24DocumentStatsOutline,
    28: vkontakteIcons.Icon28DocumentStatsOutline,
  },
  document_text_outline: {
    20: vkontakteIcons.Icon20DocumentTextOutline,
    24: vkontakteIcons.Icon24DocumentTextOutline,
    28: vkontakteIcons.Icon28DocumentTextOutline,
  },
  donate_circle_fill_yellow: {
    20: vkontakteIcons.Icon20DonateCircleFillYellow,
    28: vkontakteIcons.Icon28DonateCircleFillYellow,
  },
  donut_circle_fill_yellow: {
    20: vkontakteIcons.Icon20DonutCircleFillYellow,
    32: vkontakteIcons.Icon32DonutCircleFillYellow,
  },
  door_arrow_right_outline: {
    20: vkontakteIcons.Icon20DoorArrowRightOutline,
    24: vkontakteIcons.Icon24DoorArrowRightOutline,
    28: vkontakteIcons.Icon28DoorArrowRightOutline,
    56: vkontakteIcons.Icon56DoorArrowRightOutline,
  },
  download_check_outline: {
    20: vkontakteIcons.Icon20DownloadCheckOutline,
    24: vkontakteIcons.Icon24DownloadCheckOutline,
    28: vkontakteIcons.Icon28DownloadCheckOutline,
  },
  download_cloud_outline: {
    20: vkontakteIcons.Icon20DownloadCloudOutline,
    24: vkontakteIcons.Icon24DownloadCloudOutline,
    28: vkontakteIcons.Icon28DownloadCloudOutline,
  },
  dumpbell_outline: {
    20: vkontakteIcons.Icon20DumpbellOutline,
  },
  edit_circle_fill_blue: {
    20: vkontakteIcons.Icon20EditCircleFillBlue,
    28: vkontakteIcons.Icon28EditCircleFillBlue,
  },
  editor_cut_outline: {
    20: vkontakteIcons.Icon20EditorCutOutline,
    24: vkontakteIcons.Icon24EditorCutOutline,
    28: vkontakteIcons.Icon28EditorCutOutline,
  },
  error_circle_fill_red: {
    20: vkontakteIcons.Icon20ErrorCircleFillRed,
    24: vkontakteIcons.Icon24ErrorCircleFillRed,
  },
  error_shield: {
    20: vkontakteIcons.Icon20ErrorShield,
  },
  error_shield_filled_yellow: {
    20: vkontakteIcons.Icon20ErrorShieldFilledYellow,
  },
  favorite_circle_fill_green: {
    20: vkontakteIcons.Icon20FavoriteCircleFillGreen,
    28: vkontakteIcons.Icon28FavoriteCircleFillGreen,
    32: vkontakteIcons.Icon32FavoriteCircleFillGreen,
  },
  favorite_circle_fill_yellow: {
    20: vkontakteIcons.Icon20FavoriteCircleFillYellow,
    28: vkontakteIcons.Icon28FavoriteCircleFillYellow,
  },
  filter_outline: {
    20: vkontakteIcons.Icon20FilterOutline,
  },
  fire_alt_outline: {
    20: vkontakteIcons.Icon20FireAltOutline,
    24: vkontakteIcons.Icon24FireAltOutline,
    28: vkontakteIcons.Icon28FireAltOutline,
  },
  fire_circle_fill_red: {
    20: vkontakteIcons.Icon20FireCircleFillRed,
    28: vkontakteIcons.Icon28FireCircleFillRed,
  },
  flash_outline: {
    20: vkontakteIcons.Icon20FlashOutline,
    24: vkontakteIcons.Icon24FlashOutline,
    28: vkontakteIcons.Icon28FlashOutline,
  },
  flip_horizontal: {
    20: vkontakteIcons.Icon20FlipHorizontal,
  },
  flip_vertical: {
    20: vkontakteIcons.Icon20FlipVertical,
  },
  folder_fill: {
    20: vkontakteIcons.Icon20FolderFill,
    28: vkontakteIcons.Icon28FolderFill,
  },
  folder_lock_outline: {
    20: vkontakteIcons.Icon20FolderLockOutline,
  },
  folder_move_outline: {
    20: vkontakteIcons.Icon20FolderMoveOutline,
  },
  folder_simple_arrow_right_outline: {
    20: vkontakteIcons.Icon20FolderSimpleArrowRightOutline,
    28: vkontakteIcons.Icon28FolderSimpleArrowRightOutline,
  },
  folder_simple_arrow_up_outline: {
    20: vkontakteIcons.Icon20FolderSimpleArrowUpOutline,
    24: vkontakteIcons.Icon24FolderSimpleArrowUpOutline,
    28: vkontakteIcons.Icon28FolderSimpleArrowUpOutline,
  },
  folder_simple_lock_outline: {
    20: vkontakteIcons.Icon20FolderSimpleLockOutline,
    24: vkontakteIcons.Icon24FolderSimpleLockOutline,
    28: vkontakteIcons.Icon28FolderSimpleLockOutline,
  },
  folder_simple_outline: {
    20: vkontakteIcons.Icon20FolderSimpleOutline,
    24: vkontakteIcons.Icon24FolderSimpleOutline,
    28: vkontakteIcons.Icon28FolderSimpleOutline,
  },
  folder_simple_plus_outline: {
    20: vkontakteIcons.Icon20FolderSimplePlusOutline,
    24: vkontakteIcons.Icon24FolderSimplePlusOutline,
    28: vkontakteIcons.Icon28FolderSimplePlusOutline,
  },
  folder_simple_user_outline: {
    20: vkontakteIcons.Icon20FolderSimpleUserOutline,
    24: vkontakteIcons.Icon24FolderSimpleUserOutline,
    28: vkontakteIcons.Icon28FolderSimpleUserOutline,
  },
  followers_outline: {
    20: vkontakteIcons.Icon20FollowersOutline,
  },
  football_ball_outline: {
    20: vkontakteIcons.Icon20FootballBallOutline,
    24: vkontakteIcons.Icon24FootballBallOutline,
    28: vkontakteIcons.Icon28FootballBallOutline,
  },
  freeze_outline: {
    20: vkontakteIcons.Icon20FreezeOutline,
  },
  fullscreen_exit_outline: {
    20: vkontakteIcons.Icon20FullscreenExitOutline,
    28: vkontakteIcons.Icon28FullscreenExitOutline,
  },
  fullscreen_outline: {
    20: vkontakteIcons.Icon20FullscreenOutline,
    28: vkontakteIcons.Icon28FullscreenOutline,
  },
  funnel_outline: {
    20: vkontakteIcons.Icon20FunnelOutline,
  },
  game_circle_fill_blue: {
    20: vkontakteIcons.Icon20GameCircleFillBlue,
    28: vkontakteIcons.Icon28GameCircleFillBlue,
  },
  game_outline: {
    20: vkontakteIcons.Icon20GameOutline,
    24: vkontakteIcons.Icon24GameOutline,
    28: vkontakteIcons.Icon28GameOutline,
    36: vkontakteIcons.Icon36GameOutline,
    56: vkontakteIcons.Icon56GameOutline,
  },
  gavel_outline: {
    20: vkontakteIcons.Icon20GavelOutline,
    24: vkontakteIcons.Icon24GavelOutline,
    56: vkontakteIcons.Icon56GavelOutline,
  },
  gear_circle_fill_gray: {
    20: vkontakteIcons.Icon20GearCircleFillGray,
    28: vkontakteIcons.Icon28GearCircleFillGray,
  },
  gesture_outline: {
    20: vkontakteIcons.Icon20GestureOutline,
    28: vkontakteIcons.Icon28GestureOutline,
    56: vkontakteIcons.Icon56GestureOutline,
  },
  gesture_play_outline: {
    20: vkontakteIcons.Icon20GesturePlayOutline,
  },
  ghost_outline: {
    20: vkontakteIcons.Icon20GhostOutline,
    24: vkontakteIcons.Icon24GhostOutline,
    28: vkontakteIcons.Icon28GhostOutline,
    56: vkontakteIcons.Icon56GhostOutline,
  },
  gift_circle_fill_red: {
    20: vkontakteIcons.Icon20GiftCircleFillRed,
    28: vkontakteIcons.Icon28GiftCircleFillRed,
  },
  gift_circle_fill_yellow: {
    20: vkontakteIcons.Icon20GiftCircleFillYellow,
    28: vkontakteIcons.Icon28GiftCircleFillYellow,
  },
  globe_cross_outline: {
    20: vkontakteIcons.Icon20GlobeCrossOutline,
    28: vkontakteIcons.Icon28GlobeCrossOutline,
    56: vkontakteIcons.Icon56GlobeCrossOutline,
  },
  graph_outline: {
    20: vkontakteIcons.Icon20GraphOutline,
    24: vkontakteIcons.Icon24GraphOutline,
    28: vkontakteIcons.Icon28GraphOutline,
  },
  grid_4_uneven_vertical_outline: {
    20: vkontakteIcons.Icon20Grid4UnevenVerticalOutline,
    24: vkontakteIcons.Icon24Grid4UnevenVerticalOutline,
  },
  grid_circle_fill_purple: {
    20: vkontakteIcons.Icon20GridCircleFillPurple,
    28: vkontakteIcons.Icon28GridCircleFillPurple,
  },
  hashtag_outline: {
    20: vkontakteIcons.Icon20HashtagOutline,
    24: vkontakteIcons.Icon24HashtagOutline,
    28: vkontakteIcons.Icon28HashtagOutline,
    32: vkontakteIcons.Icon32HashtagOutline,
    36: vkontakteIcons.Icon36HashtagOutline,
    56: vkontakteIcons.Icon56HashtagOutline,
  },
  headphones_circle_fill_raspberry_pink: {
    20: vkontakteIcons.Icon20HeadphonesCircleFillRaspberryPink,
    28: vkontakteIcons.Icon28HeadphonesCircleFillRaspberryPink,
  },
  headphones_support_outline: {
    20: vkontakteIcons.Icon20HeadphonesSupportOutline,
  },
  headphones_wave_circle_fill_gray: {
    20: vkontakteIcons.Icon20HeadphonesWaveCircleFillGray,
    28: vkontakteIcons.Icon28HeadphonesWaveCircleFillGray,
  },
  headphones_wave_outline: {
    20: vkontakteIcons.Icon20HeadphonesWaveOutline,
    24: vkontakteIcons.Icon24HeadphonesWaveOutline,
    28: vkontakteIcons.Icon28HeadphonesWaveOutline,
    56: vkontakteIcons.Icon56HeadphonesWaveOutline,
  },
  health_outline: {
    20: vkontakteIcons.Icon20HealthOutline,
    24: vkontakteIcons.Icon24HealthOutline,
    36: vkontakteIcons.Icon36HealthOutline,
    56: vkontakteIcons.Icon56HealthOutline,
  },
  heart_settings_outline: {
    20: vkontakteIcons.Icon20HeartSettingsOutline,
  },
  hearts_2_circle_fill_twilight: {
    20: vkontakteIcons.Icon20Hearts2CircleFillTwilight,
    28: vkontakteIcons.Icon28Hearts2CircleFillTwilight,
    56: vkontakteIcons.Icon56Hearts2CircleFillTwilight,
  },
  hearts_2_outline: {
    20: vkontakteIcons.Icon20Hearts2Outline,
    28: vkontakteIcons.Icon28Hearts2Outline,
    36: vkontakteIcons.Icon36Hearts2Outline,
  },
  history_forward_lock_outline: {
    20: vkontakteIcons.Icon20HistoryForwardLockOutline,
    28: vkontakteIcons.Icon28HistoryForwardLockOutline,
  },
  hockey_outline: {
    20: vkontakteIcons.Icon20HockeyOutline,
    28: vkontakteIcons.Icon28HockeyOutline,
  },
  home_check_outline: {
    20: vkontakteIcons.Icon20HomeCheckOutline,
  },
  home_outline: {
    20: vkontakteIcons.Icon20HomeOutline,
    24: vkontakteIcons.Icon24HomeOutline,
    28: vkontakteIcons.Icon28HomeOutline,
    36: vkontakteIcons.Icon36HomeOutline,
  },
  horizontal_rectangle_16x9_outline: {
    20: vkontakteIcons.Icon20HorizontalRectangle16x9Outline,
    24: vkontakteIcons.Icon24HorizontalRectangle16x9Outline,
  },
  horizontal_rectangle_outline: {
    20: vkontakteIcons.Icon20HorizontalRectangleOutline,
    24: vkontakteIcons.Icon24HorizontalRectangleOutline,
    28: vkontakteIcons.Icon28HorizontalRectangleOutline,
  },
  image_filter_outline: {
    20: vkontakteIcons.Icon20ImageFilterOutline,
    24: vkontakteIcons.Icon24ImageFilterOutline,
    28: vkontakteIcons.Icon28ImageFilterOutline,
  },
  image_format_outline: {
    20: vkontakteIcons.Icon20ImageFormatOutline,
  },
  incognito_outline: {
    20: vkontakteIcons.Icon20IncognitoOutline,
    28: vkontakteIcons.Icon28IncognitoOutline,
    36: vkontakteIcons.Icon36IncognitoOutline,
  },
  infinity_outline: {
    20: vkontakteIcons.Icon20InfinityOutline,
    24: vkontakteIcons.Icon24InfinityOutline,
  },
  info: {
    20: vkontakteIcons.Icon20Info,
    24: vkontakteIcons.Icon24Info,
  },
  info_circle_outline: {
    20: vkontakteIcons.Icon20InfoCircleOutline,
    24: vkontakteIcons.Icon24InfoCircleOutline,
    28: vkontakteIcons.Icon28InfoCircleOutline,
  },
  keyboard_outline: {
    20: vkontakteIcons.Icon20KeyboardOutline,
    24: vkontakteIcons.Icon24KeyboardOutline,
    28: vkontakteIcons.Icon28KeyboardOutline,
  },
  laptop_outline: {
    20: vkontakteIcons.Icon20LaptopOutline,
    24: vkontakteIcons.Icon24LaptopOutline,
    28: vkontakteIcons.Icon28LaptopOutline,
    56: vkontakteIcons.Icon56LaptopOutline,
  },
  layout_left_column_outline: {
    20: vkontakteIcons.Icon20LayoutLeftColumnOutline,
  },
  lifebuoy_outline: {
    20: vkontakteIcons.Icon20LifebuoyOutline,
    24: vkontakteIcons.Icon24LifebuoyOutline,
    28: vkontakteIcons.Icon28LifebuoyOutline,
    56: vkontakteIcons.Icon56LifebuoyOutline,
  },
  lightbulb_circle_fill_yellow: {
    20: vkontakteIcons.Icon20LightbulbCircleFillYellow,
    28: vkontakteIcons.Icon28LightbulbCircleFillYellow,
  },
  lightbulb_outline: {
    20: vkontakteIcons.Icon20LightbulbOutline,
    24: vkontakteIcons.Icon24LightbulbOutline,
    28: vkontakteIcons.Icon28LightbulbOutline,
    36: vkontakteIcons.Icon36LightbulbOutline,
  },
  lightbulb_star_outline: {
    20: vkontakteIcons.Icon20LightbulbStarOutline,
    24: vkontakteIcons.Icon24LightbulbStarOutline,
    28: vkontakteIcons.Icon28LightbulbStarOutline,
  },
  like_circle_fill_gray: {
    20: vkontakteIcons.Icon20LikeCircleFillGray,
  },
  like_circle_fill_raspberry_pink: {
    20: vkontakteIcons.Icon20LikeCircleFillRaspberryPink,
    28: vkontakteIcons.Icon28LikeCircleFillRaspberryPink,
  },
  like_circle_fill_red: {
    20: vkontakteIcons.Icon20LikeCircleFillRed,
    24: vkontakteIcons.Icon24LikeCircleFillRed,
    28: vkontakteIcons.Icon28LikeCircleFillRed,
  },
  like_lock_outline: {
    20: vkontakteIcons.Icon20LikeLockOutline,
    28: vkontakteIcons.Icon28LikeLockOutline,
    56: vkontakteIcons.Icon56LikeLockOutline,
  },
  line_bottom: {
    20: vkontakteIcons.Icon20LineBottom,
  },
  line_outline: {
    20: vkontakteIcons.Icon20LineOutline,
  },
  lines_grid_2x3_square: {
    20: vkontakteIcons.Icon20LinesGrid2x3Square,
  },
  link_circle_outline: {
    20: vkontakteIcons.Icon20LinkCircleOutline,
    28: vkontakteIcons.Icon28LinkCircleOutline,
    32: vkontakteIcons.Icon32LinkCircleOutline,
    56: vkontakteIcons.Icon56LinkCircleOutline,
  },
  list_add_outline: {
    20: vkontakteIcons.Icon20ListAddOutline,
    24: vkontakteIcons.Icon24ListAddOutline,
    28: vkontakteIcons.Icon28ListAddOutline,
  },
  list_arrow_left_down_outline: {
    20: vkontakteIcons.Icon20ListArrowLeftDownOutline,
    24: vkontakteIcons.Icon24ListArrowLeftDownOutline,
    28: vkontakteIcons.Icon28ListArrowLeftDownOutline,
  },
  list_circle_fill_gray: {
    20: vkontakteIcons.Icon20ListCircleFillGray,
    28: vkontakteIcons.Icon28ListCircleFillGray,
  },
  list_delete_outline: {
    20: vkontakteIcons.Icon20ListDeleteOutline,
    24: vkontakteIcons.Icon24ListDeleteOutline,
  },
  list_insert_first_outline: {
    20: vkontakteIcons.Icon20ListInsertFirstOutline,
    28: vkontakteIcons.Icon28ListInsertFirstOutline,
  },
  list_insert_last_outline: {
    20: vkontakteIcons.Icon20ListInsertLastOutline,
    28: vkontakteIcons.Icon28ListInsertLastOutline,
  },
  list_like_circle_fill_blue: {
    20: vkontakteIcons.Icon20ListLikeCircleFillBlue,
  },
  list_pen_outline: {
    20: vkontakteIcons.Icon20ListPenOutline,
  },
  live_outline: {
    20: vkontakteIcons.Icon20LiveOutline,
    24: vkontakteIcons.Icon24LiveOutline,
    28: vkontakteIcons.Icon28LiveOutline,
    36: vkontakteIcons.Icon36LiveOutline,
    56: vkontakteIcons.Icon56LiveOutline,
  },
  live_slash_outline: {
    20: vkontakteIcons.Icon20LiveSlashOutline,
    28: vkontakteIcons.Icon28LiveSlashOutline,
  },
  location_map_outline: {
    20: vkontakteIcons.Icon20LocationMapOutline,
    24: vkontakteIcons.Icon24LocationMapOutline,
    28: vkontakteIcons.Icon28LocationMapOutline,
  },
  location_outline: {
    20: vkontakteIcons.Icon20LocationOutline,
    24: vkontakteIcons.Icon24LocationOutline,
    28: vkontakteIcons.Icon28LocationOutline,
    56: vkontakteIcons.Icon56LocationOutline,
  },
  location_slash_outline: {
    20: vkontakteIcons.Icon20LocationSlashOutline,
  },
  lock_circle_fill_black: {
    20: vkontakteIcons.Icon20LockCircleFillBlack,
    28: vkontakteIcons.Icon28LockCircleFillBlack,
  },
  logo_capsula_outline: {
    20: vkontakteIcons.Icon20LogoCapsulaOutline,
  },
  logo_clips_outline: {
    20: vkontakteIcons.Icon20LogoClipsOutline,
    24: vkontakteIcons.Icon24LogoClipsOutline,
    28: vkontakteIcons.Icon28LogoClipsOutline,
    56: vkontakteIcons.Icon56LogoClipsOutline,
  },
  logo_dating_outline: {
    20: vkontakteIcons.Icon20LogoDatingOutline,
    28: vkontakteIcons.Icon28LogoDatingOutline,
  },
  logo_geekbrains_outline: {
    20: vkontakteIcons.Icon20LogoGeekbrainsOutline,
  },
  logo_ok_outline: {
    20: vkontakteIcons.Icon20LogoOkOutline,
  },
  logo_old_vk: {
    20: vkontakteIcons.Icon20LogoOldVk,
  },
  logo_rustore_outline: {
    20: vkontakteIcons.Icon20LogoRustoreOutline,
  },
  logo_skillbox_outline: {
    20: vkontakteIcons.Icon20LogoSkillboxOutline,
  },
  logo_vk_ads_outline: {
    20: vkontakteIcons.Icon20LogoVkAdsOutline,
  },
  logo_vk_calls_outline: {
    20: vkontakteIcons.Icon20LogoVkCallsOutline,
    28: vkontakteIcons.Icon28LogoVkCallsOutline,
  },
  logo_vk_clip: {
    20: vkontakteIcons.Icon20LogoVkClip,
  },
  logo_vk_cloud_outline: {
    20: vkontakteIcons.Icon20LogoVkCloudOutline,
  },
  logo_vk_market: {
    20: vkontakteIcons.Icon20LogoVkMarket,
  },
  logo_vk_me_outline: {
    20: vkontakteIcons.Icon20LogoVkMeOutline,
  },
  logo_vk_outline: {
    20: vkontakteIcons.Icon20LogoVkOutline,
    24: vkontakteIcons.Icon24LogoVkOutline,
    28: vkontakteIcons.Icon28LogoVkOutline,
  },
  logo_vk_teams_outline: {
    20: vkontakteIcons.Icon20LogoVkTeamsOutline,
  },
  logo_vk_video_outline: {
    20: vkontakteIcons.Icon20LogoVkVideoOutline,
    24: vkontakteIcons.Icon24LogoVkVideoOutline,
    28: vkontakteIcons.Icon28LogoVkVideoOutline,
    32: vkontakteIcons.Icon32LogoVkVideoOutline,
    36: vkontakteIcons.Icon36LogoVkVideoOutline,
  },
  logo_vk_video_slash_outline: {
    20: vkontakteIcons.Icon20LogoVkVideoSlashOutline,
    28: vkontakteIcons.Icon28LogoVkVideoSlashOutline,
  },
  logo_vk_workdisk_outline: {
    20: vkontakteIcons.Icon20LogoVkWorkdiskOutline,
  },
  logo_vk_workmail_outline: {
    20: vkontakteIcons.Icon20LogoVkWorkmailOutline,
  },
  logo_vk_workspace_outline: {
    20: vkontakteIcons.Icon20LogoVkWorkspaceOutline,
  },
  lotus_outline: {
    20: vkontakteIcons.Icon20LotusOutline,
    24: vkontakteIcons.Icon24LotusOutline,
    28: vkontakteIcons.Icon28LotusOutline,
  },
  magnifier_minus_outline: {
    20: vkontakteIcons.Icon20MagnifierMinusOutline,
  },
  magnifier_plus_outline: {
    20: vkontakteIcons.Icon20MagnifierPlusOutline,
  },
  mail_circle_fill_blue: {
    20: vkontakteIcons.Icon20MailCircleFillBlue,
    28: vkontakteIcons.Icon28MailCircleFillBlue,
  },
  marker_outline: {
    20: vkontakteIcons.Icon20MarkerOutline,
    24: vkontakteIcons.Icon24MarkerOutline,
  },
  market_circle_fill_yellow: {
    20: vkontakteIcons.Icon20MarketCircleFillYellow,
    28: vkontakteIcons.Icon28MarketCircleFillYellow,
  },
  masks_outline: {
    20: vkontakteIcons.Icon20MasksOutline,
    24: vkontakteIcons.Icon24MasksOutline,
    28: vkontakteIcons.Icon28MasksOutline,
    32: vkontakteIcons.Icon32MasksOutline,
    56: vkontakteIcons.Icon56MasksOutline,
  },
  megaphone_outline: {
    20: vkontakteIcons.Icon20MegaphoneOutline,
    24: vkontakteIcons.Icon24MegaphoneOutline,
    28: vkontakteIcons.Icon28MegaphoneOutline,
  },
  mention_circle_fill_blue: {
    20: vkontakteIcons.Icon20MentionCircleFillBlue,
    28: vkontakteIcons.Icon28MentionCircleFillBlue,
  },
  mention_outline: {
    20: vkontakteIcons.Icon20MentionOutline,
    24: vkontakteIcons.Icon24MentionOutline,
    28: vkontakteIcons.Icon28MentionOutline,
    48: vkontakteIcons.Icon48MentionOutline,
    56: vkontakteIcons.Icon56MentionOutline,
  },
  message_add_outline: {
    20: vkontakteIcons.Icon20MessageAddOutline,
  },
  message_arrow_right_outline: {
    20: vkontakteIcons.Icon20MessageArrowRightOutline,
    24: vkontakteIcons.Icon24MessageArrowRightOutline,
    28: vkontakteIcons.Icon28MessageArrowRightOutline,
  },
  message_check_outline: {
    20: vkontakteIcons.Icon20MessageCheckOutline,
    28: vkontakteIcons.Icon28MessageCheckOutline,
  },
  message_circle_fill_blue: {
    20: vkontakteIcons.Icon20MessageCircleFillBlue,
  },
  message_circle_fill_green: {
    20: vkontakteIcons.Icon20MessageCircleFillGreen,
    28: vkontakteIcons.Icon28MessageCircleFillGreen,
    56: vkontakteIcons.Icon56MessageCircleFillGreen,
  },
  message_cross_outline: {
    20: vkontakteIcons.Icon20MessageCrossOutline,
    28: vkontakteIcons.Icon28MessageCrossOutline,
  },
  message_rectangle_outline: {
    20: vkontakteIcons.Icon20MessageRectangleOutline,
  },
  message_text_outline: {
    20: vkontakteIcons.Icon20MessageTextOutline,
    28: vkontakteIcons.Icon28MessageTextOutline,
  },
  message_unread_circle_fill_gray: {
    20: vkontakteIcons.Icon20MessageUnreadCircleFillGray,
    28: vkontakteIcons.Icon28MessageUnreadCircleFillGray,
  },
  message_unread_circle_fill_red: {
    20: vkontakteIcons.Icon20MessageUnreadCircleFillRed,
    28: vkontakteIcons.Icon28MessageUnreadCircleFillRed,
  },
  message_unread_top_outline: {
    20: vkontakteIcons.Icon20MessageUnreadTopOutline,
    24: vkontakteIcons.Icon24MessageUnreadTopOutline,
  },
  messages_outline: {
    20: vkontakteIcons.Icon20MessagesOutline,
    24: vkontakteIcons.Icon24MessagesOutline,
    28: vkontakteIcons.Icon28MessagesOutline,
    56: vkontakteIcons.Icon56MessagesOutline,
  },
  mic_circle_fill_raspberry_pink: {
    20: vkontakteIcons.Icon20MicCircleFillRaspberryPink,
    28: vkontakteIcons.Icon28MicCircleFillRaspberryPink,
  },
  minecraft_outline: {
    20: vkontakteIcons.Icon20MinecraftOutline,
    28: vkontakteIcons.Icon28MinecraftOutline,
  },
  minus_outline: {
    20: vkontakteIcons.Icon20MinusOutline,
    24: vkontakteIcons.Icon24MinusOutline,
    28: vkontakteIcons.Icon28MinusOutline,
  },
  minus_square_outline: {
    20: vkontakteIcons.Icon20MinusSquareOutline,
    24: vkontakteIcons.Icon24MinusSquareOutline,
    28: vkontakteIcons.Icon28MinusSquareOutline,
  },
  money_circle_check_outline: {
    20: vkontakteIcons.Icon20MoneyCircleCheckOutline,
    24: vkontakteIcons.Icon24MoneyCircleCheckOutline,
    28: vkontakteIcons.Icon28MoneyCircleCheckOutline,
  },
  money_outline: {
    20: vkontakteIcons.Icon20MoneyOutline,
  },
  money_request_circle_fill_blue: {
    20: vkontakteIcons.Icon20MoneyRequestCircleFillBlue,
    28: vkontakteIcons.Icon28MoneyRequestCircleFillBlue,
  },
  money_transfer_circle_fill_red: {
    20: vkontakteIcons.Icon20MoneyTransferCircleFillRed,
    28: vkontakteIcons.Icon28MoneyTransferCircleFillRed,
  },
  money_transfer_circle_fill_turquoise: {
    20: vkontakteIcons.Icon20MoneyTransferCircleFillTurquoise,
    28: vkontakteIcons.Icon28MoneyTransferCircleFillTurquoise,
  },
  money_transfer_outline: {
    20: vkontakteIcons.Icon20MoneyTransferOutline,
    24: vkontakteIcons.Icon24MoneyTransferOutline,
    28: vkontakteIcons.Icon28MoneyTransferOutline,
    32: vkontakteIcons.Icon32MoneyTransferOutline,
    56: vkontakteIcons.Icon56MoneyTransferOutline,
  },
  moon_outline: {
    20: vkontakteIcons.Icon20MoonOutline,
    28: vkontakteIcons.Icon28MoonOutline,
    56: vkontakteIcons.Icon56MoonOutline,
  },
  more: {
    20: vkontakteIcons.Icon20More,
    28: vkontakteIcons.Icon28More,
  },
  more_horizontal_circle: {
    20: vkontakteIcons.Icon20MoreHorizontalCircle,
  },
  more_vertical_circle: {
    20: vkontakteIcons.Icon20MoreVerticalCircle,
  },
  music_note_wave_outline: {
    20: vkontakteIcons.Icon20MusicNoteWaveOutline,
    24: vkontakteIcons.Icon24MusicNoteWaveOutline,
    28: vkontakteIcons.Icon28MusicNoteWaveOutline,
  },
  mute: {
    20: vkontakteIcons.Icon20Mute,
    24: vkontakteIcons.Icon24Mute,
    48: vkontakteIcons.Icon48Mute,
  },
  mute_outline: {
    20: vkontakteIcons.Icon20MuteOutline,
    24: vkontakteIcons.Icon24MuteOutline,
    28: vkontakteIcons.Icon28MuteOutline,
  },
  narrative_outline: {
    20: vkontakteIcons.Icon20NarrativeOutline,
    24: vkontakteIcons.Icon24NarrativeOutline,
    28: vkontakteIcons.Icon28NarrativeOutline,
    56: vkontakteIcons.Icon56NarrativeOutline,
  },
  nda_outline: {
    20: vkontakteIcons.Icon20NdaOutline,
  },
  newsfeed_slash_outline: {
    20: vkontakteIcons.Icon20NewsfeedSlashOutline,
  },
  notification_outline: {
    20: vkontakteIcons.Icon20NotificationOutline,
    24: vkontakteIcons.Icon24NotificationOutline,
    56: vkontakteIcons.Icon56NotificationOutline,
  },
  notification_slash_outline: {
    20: vkontakteIcons.Icon20NotificationSlashOutline,
    24: vkontakteIcons.Icon24NotificationSlashOutline,
  },
  on_off_outline: {
    20: vkontakteIcons.Icon20OnOffOutline,
    24: vkontakteIcons.Icon24OnOffOutline,
    28: vkontakteIcons.Icon28OnOffOutline,
  },
  pacman_outline: {
    20: vkontakteIcons.Icon20PacmanOutline,
    24: vkontakteIcons.Icon24PacmanOutline,
  },
  paint_roller_outline: {
    20: vkontakteIcons.Icon20PaintRollerOutline,
    24: vkontakteIcons.Icon24PaintRollerOutline,
    28: vkontakteIcons.Icon28PaintRollerOutline,
  },
  pallete_outline: {
    20: vkontakteIcons.Icon20PalleteOutline,
  },
  paw_outline: {
    20: vkontakteIcons.Icon20PawOutline,
    24: vkontakteIcons.Icon24PawOutline,
    28: vkontakteIcons.Icon28PawOutline,
  },
  pen_stack_lock_outline: {
    20: vkontakteIcons.Icon20PenStackLockOutline,
    28: vkontakteIcons.Icon28PenStackLockOutline,
  },
  pen_stack_outline: {
    20: vkontakteIcons.Icon20PenStackOutline,
    28: vkontakteIcons.Icon28PenStackOutline,
  },
  phone_circle_fill_green: {
    20: vkontakteIcons.Icon20PhoneCircleFillGreen,
    28: vkontakteIcons.Icon28PhoneCircleFillGreen,
    56: vkontakteIcons.Icon56PhoneCircleFillGreen,
  },
  phone_down: {
    20: vkontakteIcons.Icon20PhoneDown,
    24: vkontakteIcons.Icon24PhoneDown,
  },
  phone_down_outline: {
    20: vkontakteIcons.Icon20PhoneDownOutline,
    56: vkontakteIcons.Icon56PhoneDownOutline,
  },
  picture_circle_fill_yellow: {
    20: vkontakteIcons.Icon20PictureCircleFillYellow,
  },
  picture_on_square_outline: {
    20: vkontakteIcons.Icon20PictureOnSquareOutline,
  },
  picture_plus_outline: {
    20: vkontakteIcons.Icon20PicturePlusOutline,
    24: vkontakteIcons.Icon24PicturePlusOutline,
    28: vkontakteIcons.Icon28PicturePlusOutline,
  },
  picture_slash_outline: {
    20: vkontakteIcons.Icon20PictureSlashOutline,
  },
  picture_stack: {
    20: vkontakteIcons.Icon20PictureStack,
    28: vkontakteIcons.Icon28PictureStack,
  },
  picture_stack_outline: {
    20: vkontakteIcons.Icon20PictureStackOutline,
    28: vkontakteIcons.Icon28PictureStackOutline,
  },
  pin_dot_outline: {
    20: vkontakteIcons.Icon20PinDotOutline,
    24: vkontakteIcons.Icon24PinDotOutline,
    28: vkontakteIcons.Icon28PinDotOutline,
    56: vkontakteIcons.Icon56PinDotOutline,
  },
  pin_slash_outline: {
    20: vkontakteIcons.Icon20PinSlashOutline,
    24: vkontakteIcons.Icon24PinSlashOutline,
    28: vkontakteIcons.Icon28PinSlashOutline,
  },
  play_circle_fill_steel_gray: {
    20: vkontakteIcons.Icon20PlayCircleFillSteelGray,
  },
  play_circle_fill_steel_red: {
    20: vkontakteIcons.Icon20PlayCircleFillSteelRed,
  },
  play_circle_transparent: {
    20: vkontakteIcons.Icon20PlayCircleTransparent,
  },
  play_rectangle_stack_outline: {
    20: vkontakteIcons.Icon20PlayRectangleStackOutline,
    28: vkontakteIcons.Icon28PlayRectangleStackOutline,
    32: vkontakteIcons.Icon32PlayRectangleStackOutline,
  },
  playlist_outline: {
    20: vkontakteIcons.Icon20PlaylistOutline,
    24: vkontakteIcons.Icon24PlaylistOutline,
    28: vkontakteIcons.Icon28PlaylistOutline,
    36: vkontakteIcons.Icon36PlaylistOutline,
    56: vkontakteIcons.Icon56PlaylistOutline,
  },
  podcast_circle_fill_red: {
    20: vkontakteIcons.Icon20PodcastCircleFillRed,
    28: vkontakteIcons.Icon28PodcastCircleFillRed,
  },
  pointer_outline: {
    20: vkontakteIcons.Icon20PointerOutline,
  },
  poll_circle_fill_green: {
    20: vkontakteIcons.Icon20PollCircleFillGreen,
    28: vkontakteIcons.Icon28PollCircleFillGreen,
  },
  poll_outline: {
    20: vkontakteIcons.Icon20PollOutline,
    24: vkontakteIcons.Icon24PollOutline,
    32: vkontakteIcons.Icon32PollOutline,
    56: vkontakteIcons.Icon56PollOutline,
  },
  printer_outline: {
    20: vkontakteIcons.Icon20PrinterOutline,
    24: vkontakteIcons.Icon24PrinterOutline,
    28: vkontakteIcons.Icon28PrinterOutline,
  },
  privacy_circle_fill_blue: {
    20: vkontakteIcons.Icon20PrivacyCircleFillBlue,
  },
  privacy_circle_fill_red: {
    20: vkontakteIcons.Icon20PrivacyCircleFillRed,
  },
  prometey_circle_fill_red: {
    20: vkontakteIcons.Icon20PrometeyCircleFillRed,
    32: vkontakteIcons.Icon32PrometeyCircleFillRed,
  },
  pulse_outline: {
    20: vkontakteIcons.Icon20PulseOutline,
  },
  qr_code_outline: {
    20: vkontakteIcons.Icon20QrCodeOutline,
    28: vkontakteIcons.Icon28QrCodeOutline,
  },
  question_circle_fill_green: {
    20: vkontakteIcons.Icon20QuestionCircleFillGreen,
  },
  question_circle_fill_violet: {
    20: vkontakteIcons.Icon20QuestionCircleFillViolet,
  },
  question_fill_circle_red: {
    20: vkontakteIcons.Icon20QuestionFillCircleRed,
  },
  question_fill_circle_violet: {
    20: vkontakteIcons.Icon20QuestionFillCircleViolet,
  },
  question_outline: {
    20: vkontakteIcons.Icon20QuestionOutline,
    24: vkontakteIcons.Icon24QuestionOutline,
    28: vkontakteIcons.Icon28QuestionOutline,
    56: vkontakteIcons.Icon56QuestionOutline,
  },
  radio_off: {
    20: vkontakteIcons.Icon20RadioOff,
    24: vkontakteIcons.Icon24RadioOff,
  },
  radio_on: {
    20: vkontakteIcons.Icon20RadioOn,
    24: vkontakteIcons.Icon24RadioOn,
  },
  radiowaves_left_and_right_circle_fill_red: {
    20: vkontakteIcons.Icon20RadiowavesLeftAndRightCircleFillRed,
    28: vkontakteIcons.Icon28RadiowavesLeftAndRightCircleFillRed,
  },
  receipt_outline: {
    20: vkontakteIcons.Icon20ReceiptOutline,
    24: vkontakteIcons.Icon24ReceiptOutline,
    28: vkontakteIcons.Icon28ReceiptOutline,
  },
  recent_circle_fill_yellow: {
    20: vkontakteIcons.Icon20RecentCircleFillYellow,
  },
  recent_outline: {
    20: vkontakteIcons.Icon20RecentOutline,
    24: vkontakteIcons.Icon24RecentOutline,
    28: vkontakteIcons.Icon28RecentOutline,
    56: vkontakteIcons.Icon56RecentOutline,
  },
  recorder_tape_outline: {
    20: vkontakteIcons.Icon20RecorderTapeOutline,
    28: vkontakteIcons.Icon28RecorderTapeOutline,
  },
  rectangle_2_horizontal_outline: {
    20: vkontakteIcons.Icon20Rectangle2HorizontalOutline,
  },
  rectangle_info_outline: {
    20: vkontakteIcons.Icon20RectangleInfoOutline,
  },
  rectangle_line_bottom_left_outline: {
    20: vkontakteIcons.Icon20RectangleLineBottomLeftOutline,
  },
  rectangle_split_4_uneven_outline: {
    20: vkontakteIcons.Icon20RectangleSplit4UnevenOutline,
    24: vkontakteIcons.Icon24RectangleSplit4UnevenOutline,
    28: vkontakteIcons.Icon28RectangleSplit4UnevenOutline,
  },
  refresh_outline: {
    20: vkontakteIcons.Icon20RefreshOutline,
    24: vkontakteIcons.Icon24RefreshOutline,
    28: vkontakteIcons.Icon28RefreshOutline,
  },
  remove_circle_outline: {
    20: vkontakteIcons.Icon20RemoveCircleOutline,
    28: vkontakteIcons.Icon28RemoveCircleOutline,
  },
  reorder: {
    20: vkontakteIcons.Icon20Reorder,
    24: vkontakteIcons.Icon24Reorder,
  },
  replay_15: {
    20: vkontakteIcons.Icon20Replay15,
    24: vkontakteIcons.Icon24Replay15,
    28: vkontakteIcons.Icon28Replay15,
    36: vkontakteIcons.Icon36Replay15,
    48: vkontakteIcons.Icon48Replay15,
  },
  replay_outline: {
    20: vkontakteIcons.Icon20ReplayOutline,
    24: vkontakteIcons.Icon24ReplayOutline,
    28: vkontakteIcons.Icon28ReplayOutline,
  },
  reply_circle_fill_gray: {
    20: vkontakteIcons.Icon20ReplyCircleFillGray,
  },
  reply_circle_fill_green: {
    20: vkontakteIcons.Icon20ReplyCircleFillGreen,
    28: vkontakteIcons.Icon28ReplyCircleFillGreen,
  },
  repost_circle_fill_green: {
    20: vkontakteIcons.Icon20RepostCircleFillGreen,
    28: vkontakteIcons.Icon28RepostCircleFillGreen,
  },
  rotate_left: {
    20: vkontakteIcons.Icon20RotateLeft,
  },
  rotate_right: {
    20: vkontakteIcons.Icon20RotateRight,
  },
  rss_circle_fill_black: {
    20: vkontakteIcons.Icon20RssCircleFillBlack,
    28: vkontakteIcons.Icon28RssCircleFillBlack,
  },
  rss_circle_fill_yellow: {
    20: vkontakteIcons.Icon20RssCircleFillYellow,
    28: vkontakteIcons.Icon28RssCircleFillYellow,
  },
  scan_viewfinder_outline: {
    20: vkontakteIcons.Icon20ScanViewfinderOutline,
    24: vkontakteIcons.Icon24ScanViewfinderOutline,
    28: vkontakteIcons.Icon28ScanViewfinderOutline,
  },
  scissors_outline: {
    20: vkontakteIcons.Icon20ScissorsOutline,
    28: vkontakteIcons.Icon28ScissorsOutline,
  },
  send_outline: {
    20: vkontakteIcons.Icon20SendOutline,
    24: vkontakteIcons.Icon24SendOutline,
    28: vkontakteIcons.Icon28SendOutline,
  },
  services_circle_fill_blue: {
    20: vkontakteIcons.Icon20ServicesCircleFillBlue,
    28: vkontakteIcons.Icon28ServicesCircleFillBlue,
  },
  services_circle_fill_yellow: {
    20: vkontakteIcons.Icon20ServicesCircleFillYellow,
    28: vkontakteIcons.Icon28ServicesCircleFillYellow,
  },
  services_filled: {
    20: vkontakteIcons.Icon20ServicesFilled,
  },
  share_external_android: {
    20: vkontakteIcons.Icon20ShareExternalAndroid,
  },
  share_external_outline: {
    20: vkontakteIcons.Icon20ShareExternalOutline,
    24: vkontakteIcons.Icon24ShareExternalOutline,
    28: vkontakteIcons.Icon28ShareExternalOutline,
  },
  shield_line_outline: {
    20: vkontakteIcons.Icon20ShieldLineOutline,
  },
  signature_outline: {
    20: vkontakteIcons.Icon20SignatureOutline,
    24: vkontakteIcons.Icon24SignatureOutline,
    28: vkontakteIcons.Icon28SignatureOutline,
  },
  skip_back: {
    20: vkontakteIcons.Icon20SkipBack,
    24: vkontakteIcons.Icon24SkipBack,
    28: vkontakteIcons.Icon28SkipBack,
    36: vkontakteIcons.Icon36SkipBack,
    48: vkontakteIcons.Icon48SkipBack,
  },
  skip_circle_fill_gray: {
    20: vkontakteIcons.Icon20SkipCircleFillGray,
  },
  skip_right_outline: {
    20: vkontakteIcons.Icon20SkipRightOutline,
  },
  skirt_outline: {
    20: vkontakteIcons.Icon20SkirtOutline,
    24: vkontakteIcons.Icon24SkirtOutline,
    28: vkontakteIcons.Icon28SkirtOutline,
  },
  skull_outline: {
    20: vkontakteIcons.Icon20SkullOutline,
    24: vkontakteIcons.Icon24SkullOutline,
  },
  smartphone_outline: {
    20: vkontakteIcons.Icon20SmartphoneOutline,
    24: vkontakteIcons.Icon24SmartphoneOutline,
    28: vkontakteIcons.Icon28SmartphoneOutline,
    56: vkontakteIcons.Icon56SmartphoneOutline,
  },
  smile_outline: {
    20: vkontakteIcons.Icon20SmileOutline,
    24: vkontakteIcons.Icon24SmileOutline,
    28: vkontakteIcons.Icon28SmileOutline,
    36: vkontakteIcons.Icon36SmileOutline,
    44: vkontakteIcons.Icon44SmileOutline,
    56: vkontakteIcons.Icon56SmileOutline,
  },
  song_circle_fill_violet: {
    20: vkontakteIcons.Icon20SongCircleFillViolet,
    28: vkontakteIcons.Icon28SongCircleFillViolet,
  },
  song_outline: {
    20: vkontakteIcons.Icon20SongOutline,
    24: vkontakteIcons.Icon24SongOutline,
    28: vkontakteIcons.Icon28SongOutline,
    32: vkontakteIcons.Icon32SongOutline,
    36: vkontakteIcons.Icon36SongOutline,
    56: vkontakteIcons.Icon56SongOutline,
  },
  sparkle_outline: {
    20: vkontakteIcons.Icon20SparkleOutline,
    28: vkontakteIcons.Icon28SparkleOutline,
  },
  square_4_plus_outline: {
    20: vkontakteIcons.Icon20Square4PlusOutline,
    24: vkontakteIcons.Icon24Square4PlusOutline,
    28: vkontakteIcons.Icon28Square4PlusOutline,
  },
  square_4_slash_outline: {
    20: vkontakteIcons.Icon20Square4SlashOutline,
    24: vkontakteIcons.Icon24Square4SlashOutline,
    28: vkontakteIcons.Icon28Square4SlashOutline,
  },
  square_split_3_horizontal_outline: {
    20: vkontakteIcons.Icon20SquareSplit3HorizontalOutline,
    24: vkontakteIcons.Icon24SquareSplit3HorizontalOutline,
    28: vkontakteIcons.Icon28SquareSplit3HorizontalOutline,
  },
  square_split_4_outline: {
    20: vkontakteIcons.Icon20SquareSplit4Outline,
    24: vkontakteIcons.Icon24SquareSplit4Outline,
    28: vkontakteIcons.Icon28SquareSplit4Outline,
  },
  square_stack_up_outline: {
    20: vkontakteIcons.Icon20SquareStackUpOutline,
    24: vkontakteIcons.Icon24SquareStackUpOutline,
    28: vkontakteIcons.Icon28SquareStackUpOutline,
    56: vkontakteIcons.Icon56SquareStackUpOutline,
  },
  squareshape_9_grid_outline: {
    20: vkontakteIcons.Icon20Squareshape9GridOutline,
  },
  stars_circle_fill_violet: {
    20: vkontakteIcons.Icon20StarsCircleFillViolet,
    28: vkontakteIcons.Icon28StarsCircleFillViolet,
    32: vkontakteIcons.Icon32StarsCircleFillViolet,
    48: vkontakteIcons.Icon48StarsCircleFillViolet,
  },
  stars_filled: {
    20: vkontakteIcons.Icon20StarsFilled,
  },
  stars_slash_outline: {
    20: vkontakteIcons.Icon20StarsSlashOutline,
    28: vkontakteIcons.Icon28StarsSlashOutline,
  },
  statistic_circle_fill_blue: {
    20: vkontakteIcons.Icon20StatisticCircleFillBlue,
    28: vkontakteIcons.Icon28StatisticCircleFillBlue,
  },
  statistics_outline: {
    20: vkontakteIcons.Icon20StatisticsOutline,
    24: vkontakteIcons.Icon24StatisticsOutline,
    28: vkontakteIcons.Icon28StatisticsOutline,
    56: vkontakteIcons.Icon56StatisticsOutline,
  },
  sticker_outline: {
    20: vkontakteIcons.Icon20StickerOutline,
    24: vkontakteIcons.Icon24StickerOutline,
    28: vkontakteIcons.Icon28StickerOutline,
    56: vkontakteIcons.Icon56StickerOutline,
  },
  sticker_smile_outline: {
    20: vkontakteIcons.Icon20StickerSmileOutline,
    24: vkontakteIcons.Icon24StickerSmileOutline,
    28: vkontakteIcons.Icon28StickerSmileOutline,
  },
  story_add_outline: {
    20: vkontakteIcons.Icon20StoryAddOutline,
    28: vkontakteIcons.Icon28StoryAddOutline,
  },
  story_fill_circle_red: {
    20: vkontakteIcons.Icon20StoryFillCircleRed,
    28: vkontakteIcons.Icon28StoryFillCircleRed,
  },
  story_fill_circle_yellow: {
    20: vkontakteIcons.Icon20StoryFillCircleYellow,
  },
  story_reply_circle_fill_violet: {
    20: vkontakteIcons.Icon20StoryReplyCircleFillViolet,
    28: vkontakteIcons.Icon28StoryReplyCircleFillViolet,
  },
  story_slash_outline: {
    20: vkontakteIcons.Icon20StorySlashOutline,
  },
  strip_circle_fill_red: {
    20: vkontakteIcons.Icon20StripCircleFillRed,
  },
  subtitles_outline: {
    20: vkontakteIcons.Icon20SubtitlesOutline,
    24: vkontakteIcons.Icon24SubtitlesOutline,
    28: vkontakteIcons.Icon28SubtitlesOutline,
  },
  sun_outline: {
    20: vkontakteIcons.Icon20SunOutline,
    24: vkontakteIcons.Icon24SunOutline,
    28: vkontakteIcons.Icon28SunOutline,
  },
  tab_add_outline: {
    20: vkontakteIcons.Icon20TabAddOutline,
  },
  table_header_outline: {
    20: vkontakteIcons.Icon20TableHeaderOutline,
  },
  tag_outline: {
    20: vkontakteIcons.Icon20TagOutline,
    24: vkontakteIcons.Icon24TagOutline,
    28: vkontakteIcons.Icon28TagOutline,
    56: vkontakteIcons.Icon56TagOutline,
  },
  target_outline: {
    20: vkontakteIcons.Icon20TargetOutline,
    24: vkontakteIcons.Icon24TargetOutline,
    28: vkontakteIcons.Icon28TargetOutline,
  },
  test_coin_outline: {
    20: vkontakteIcons.Icon20TestCoinOutline,
  },
  text_accent_mark_outline: {
    20: vkontakteIcons.Icon20TextAccentMarkOutline,
  },
  text_heading_1_outline: {
    20: vkontakteIcons.Icon20TextHeading1Outline,
    24: vkontakteIcons.Icon24TextHeading1Outline,
  },
  text_heading_2_outline: {
    20: vkontakteIcons.Icon20TextHeading2Outline,
    24: vkontakteIcons.Icon24TextHeading2Outline,
  },
  text_live_circle_fill_green: {
    20: vkontakteIcons.Icon20TextLiveCircleFillGreen,
    28: vkontakteIcons.Icon28TextLiveCircleFillGreen,
  },
  text_live_outline: {
    20: vkontakteIcons.Icon20TextLiveOutline,
    24: vkontakteIcons.Icon24TextLiveOutline,
    28: vkontakteIcons.Icon28TextLiveOutline,
    56: vkontakteIcons.Icon56TextLiveOutline,
  },
  text_tt_outline: {
    20: vkontakteIcons.Icon20TextTtOutline,
    24: vkontakteIcons.Icon24TextTtOutline,
  },
  thermometer_outline: {
    20: vkontakteIcons.Icon20ThermometerOutline,
    24: vkontakteIcons.Icon24ThermometerOutline,
  },
  thumbs_down: {
    20: vkontakteIcons.Icon20ThumbsDown,
    24: vkontakteIcons.Icon24ThumbsDown,
    28: vkontakteIcons.Icon28ThumbsDown,
  },
  thumbs_up: {
    20: vkontakteIcons.Icon20ThumbsUp,
    24: vkontakteIcons.Icon24ThumbsUp,
    28: vkontakteIcons.Icon28ThumbsUp,
  },
  thumbs_up_circle_fill_green: {
    20: vkontakteIcons.Icon20ThumbsUpCircleFillGreen,
    28: vkontakteIcons.Icon28ThumbsUpCircleFillGreen,
  },
  touch_id_outline: {
    20: vkontakteIcons.Icon20TouchIdOutline,
    28: vkontakteIcons.Icon28TouchIdOutline,
    56: vkontakteIcons.Icon56TouchIdOutline,
  },
  traffic_cone_outline: {
    20: vkontakteIcons.Icon20TrafficConeOutline,
    28: vkontakteIcons.Icon28TrafficConeOutline,
  },
  transparency_outline: {
    20: vkontakteIcons.Icon20TransparencyOutline,
  },
  trash_simple_outline: {
    20: vkontakteIcons.Icon20TrashSimpleOutline,
    24: vkontakteIcons.Icon24TrashSimpleOutline,
  },
  trash_smile_outline: {
    20: vkontakteIcons.Icon20TrashSmileOutline,
    24: vkontakteIcons.Icon24TrashSmileOutline,
  },
  tshirt_outline: {
    20: vkontakteIcons.Icon20TshirtOutline,
    24: vkontakteIcons.Icon24TshirtOutline,
    28: vkontakteIcons.Icon28TshirtOutline,
  },
  tv_outline: {
    20: vkontakteIcons.Icon20TvOutline,
    24: vkontakteIcons.Icon24TvOutline,
    28: vkontakteIcons.Icon28TvOutline,
  },
  tv_text_outline: {
    20: vkontakteIcons.Icon20TvTextOutline,
  },
  uma_outline: {
    20: vkontakteIcons.Icon20UmaOutline,
  },
  umbrella_outline: {
    20: vkontakteIcons.Icon20UmbrellaOutline,
  },
  unarchive_outline: {
    20: vkontakteIcons.Icon20UnarchiveOutline,
    24: vkontakteIcons.Icon24UnarchiveOutline,
    28: vkontakteIcons.Icon28UnarchiveOutline,
  },
  user_add_outline: {
    20: vkontakteIcons.Icon20UserAddOutline,
    24: vkontakteIcons.Icon24UserAddOutline,
    28: vkontakteIcons.Icon28UserAddOutline,
    56: vkontakteIcons.Icon56UserAddOutline,
  },
  user_book_outline: {
    20: vkontakteIcons.Icon20UserBookOutline,
    56: vkontakteIcons.Icon56UserBookOutline,
  },
  user_circle_fill_blue: {
    20: vkontakteIcons.Icon20UserCircleFillBlue,
    28: vkontakteIcons.Icon28UserCircleFillBlue,
    32: vkontakteIcons.Icon32UserCircleFillBlue,
    56: vkontakteIcons.Icon56UserCircleFillBlue,
  },
  user_circle_outline: {
    20: vkontakteIcons.Icon20UserCircleOutline,
    24: vkontakteIcons.Icon24UserCircleOutline,
    28: vkontakteIcons.Icon28UserCircleOutline,
    36: vkontakteIcons.Icon36UserCircleOutline,
    56: vkontakteIcons.Icon56UserCircleOutline,
  },
  user_gear_outline: {
    20: vkontakteIcons.Icon20UserGearOutline,
  },
  user_microphone_badge_outline: {
    20: vkontakteIcons.Icon20UserMicrophoneBadgeOutline,
    24: vkontakteIcons.Icon24UserMicrophoneBadgeOutline,
    28: vkontakteIcons.Icon28UserMicrophoneBadgeOutline,
    56: vkontakteIcons.Icon56UserMicrophoneBadgeOutline,
  },
  user_microphone_badge_slash_outline: {
    20: vkontakteIcons.Icon20UserMicrophoneBadgeSlashOutline,
    28: vkontakteIcons.Icon28UserMicrophoneBadgeSlashOutline,
  },
  user_pen_outline: {
    20: vkontakteIcons.Icon20UserPenOutline,
    24: vkontakteIcons.Icon24UserPenOutline,
    28: vkontakteIcons.Icon28UserPenOutline,
  },
  user_rectangle: {
    20: vkontakteIcons.Icon20UserRectangle,
  },
  user_reply_outline: {
    20: vkontakteIcons.Icon20UserReplyOutline,
  },
  user_slash_outline: {
    20: vkontakteIcons.Icon20UserSlashOutline,
    24: vkontakteIcons.Icon24UserSlashOutline,
    28: vkontakteIcons.Icon28UserSlashOutline,
    36: vkontakteIcons.Icon36UserSlashOutline,
  },
  user_square: {
    20: vkontakteIcons.Icon20UserSquare,
    24: vkontakteIcons.Icon24UserSquare,
  },
  user_square_on_square_outline: {
    20: vkontakteIcons.Icon20UserSquareOnSquareOutline,
    24: vkontakteIcons.Icon24UserSquareOnSquareOutline,
    28: vkontakteIcons.Icon28UserSquareOnSquareOutline,
    32: vkontakteIcons.Icon32UserSquareOnSquareOutline,
    56: vkontakteIcons.Icon56UserSquareOnSquareOutline,
  },
  user_star_badge_outline: {
    20: vkontakteIcons.Icon20UserStarBadgeOutline,
    28: vkontakteIcons.Icon28UserStarBadgeOutline,
  },
  user_star_badge_slash_outline: {
    20: vkontakteIcons.Icon20UserStarBadgeSlashOutline,
    28: vkontakteIcons.Icon28UserStarBadgeSlashOutline,
  },
  user_star_outline: {
    20: vkontakteIcons.Icon20UserStarOutline,
    28: vkontakteIcons.Icon28UserStarOutline,
  },
  user_tag_outline: {
    20: vkontakteIcons.Icon20UserTagOutline,
    24: vkontakteIcons.Icon24UserTagOutline,
    28: vkontakteIcons.Icon28UserTagOutline,
  },
  users_3: {
    20: vkontakteIcons.Icon20Users3,
    28: vkontakteIcons.Icon28Users3,
    36: vkontakteIcons.Icon36Users3,
  },
  users_3_circle_fill_blue: {
    20: vkontakteIcons.Icon20Users3CircleFillBlue,
    28: vkontakteIcons.Icon28Users3CircleFillBlue,
  },
  users_3_outline: {
    20: vkontakteIcons.Icon20Users3Outline,
    24: vkontakteIcons.Icon24Users3Outline,
    28: vkontakteIcons.Icon28Users3Outline,
    36: vkontakteIcons.Icon36Users3Outline,
    56: vkontakteIcons.Icon56Users3Outline,
  },
  users_circle_fill_blue: {
    20: vkontakteIcons.Icon20UsersCircleFillBlue,
    28: vkontakteIcons.Icon28UsersCircleFillBlue,
    32: vkontakteIcons.Icon32UsersCircleFillBlue,
  },
  users_outline: {
    20: vkontakteIcons.Icon20UsersOutline,
    24: vkontakteIcons.Icon24UsersOutline,
    28: vkontakteIcons.Icon28UsersOutline,
    56: vkontakteIcons.Icon56UsersOutline,
  },
  users_slash_outline: {
    20: vkontakteIcons.Icon20UsersSlashOutline,
  },
  vertical_rectangle_outline: {
    20: vkontakteIcons.Icon20VerticalRectangleOutline,
    24: vkontakteIcons.Icon24VerticalRectangleOutline,
  },
  video_add_square_outline: {
    20: vkontakteIcons.Icon20VideoAddSquareOutline,
    24: vkontakteIcons.Icon24VideoAddSquareOutline,
    28: vkontakteIcons.Icon28VideoAddSquareOutline,
  },
  video_camera_circle_fill_red: {
    20: vkontakteIcons.Icon20VideoCameraCircleFillRed,
    28: vkontakteIcons.Icon28VideoCameraCircleFillRed,
  },
  video_circle_outline: {
    20: vkontakteIcons.Icon20VideoCircleOutline,
    24: vkontakteIcons.Icon24VideoCircleOutline,
    28: vkontakteIcons.Icon28VideoCircleOutline,
    56: vkontakteIcons.Icon56VideoCircleOutline,
  },
  video_outline: {
    20: vkontakteIcons.Icon20VideoOutline,
    24: vkontakteIcons.Icon24VideoOutline,
    28: vkontakteIcons.Icon28VideoOutline,
    36: vkontakteIcons.Icon36VideoOutline,
    56: vkontakteIcons.Icon56VideoOutline,
  },
  videocam_slash_outline: {
    20: vkontakteIcons.Icon20VideocamSlashOutline,
    28: vkontakteIcons.Icon28VideocamSlashOutline,
    56: vkontakteIcons.Icon56VideocamSlashOutline,
  },
  view_circle_fill_red: {
    20: vkontakteIcons.Icon20ViewCircleFillRed,
  },
  vinyl_outline: {
    20: vkontakteIcons.Icon20VinylOutline,
    24: vkontakteIcons.Icon24VinylOutline,
    28: vkontakteIcons.Icon28VinylOutline,
    36: vkontakteIcons.Icon36VinylOutline,
    56: vkontakteIcons.Icon56VinylOutline,
  },
  virus_outline: {
    20: vkontakteIcons.Icon20VirusOutline,
  },
  vk_video_circle_fill_red: {
    20: vkontakteIcons.Icon20VkVideoCircleFillRed,
    28: vkontakteIcons.Icon28VkVideoCircleFillRed,
  },
  voice: {
    20: vkontakteIcons.Icon20Voice,
    24: vkontakteIcons.Icon24Voice,
    28: vkontakteIcons.Icon28Voice,
  },
  voice_outline: {
    20: vkontakteIcons.Icon20VoiceOutline,
    24: vkontakteIcons.Icon24VoiceOutline,
    28: vkontakteIcons.Icon28VoiceOutline,
  },
  voice_slash_outline: {
    20: vkontakteIcons.Icon20VoiceSlashOutline,
  },
  volume_centered_outline: {
    20: vkontakteIcons.Icon20VolumeCenteredOutline,
  },
  volume_outline: {
    20: vkontakteIcons.Icon20VolumeOutline,
    24: vkontakteIcons.Icon24VolumeOutline,
    28: vkontakteIcons.Icon28VolumeOutline,
  },
  votes_circle_fill_blue: {
    20: vkontakteIcons.Icon20VotesCircleFillBlue,
  },
  votest_transfer_circle_fill_turquoise: {
    20: vkontakteIcons.Icon20VotestTransferCircleFillTurquoise,
  },
  washer_outline: {
    20: vkontakteIcons.Icon20WasherOutline,
    24: vkontakteIcons.Icon24WasherOutline,
    28: vkontakteIcons.Icon28WasherOutline,
  },
  water_drop_outline: {
    20: vkontakteIcons.Icon20WaterDropOutline,
    24: vkontakteIcons.Icon24WaterDropOutline,
    28: vkontakteIcons.Icon28WaterDropOutline,
  },
  wheel_outline: {
    20: vkontakteIcons.Icon20WheelOutline,
    24: vkontakteIcons.Icon24WheelOutline,
    28: vkontakteIcons.Icon28WheelOutline,
  },
  widgets_outline: {
    20: vkontakteIcons.Icon20WidgetsOutline,
    28: vkontakteIcons.Icon28WidgetsOutline,
  },
  wind_outline: {
    20: vkontakteIcons.Icon20WindOutline,
  },
  wineglass_outline: {
    20: vkontakteIcons.Icon20WineglassOutline,
    24: vkontakteIcons.Icon24WineglassOutline,
    28: vkontakteIcons.Icon28WineglassOutline,
  },
  write: {
    20: vkontakteIcons.Icon20Write,
    24: vkontakteIcons.Icon24Write,
    28: vkontakteIcons.Icon28Write,
    32: vkontakteIcons.Icon32Write,
  },
  write_outline: {
    20: vkontakteIcons.Icon20WriteOutline,
    24: vkontakteIcons.Icon24WriteOutline,
    28: vkontakteIcons.Icon28WriteOutline,
    56: vkontakteIcons.Icon56WriteOutline,
  },
  write_square_outline: {
    20: vkontakteIcons.Icon20WriteSquareOutline,
    28: vkontakteIcons.Icon28WriteSquareOutline,
  },
  yuan_outline: {
    20: vkontakteIcons.Icon20YuanOutline,
  },
  zip_outline: {
    20: vkontakteIcons.Icon20ZipOutline,
    28: vkontakteIcons.Icon28ZipOutline,
  },
  zodiac_aquarius_outline: {
    20: vkontakteIcons.Icon20ZodiacAquariusOutline,
  },
  zodiac_aries_outline: {
    20: vkontakteIcons.Icon20ZodiacAriesOutline,
  },
  zodiac_cancer_outline: {
    20: vkontakteIcons.Icon20ZodiacCancerOutline,
  },
  zodiac_capricorn_outline: {
    20: vkontakteIcons.Icon20ZodiacCapricornOutline,
  },
  zodiac_gemini_outline: {
    20: vkontakteIcons.Icon20ZodiacGeminiOutline,
    24: vkontakteIcons.Icon24ZodiacGeminiOutline,
    28: vkontakteIcons.Icon28ZodiacGeminiOutline,
  },
  zodiac_leo_outline: {
    20: vkontakteIcons.Icon20ZodiacLeoOutline,
  },
  zodiac_libra_outline: {
    20: vkontakteIcons.Icon20ZodiacLibraOutline,
  },
  zodiac_pisces_outline: {
    20: vkontakteIcons.Icon20ZodiacPiscesOutline,
  },
  zodiac_sagittarius_outline: {
    20: vkontakteIcons.Icon20ZodiacSagittariusOutline,
  },
  zodiac_scorpio_outline: {
    20: vkontakteIcons.Icon20ZodiacScorpioOutline,
  },
  zodiac_taurus_outline: {
    20: vkontakteIcons.Icon20ZodiacTaurusOutline,
  },
  zodiac_virgo_outline: {
    20: vkontakteIcons.Icon20ZodiacVirgoOutline,
  },
  '0_circle_outline': {
    24: vkontakteIcons.Icon240CircleOutline,
  },
  '16_circle_outline': {
    24: vkontakteIcons.Icon2416CircleOutline,
    56: vkontakteIcons.Icon5616CircleOutline,
  },
  '18_circle_outline': {
    24: vkontakteIcons.Icon2418CircleOutline,
    28: vkontakteIcons.Icon2818CircleOutline,
    32: vkontakteIcons.Icon3218CircleOutline,
    56: vkontakteIcons.Icon5618CircleOutline,
  },
  '3_square_outline': {
    24: vkontakteIcons.Icon243SquareOutline,
  },
  add_awards_outline: {
    24: vkontakteIcons.Icon24AddAwardsOutline,
  },
  add_braces_outline: {
    24: vkontakteIcons.Icon24AddBracesOutline,
  },
  add_circle_dotted_outline: {
    24: vkontakteIcons.Icon24AddCircleDottedOutline,
  },
  add_outline: {
    24: vkontakteIcons.Icon24AddOutline,
    28: vkontakteIcons.Icon28AddOutline,
    48: vkontakteIcons.Icon48AddOutline,
  },
  airplay: {
    24: vkontakteIcons.Icon24Airplay,
  },
  airplay_video_outline: {
    24: vkontakteIcons.Icon24AirplayVideoOutline,
    28: vkontakteIcons.Icon28AirplayVideoOutline,
  },
  arrow_down_to_square_outline: {
    24: vkontakteIcons.Icon24ArrowDownToSquareOutline,
    28: vkontakteIcons.Icon28ArrowDownToSquareOutline,
  },
  arrow_enter_square_outline: {
    24: vkontakteIcons.Icon24ArrowEnterSquareOutline,
  },
  arrow_left_right_lines_vertical_outline: {
    24: vkontakteIcons.Icon24ArrowLeftRightLinesVerticalOutline,
  },
  arrow_left_square_outline: {
    24: vkontakteIcons.Icon24ArrowLeftSquareOutline,
  },
  arrow_right_circle_outline: {
    24: vkontakteIcons.Icon24ArrowRightCircleOutline,
    28: vkontakteIcons.Icon28ArrowRightCircleOutline,
  },
  arrow_turn_left_outline: {
    24: vkontakteIcons.Icon24ArrowTurnLeftOutline,
  },
  arrow_up_down_corners_outline: {
    24: vkontakteIcons.Icon24ArrowUpDownCornersOutline,
  },
  arrow_up_right_corner_outline: {
    24: vkontakteIcons.Icon24ArrowUpRightCornerOutline,
  },
  arrow_up_right_outline: {
    24: vkontakteIcons.Icon24ArrowUpRightOutline,
  },
  article: {
    24: vkontakteIcons.Icon24Article,
    36: vkontakteIcons.Icon36Article,
  },
  artist: {
    24: vkontakteIcons.Icon24Artist,
  },
  attachments: {
    24: vkontakteIcons.Icon24Attachments,
    28: vkontakteIcons.Icon28Attachments,
  },
  back: {
    24: vkontakteIcons.Icon24Back,
  },
  ball_outline: {
    24: vkontakteIcons.Icon24BallOutline,
  },
  bank_outline: {
    24: vkontakteIcons.Icon24BankOutline,
    28: vkontakteIcons.Icon28BankOutline,
  },
  bidy_outline: {
    24: vkontakteIcons.Icon24BidyOutline,
  },
  billhead_outline: {
    24: vkontakteIcons.Icon24BillheadOutline,
    28: vkontakteIcons.Icon28BillheadOutline,
  },
  bluetooth_outline: {
    24: vkontakteIcons.Icon24BluetoothOutline,
    28: vkontakteIcons.Icon28BluetoothOutline,
  },
  blur_outline: {
    24: vkontakteIcons.Icon24BlurOutline,
  },
  bookmark_add_badge_outline: {
    24: vkontakteIcons.Icon24BookmarkAddBadgeOutline,
  },
  bookmark_check_badge: {
    24: vkontakteIcons.Icon24BookmarkCheckBadge,
  },
  bookmark_check_outline: {
    24: vkontakteIcons.Icon24BookmarkCheckOutline,
    28: vkontakteIcons.Icon28BookmarkCheckOutline,
  },
  books_outline: {
    24: vkontakteIcons.Icon24BooksOutline,
  },
  bowl_sticks_outline: {
    24: vkontakteIcons.Icon24BowlSticksOutline,
  },
  boxing_glove_outline: {
    24: vkontakteIcons.Icon24BoxingGloveOutline,
  },
  brain_outline: {
    24: vkontakteIcons.Icon24BrainOutline,
    28: vkontakteIcons.Icon28BrainOutline,
  },
  briefcase_outline: {
    24: vkontakteIcons.Icon24BriefcaseOutline,
    28: vkontakteIcons.Icon28BriefcaseOutline,
  },
  broadcast: {
    24: vkontakteIcons.Icon24Broadcast,
  },
  broadcast_outline: {
    24: vkontakteIcons.Icon24BroadcastOutline,
  },
  broom: {
    24: vkontakteIcons.Icon24Broom,
  },
  browser_back: {
    24: vkontakteIcons.Icon24BrowserBack,
  },
  browser_forward: {
    24: vkontakteIcons.Icon24BrowserForward,
  },
  bug: {
    24: vkontakteIcons.Icon24Bug,
  },
  cactus_outline: {
    24: vkontakteIcons.Icon24CactusOutline,
  },
  calendar_add_outline: {
    24: vkontakteIcons.Icon24CalendarAddOutline,
    28: vkontakteIcons.Icon28CalendarAddOutline,
  },
  chat_wave_outline_gray: {
    24: vkontakteIcons.Icon24ChatWaveOutlineGray,
    28: vkontakteIcons.Icon28ChatWaveOutlineGray,
  },
  chats: {
    24: vkontakteIcons.Icon24Chats,
  },
  check_box_indeterminate: {
    24: vkontakteIcons.Icon24CheckBoxIndeterminate,
  },
  check_circle_filled_blue: {
    24: vkontakteIcons.Icon24CheckCircleFilledBlue,
  },
  chef_hat_outline: {
    24: vkontakteIcons.Icon24ChefHatOutline,
    28: vkontakteIcons.Icon28ChefHatOutline,
  },
  chevron_compact_left: {
    24: vkontakteIcons.Icon24ChevronCompactLeft,
  },
  chevron_compact_right: {
    24: vkontakteIcons.Icon24ChevronCompactRight,
  },
  chevron_down: {
    24: vkontakteIcons.Icon24ChevronDown,
  },
  chevron_left_small_outline: {
    24: vkontakteIcons.Icon24ChevronLeftSmallOutline,
  },
  chevron_left_square_outline: {
    24: vkontakteIcons.Icon24ChevronLeftSquareOutline,
  },
  chevron_right_circle: {
    24: vkontakteIcons.Icon24ChevronRightCircle,
    28: vkontakteIcons.Icon28ChevronRightCircle,
  },
  chevron_right_small_outline: {
    24: vkontakteIcons.Icon24ChevronRightSmallOutline,
  },
  chevron_right_square_outline: {
    24: vkontakteIcons.Icon24ChevronRightSquareOutline,
  },
  circle_dashed_outline: {
    24: vkontakteIcons.Icon24CircleDashedOutline,
  },
  clip_outline: {
    24: vkontakteIcons.Icon24ClipOutline,
    28: vkontakteIcons.Icon28ClipOutline,
  },
  clock_add_outline: {
    24: vkontakteIcons.Icon24ClockAddOutline,
  },
  clock_check_outline: {
    24: vkontakteIcons.Icon24ClockCheckOutline,
  },
  clock_circle_dashed_outline: {
    24: vkontakteIcons.Icon24ClockCircleDashedOutline,
    28: vkontakteIcons.Icon28ClockCircleDashedOutline,
    56: vkontakteIcons.Icon56ClockCircleDashedOutline,
  },
  clock_circle_fill_gray: {
    24: vkontakteIcons.Icon24ClockCircleFillGray,
    28: vkontakteIcons.Icon28ClockCircleFillGray,
  },
  clock_lock_outline: {
    24: vkontakteIcons.Icon24ClockLockOutline,
  },
  color_correction: {
    24: vkontakteIcons.Icon24ColorCorrection,
  },
  comment_alt: {
    24: vkontakteIcons.Icon24CommentAlt,
  },
  contrast_outline: {
    24: vkontakteIcons.Icon24ContrastOutline,
  },
  copy: {
    24: vkontakteIcons.Icon24Copy,
  },
  cross_shield_outline: {
    24: vkontakteIcons.Icon24CrossShieldOutline,
  },
  crown_outline: {
    24: vkontakteIcons.Icon24CrownOutline,
    28: vkontakteIcons.Icon28CrownOutline,
  },
  data_saver_circle_fill_green: {
    24: vkontakteIcons.Icon24DataSaverCircleFillGreen,
  },
  deepfake_outline: {
    24: vkontakteIcons.Icon24DeepfakeOutline,
  },
  delete_arrow_up_outline: {
    24: vkontakteIcons.Icon24DeleteArrowUpOutline,
  },
  delete_saved_outline: {
    24: vkontakteIcons.Icon24DeleteSavedOutline,
    28: vkontakteIcons.Icon28DeleteSavedOutline,
    56: vkontakteIcons.Icon56DeleteSavedOutline,
  },
  dice_5_outline: {
    24: vkontakteIcons.Icon24Dice5Outline,
    28: vkontakteIcons.Icon28Dice5Outline,
  },
  discussions: {
    24: vkontakteIcons.Icon24Discussions,
    32: vkontakteIcons.Icon32Discussions,
  },
  dismiss: {
    24: vkontakteIcons.Icon24Dismiss,
    28: vkontakteIcons.Icon28Dismiss,
  },
  dismiss_overlay: {
    24: vkontakteIcons.Icon24DismissOverlay,
  },
  dismiss_substract: {
    24: vkontakteIcons.Icon24DismissSubstract,
    28: vkontakteIcons.Icon28DismissSubstract,
  },
  do_not_disturb: {
    24: vkontakteIcons.Icon24DoNotDisturb,
  },
  document: {
    24: vkontakteIcons.Icon24Document,
    28: vkontakteIcons.Icon28Document,
    32: vkontakteIcons.Icon32Document,
    36: vkontakteIcons.Icon36Document,
  },
  dollar_circle_outline: {
    24: vkontakteIcons.Icon24DollarCircleOutline,
  },
  done_outline: {
    24: vkontakteIcons.Icon24DoneOutline,
    28: vkontakteIcons.Icon28DoneOutline,
    32: vkontakteIcons.Icon32DoneOutline,
    36: vkontakteIcons.Icon36DoneOutline,
  },
  door_arrow_left_outline: {
    24: vkontakteIcons.Icon24DoorArrowLeftOutline,
    28: vkontakteIcons.Icon28DoorArrowLeftOutline,
  },
  download_cross_badge_outline: {
    24: vkontakteIcons.Icon24DownloadCrossBadgeOutline,
  },
  download_error_outline: {
    24: vkontakteIcons.Icon24DownloadErrorOutline,
    28: vkontakteIcons.Icon28DownloadErrorOutline,
  },
  drag_reorder_outline: {
    24: vkontakteIcons.Icon24DragReorderOutline,
    28: vkontakteIcons.Icon28DragReorderOutline,
  },
  drill_outline: {
    24: vkontakteIcons.Icon24DrillOutline,
    28: vkontakteIcons.Icon28DrillOutline,
  },
  drops_outline: {
    24: vkontakteIcons.Icon24DropsOutline,
  },
  dumbbells_outline: {
    24: vkontakteIcons.Icon24DumbbellsOutline,
    28: vkontakteIcons.Icon28DumbbellsOutline,
  },
  employee_outline: {
    24: vkontakteIcons.Icon24EmployeeOutline,
    28: vkontakteIcons.Icon28EmployeeOutline,
  },
  error: {
    24: vkontakteIcons.Icon24Error,
  },
  eternal_flame_outline: {
    24: vkontakteIcons.Icon24EternalFlameOutline,
    28: vkontakteIcons.Icon28EternalFlameOutline,
  },
  exposition_outline: {
    24: vkontakteIcons.Icon24ExpositionOutline,
  },
  external_link_outline: {
    24: vkontakteIcons.Icon24ExternalLinkOutline,
  },
  film_strip_add_outline: {
    24: vkontakteIcons.Icon24FilmStripAddOutline,
    28: vkontakteIcons.Icon28FilmStripAddOutline,
  },
  filter: {
    24: vkontakteIcons.Icon24Filter,
  },
  flapper_outline: {
    24: vkontakteIcons.Icon24FlapperOutline,
  },
  folder: {
    24: vkontakteIcons.Icon24Folder,
    32: vkontakteIcons.Icon32Folder,
  },
  folder_add: {
    24: vkontakteIcons.Icon24FolderAdd,
  },
  folder_simple_arrow_right: {
    24: vkontakteIcons.Icon24FolderSimpleArrowRight,
  },
  followers: {
    24: vkontakteIcons.Icon24Followers,
  },
  forward_15: {
    24: vkontakteIcons.Icon24Forward15,
    28: vkontakteIcons.Icon28Forward15,
    36: vkontakteIcons.Icon36Forward15,
    48: vkontakteIcons.Icon48Forward15,
  },
  forward: {
    24: vkontakteIcons.Icon24Forward,
    48: vkontakteIcons.Icon48Forward,
  },
  fullscreen_exit: {
    24: vkontakteIcons.Icon24FullscreenExit,
  },
  gallery: {
    24: vkontakteIcons.Icon24Gallery,
    32: vkontakteIcons.Icon32Gallery,
  },
  gif_outline: {
    24: vkontakteIcons.Icon24GifOutline,
    28: vkontakteIcons.Icon28GifOutline,
  },
  goods_collection: {
    24: vkontakteIcons.Icon24GoodsCollection,
    56: vkontakteIcons.Icon56GoodsCollection,
    96: vkontakteIcons.Icon96GoodsCollection,
  },
  gradient_outline: {
    24: vkontakteIcons.Icon24GradientOutline,
  },
  grain_outline: {
    24: vkontakteIcons.Icon24GrainOutline,
  },
  gun_outline: {
    24: vkontakteIcons.Icon24GunOutline,
  },
  hammer_outline: {
    24: vkontakteIcons.Icon24HammerOutline,
  },
  hand_2_slash_outline: {
    24: vkontakteIcons.Icon24Hand2SlashOutline,
    28: vkontakteIcons.Icon28Hand2SlashOutline,
  },
  hanger_outline: {
    24: vkontakteIcons.Icon24HangerOutline,
    28: vkontakteIcons.Icon28HangerOutline,
  },
  heart_gear_outline: {
    24: vkontakteIcons.Icon24HeartGearOutline,
    28: vkontakteIcons.Icon28HeartGearOutline,
  },
  hearts_2: {
    24: vkontakteIcons.Icon24Hearts2,
    28: vkontakteIcons.Icon28Hearts2,
  },
  hide: {
    24: vkontakteIcons.Icon24Hide,
    28: vkontakteIcons.Icon28Hide,
  },
  highlights_outline: {
    24: vkontakteIcons.Icon24HighlightsOutline,
  },
  history_forward_outline: {
    24: vkontakteIcons.Icon24HistoryForwardOutline,
    28: vkontakteIcons.Icon28HistoryForwardOutline,
  },
  home_heart_outline: {
    24: vkontakteIcons.Icon24HomeHeartOutline,
  },
  hsl_outline: {
    24: vkontakteIcons.Icon24HslOutline,
  },
  ice_skates_outline: {
    24: vkontakteIcons.Icon24IceSkatesOutline,
  },
  incognito: {
    24: vkontakteIcons.Icon24Incognito,
  },
  keyboard_bots_outline: {
    24: vkontakteIcons.Icon24KeyboardBotsOutline,
    28: vkontakteIcons.Icon28KeyboardBotsOutline,
  },
  knife_outline: {
    24: vkontakteIcons.Icon24KnifeOutline,
  },
  link_circle: {
    24: vkontakteIcons.Icon24LinkCircle,
    40: vkontakteIcons.Icon40LinkCircle,
  },
  link_circle_filled: {
    24: vkontakteIcons.Icon24LinkCircleFilled,
  },
  linked_outline: {
    24: vkontakteIcons.Icon24LinkedOutline,
  },
  list: {
    24: vkontakteIcons.Icon24List,
  },
  list_add: {
    24: vkontakteIcons.Icon24ListAdd,
  },
  list_bullet_square_outline: {
    24: vkontakteIcons.Icon24ListBulletSquareOutline,
    28: vkontakteIcons.Icon28ListBulletSquareOutline,
    56: vkontakteIcons.Icon56ListBulletSquareOutline,
  },
  list_check_outline: {
    24: vkontakteIcons.Icon24ListCheckOutline,
    28: vkontakteIcons.Icon28ListCheckOutline,
  },
  list_like_fill: {
    24: vkontakteIcons.Icon24ListLikeFill,
    28: vkontakteIcons.Icon28ListLikeFill,
  },
  list_like_outline: {
    24: vkontakteIcons.Icon24ListLikeOutline,
    28: vkontakteIcons.Icon28ListLikeOutline,
  },
  list_like_slash_outline: {
    24: vkontakteIcons.Icon24ListLikeSlashOutline,
    28: vkontakteIcons.Icon28ListLikeSlashOutline,
  },
  list_pin_outline: {
    24: vkontakteIcons.Icon24ListPinOutline,
  },
  live: {
    24: vkontakteIcons.Icon24Live,
  },
  live_add_outline: {
    24: vkontakteIcons.Icon24LiveAddOutline,
    28: vkontakteIcons.Icon28LiveAddOutline,
  },
  live_clock_badge_outline: {
    24: vkontakteIcons.Icon24LiveClockBadgeOutline,
    28: vkontakteIcons.Icon28LiveClockBadgeOutline,
    56: vkontakteIcons.Icon56LiveClockBadgeOutline,
  },
  live_disable_outline: {
    24: vkontakteIcons.Icon24LiveDisableOutline,
  },
  locate: {
    24: vkontakteIcons.Icon24Locate,
  },
  location_slash: {
    24: vkontakteIcons.Icon24LocationSlash,
  },
  lock_open_outline: {
    24: vkontakteIcons.Icon24LockOpenOutline,
    28: vkontakteIcons.Icon28LockOpenOutline,
    56: vkontakteIcons.Icon56LockOpenOutline,
  },
  logo_facebook: {
    24: vkontakteIcons.Icon24LogoFacebook,
  },
  logo_google: {
    24: vkontakteIcons.Icon24LogoGoogle,
  },
  logo_icq_outline: {
    24: vkontakteIcons.Icon24LogoIcqOutline,
  },
  logo_instagram: {
    24: vkontakteIcons.Icon24LogoInstagram,
    28: vkontakteIcons.Icon28LogoInstagram,
  },
  logo_livejournal: {
    24: vkontakteIcons.Icon24LogoLivejournal,
  },
  logo_ok: {
    24: vkontakteIcons.Icon24LogoOk,
  },
  logo_skype: {
    24: vkontakteIcons.Icon24LogoSkype,
    28: vkontakteIcons.Icon28LogoSkype,
  },
  logo_twitter: {
    24: vkontakteIcons.Icon24LogoTwitter,
  },
  logo_vk_color: {
    24: vkontakteIcons.Icon24LogoVkColor,
    28: vkontakteIcons.Icon28LogoVkColor,
    32: vkontakteIcons.Icon32LogoVkColor,
    56: vkontakteIcons.Icon56LogoVkColor,
  },
  logo_vk_music_outline: {
    24: vkontakteIcons.Icon24LogoVkMusicOutline,
  },
  magic_wand_outline: {
    24: vkontakteIcons.Icon24MagicWandOutline,
    28: vkontakteIcons.Icon28MagicWandOutline,
  },
  mail_circle_fill_green: {
    24: vkontakteIcons.Icon24MailCircleFillGreen,
  },
  mappin_viewfinder_outline: {
    24: vkontakteIcons.Icon24MappinViewfinderOutline,
  },
  memory_card: {
    24: vkontakteIcons.Icon24MemoryCard,
    32: vkontakteIcons.Icon32MemoryCard,
  },
  message_add_badge_outline: {
    24: vkontakteIcons.Icon24MessageAddBadgeOutline,
    28: vkontakteIcons.Icon28MessageAddBadgeOutline,
  },
  message_badge: {
    24: vkontakteIcons.Icon24MessageBadge,
  },
  message_forward: {
    24: vkontakteIcons.Icon24MessageForward,
  },
  message_heart_outline: {
    24: vkontakteIcons.Icon24MessageHeartOutline,
    28: vkontakteIcons.Icon28MessageHeartOutline,
  },
  message_pin_outline: {
    24: vkontakteIcons.Icon24MessagePinOutline,
    28: vkontakteIcons.Icon28MessagePinOutline,
  },
  message_reply_outline: {
    24: vkontakteIcons.Icon24MessageReplyOutline,
    28: vkontakteIcons.Icon28MessageReplyOutline,
  },
  message_unread_outline: {
    24: vkontakteIcons.Icon24MessageUnreadOutline,
    28: vkontakteIcons.Icon28MessageUnreadOutline,
  },
  microphone_2_slash_outline: {
    24: vkontakteIcons.Icon24Microphone2SlashOutline,
    28: vkontakteIcons.Icon28Microphone2SlashOutline,
  },
  microphone_slash_color: {
    24: vkontakteIcons.Icon24MicrophoneSlashColor,
  },
  microphone_slash_outline: {
    24: vkontakteIcons.Icon24MicrophoneSlashOutline,
    28: vkontakteIcons.Icon28MicrophoneSlashOutline,
    56: vkontakteIcons.Icon56MicrophoneSlashOutline,
  },
  money_request_outline: {
    24: vkontakteIcons.Icon24MoneyRequestOutline,
    28: vkontakteIcons.Icon28MoneyRequestOutline,
  },
  money_send_outline: {
    24: vkontakteIcons.Icon24MoneySendOutline,
    28: vkontakteIcons.Icon28MoneySendOutline,
  },
  money_transfer: {
    24: vkontakteIcons.Icon24MoneyTransfer,
    28: vkontakteIcons.Icon28MoneyTransfer,
    32: vkontakteIcons.Icon32MoneyTransfer,
  },
  more_horizontal_overlay: {
    24: vkontakteIcons.Icon24MoreHorizontalOverlay,
  },
  mortar_outline: {
    24: vkontakteIcons.Icon24MortarOutline,
    28: vkontakteIcons.Icon28MortarOutline,
  },
  motorcycle_outline: {
    24: vkontakteIcons.Icon24MotorcycleOutline,
    28: vkontakteIcons.Icon28MotorcycleOutline,
  },
  mute_cross_outline: {
    24: vkontakteIcons.Icon24MuteCrossOutline,
  },
  narrative_filled: {
    24: vkontakteIcons.Icon24NarrativeFilled,
  },
  newsfeed: {
    24: vkontakteIcons.Icon24Newsfeed,
    28: vkontakteIcons.Icon28Newsfeed,
    36: vkontakteIcons.Icon36Newsfeed,
  },
  newsfeed_music_note_outline: {
    24: vkontakteIcons.Icon24NewsfeedMusicNoteOutline,
    28: vkontakteIcons.Icon28NewsfeedMusicNoteOutline,
  },
  note: {
    24: vkontakteIcons.Icon24Note,
    32: vkontakteIcons.Icon32Note,
  },
  notification_check_outline: {
    24: vkontakteIcons.Icon24NotificationCheckOutline,
    28: vkontakteIcons.Icon28NotificationCheckOutline,
  },
  notification_disable: {
    24: vkontakteIcons.Icon24NotificationDisable,
  },
  notification_subtract_outline: {
    24: vkontakteIcons.Icon24NotificationSubtractOutline,
    28: vkontakteIcons.Icon28NotificationSubtractOutline,
  },
  open_in: {
    24: vkontakteIcons.Icon24OpenIn,
  },
  pause_circle_fill_gray: {
    24: vkontakteIcons.Icon24PauseCircleFillGray,
  },
  pause_circle_fill_white: {
    24: vkontakteIcons.Icon24PauseCircleFillWhite,
    28: vkontakteIcons.Icon28PauseCircleFillWhite,
  },
  pause_outline: {
    24: vkontakteIcons.Icon24PauseOutline,
    28: vkontakteIcons.Icon28PauseOutline,
    56: vkontakteIcons.Icon56PauseOutline,
  },
  payment_card_clock_outline: {
    24: vkontakteIcons.Icon24PaymentCardClockOutline,
  },
  payment_card_vertical_outline: {
    24: vkontakteIcons.Icon24PaymentCardVerticalOutline,
    28: vkontakteIcons.Icon28PaymentCardVerticalOutline,
    56: vkontakteIcons.Icon56PaymentCardVerticalOutline,
  },
  percent_circle: {
    24: vkontakteIcons.Icon24PercentCircle,
  },
  phone_add_outline: {
    24: vkontakteIcons.Icon24PhoneAddOutline,
    28: vkontakteIcons.Icon28PhoneAddOutline,
  },
  phone_arrow_down_left: {
    24: vkontakteIcons.Icon24PhoneArrowDownLeft,
  },
  phone_cross: {
    24: vkontakteIcons.Icon24PhoneCross,
  },
  phone_cross_outline: {
    24: vkontakteIcons.Icon24PhoneCrossOutline,
    28: vkontakteIcons.Icon28PhoneCrossOutline,
  },
  phone_wave_outline_gray: {
    24: vkontakteIcons.Icon24PhoneWaveOutlineGray,
    28: vkontakteIcons.Icon28PhoneWaveOutlineGray,
  },
  photos_stack_outline: {
    24: vkontakteIcons.Icon24PhotosStackOutline,
  },
  picture_in_picture_16x9_outline: {
    24: vkontakteIcons.Icon24PictureInPicture16x9Outline,
    28: vkontakteIcons.Icon28PictureInPicture16x9Outline,
  },
  picture_in_picture_out_16x9_outline: {
    24: vkontakteIcons.Icon24PictureInPictureOut16x9Outline,
    28: vkontakteIcons.Icon28PictureInPictureOut16x9Outline,
  },
  picture_in_picture_square_filled: {
    24: vkontakteIcons.Icon24PictureInPictureSquareFilled,
  },
  play_cards_2_outline: {
    24: vkontakteIcons.Icon24PlayCards2Outline,
    28: vkontakteIcons.Icon28PlayCards2Outline,
  },
  play_circle_fill_white: {
    24: vkontakteIcons.Icon24PlayCircleFillWhite,
    28: vkontakteIcons.Icon28PlayCircleFillWhite,
  },
  play_next: {
    24: vkontakteIcons.Icon24PlayNext,
  },
  play_next_outline: {
    24: vkontakteIcons.Icon24PlayNextOutline,
  },
  play_outline: {
    24: vkontakteIcons.Icon24PlayOutline,
    28: vkontakteIcons.Icon28PlayOutline,
  },
  play_speed: {
    24: vkontakteIcons.Icon24PlaySpeed,
  },
  playlist: {
    24: vkontakteIcons.Icon24Playlist,
    36: vkontakteIcons.Icon36Playlist,
    48: vkontakteIcons.Icon48Playlist,
  },
  podcast: {
    24: vkontakteIcons.Icon24Podcast,
    48: vkontakteIcons.Icon48Podcast,
  },
  printer: {
    24: vkontakteIcons.Icon24Printer,
  },
  privacy: {
    24: vkontakteIcons.Icon24Privacy,
  },
  qr: {
    24: vkontakteIcons.Icon24Qr,
  },
  rate_outline: {
    24: vkontakteIcons.Icon24RateOutline,
    28: vkontakteIcons.Icon28RateOutline,
  },
  rectangle_hand_point_up: {
    24: vkontakteIcons.Icon24RectangleHandPointUp,
  },
  rectangle_outline: {
    24: vkontakteIcons.Icon24RectangleOutline,
  },
  rectangles_2_outline: {
    24: vkontakteIcons.Icon24Rectangles2Outline,
  },
  refresh: {
    24: vkontakteIcons.Icon24Refresh,
  },
  remove_circle: {
    24: vkontakteIcons.Icon24RemoveCircle,
  },
  reorder_ios: {
    24: vkontakteIcons.Icon24ReorderIos,
  },
  repeat_1_outline: {
    24: vkontakteIcons.Icon24Repeat1Outline,
    28: vkontakteIcons.Icon28Repeat1Outline,
  },
  repeat_1_outline_dot: {
    24: vkontakteIcons.Icon24Repeat1OutlineDot,
  },
  repeat: {
    24: vkontakteIcons.Icon24Repeat,
  },
  repeat_one: {
    24: vkontakteIcons.Icon24RepeatOne,
  },
  repeat_outline: {
    24: vkontakteIcons.Icon24RepeatOutline,
    28: vkontakteIcons.Icon28RepeatOutline,
  },
  repeat_outline_dot: {
    24: vkontakteIcons.Icon24RepeatOutlineDot,
  },
  report: {
    24: vkontakteIcons.Icon24Report,
    28: vkontakteIcons.Icon28Report,
  },
  robot_outline: {
    24: vkontakteIcons.Icon24RobotOutline,
    28: vkontakteIcons.Icon28RobotOutline,
  },
  rouble_badge_outline: {
    24: vkontakteIcons.Icon24RoubleBadgeOutline,
  },
  sart_outline: {
    24: vkontakteIcons.Icon24SartOutline,
  },
  screencast: {
    24: vkontakteIcons.Icon24Screencast,
    28: vkontakteIcons.Icon28Screencast,
  },
  screencast_enabled_outline: {
    24: vkontakteIcons.Icon24ScreencastEnabledOutline,
    28: vkontakteIcons.Icon28ScreencastEnabledOutline,
  },
  screencast_outline: {
    24: vkontakteIcons.Icon24ScreencastOutline,
    28: vkontakteIcons.Icon28ScreencastOutline,
    56: vkontakteIcons.Icon56ScreencastOutline,
  },
  search_like_filled_outline: {
    24: vkontakteIcons.Icon24SearchLikeFilledOutline,
    28: vkontakteIcons.Icon28SearchLikeFilledOutline,
    56: vkontakteIcons.Icon56SearchLikeFilledOutline,
  },
  search_like_outline: {
    24: vkontakteIcons.Icon24SearchLikeOutline,
    28: vkontakteIcons.Icon28SearchLikeOutline,
    56: vkontakteIcons.Icon56SearchLikeOutline,
  },
  search_slash_outline: {
    24: vkontakteIcons.Icon24SearchSlashOutline,
  },
  send: {
    24: vkontakteIcons.Icon24Send,
    28: vkontakteIcons.Icon28Send,
    36: vkontakteIcons.Icon36Send,
  },
  send_clock: {
    24: vkontakteIcons.Icon24SendClock,
    28: vkontakteIcons.Icon28SendClock,
  },
  settings: {
    24: vkontakteIcons.Icon24Settings,
    28: vkontakteIcons.Icon28Settings,
  },
  shadows_outline: {
    24: vkontakteIcons.Icon24ShadowsOutline,
  },
  share_alt: {
    24: vkontakteIcons.Icon24ShareAlt,
  },
  share_external: {
    24: vkontakteIcons.Icon24ShareExternal,
    28: vkontakteIcons.Icon28ShareExternal,
  },
  shuffle: {
    24: vkontakteIcons.Icon24Shuffle,
  },
  shuffle_outline_dot: {
    24: vkontakteIcons.Icon24ShuffleOutlineDot,
  },
  similar: {
    24: vkontakteIcons.Icon24Similar,
  },
  skip_next: {
    24: vkontakteIcons.Icon24SkipNext,
    28: vkontakteIcons.Icon28SkipNext,
    36: vkontakteIcons.Icon36SkipNext,
    48: vkontakteIcons.Icon48SkipNext,
  },
  skip_previous: {
    24: vkontakteIcons.Icon24SkipPrevious,
    28: vkontakteIcons.Icon28SkipPrevious,
    36: vkontakteIcons.Icon36SkipPrevious,
    48: vkontakteIcons.Icon48SkipPrevious,
  },
  skip_to_action: {
    24: vkontakteIcons.Icon24SkipToAction,
    28: vkontakteIcons.Icon28SkipToAction,
  },
  sliders_vertical_outline: {
    24: vkontakteIcons.Icon24SlidersVerticalOutline,
    28: vkontakteIcons.Icon28SlidersVerticalOutline,
  },
  sneaker_outline: {
    24: vkontakteIcons.Icon24SneakerOutline,
    28: vkontakteIcons.Icon28SneakerOutline,
  },
  snowflake_outline: {
    24: vkontakteIcons.Icon24SnowflakeOutline,
    28: vkontakteIcons.Icon28SnowflakeOutline,
  },
  song: {
    24: vkontakteIcons.Icon24Song,
  },
  sort: {
    24: vkontakteIcons.Icon24Sort,
  },
  sound_effect: {
    24: vkontakteIcons.Icon24SoundEffect,
  },
  speedometer_middle_outline: {
    24: vkontakteIcons.Icon24SpeedometerMiddleOutline,
    28: vkontakteIcons.Icon28SpeedometerMiddleOutline,
  },
  spoiler_outline: {
    24: vkontakteIcons.Icon24SpoilerOutline,
  },
  square_4: {
    24: vkontakteIcons.Icon24Square4,
  },
  square_grid_3x3: {
    24: vkontakteIcons.Icon24SquareGrid3x3,
  },
  squareshape_2_horizontal_bottom_outline: {
    24: vkontakteIcons.Icon24Squareshape2HorizontalBottomOutline,
  },
  squareshape_2_vertical_outline: {
    24: vkontakteIcons.Icon24Squareshape2VerticalOutline,
  },
  squareshape_3_vertical_left_outline: {
    24: vkontakteIcons.Icon24Squareshape3VerticalLeftOutline,
  },
  squareshape_3_vertical_outline: {
    24: vkontakteIcons.Icon24Squareshape3VerticalOutline,
  },
  squareshape_4_grid_outline: {
    24: vkontakteIcons.Icon24Squareshape4GridOutline,
  },
  squareshape_4_horizontal_outline: {
    24: vkontakteIcons.Icon24Squareshape4HorizontalOutline,
  },
  squareshape_4_vertical_left_outline: {
    24: vkontakteIcons.Icon24Squareshape4VerticalLeftOutline,
  },
  squareshape_4_vertical_topleft_bottomright_outline: {
    24: vkontakteIcons.Icon24Squareshape4VerticalTopleftBottomrightOutline,
  },
  squareshape_5_horizontal_center_outline: {
    24: vkontakteIcons.Icon24Squareshape5HorizontalCenterOutline,
  },
  squareshape_5_topright_outline: {
    24: vkontakteIcons.Icon24Squareshape5ToprightOutline,
  },
  squareshape_5_vertical_center_split_outline: {
    24: vkontakteIcons.Icon24Squareshape5VerticalCenterSplitOutline,
  },
  squareshape_5_vertical_left_outline: {
    24: vkontakteIcons.Icon24Squareshape5VerticalLeftOutline,
  },
  squareshape_5_vertical_left_split_outline: {
    24: vkontakteIcons.Icon24Squareshape5VerticalLeftSplitOutline,
  },
  star_circle_fill_green: {
    24: vkontakteIcons.Icon24StarCircleFillGreen,
  },
  star_shield_outline: {
    24: vkontakteIcons.Icon24StarShieldOutline,
  },
  stars_outline: {
    24: vkontakteIcons.Icon24StarsOutline,
    28: vkontakteIcons.Icon28StarsOutline,
    32: vkontakteIcons.Icon32StarsOutline,
  },
  stop: {
    24: vkontakteIcons.Icon24Stop,
  },
  story_reply_outline: {
    24: vkontakteIcons.Icon24StoryReplyOutline,
  },
  stud_outline: {
    24: vkontakteIcons.Icon24StudOutline,
    28: vkontakteIcons.Icon28StudOutline,
  },
  tennis_ball_outline: {
    24: vkontakteIcons.Icon24TennisBallOutline,
  },
  thumb_down: {
    24: vkontakteIcons.Icon24ThumbDown,
  },
  thumb_up: {
    24: vkontakteIcons.Icon24ThumbUp,
  },
  tree_nodes: {
    24: vkontakteIcons.Icon24TreeNodes,
  },
  tree_nodes_outline: {
    24: vkontakteIcons.Icon24TreeNodesOutline,
  },
  triangle_outline: {
    24: vkontakteIcons.Icon24TriangleOutline,
  },
  ugc_sticker_outline: {
    24: vkontakteIcons.Icon24UgcStickerOutline,
  },
  unblock_outline: {
    24: vkontakteIcons.Icon24UnblockOutline,
  },
  unpin: {
    24: vkontakteIcons.Icon24Unpin,
  },
  upload: {
    24: vkontakteIcons.Icon24Upload,
  },
  user_added: {
    24: vkontakteIcons.Icon24UserAdded,
  },
  user_added_outline: {
    24: vkontakteIcons.Icon24UserAddedOutline,
    28: vkontakteIcons.Icon28UserAddedOutline,
  },
  user_background_outline: {
    24: vkontakteIcons.Icon24UserBackgroundOutline,
    28: vkontakteIcons.Icon28UserBackgroundOutline,
  },
  user_incoming: {
    24: vkontakteIcons.Icon24UserIncoming,
  },
  user_outgoing: {
    24: vkontakteIcons.Icon24UserOutgoing,
  },
  user_square_on_square: {
    24: vkontakteIcons.Icon24UserSquareOnSquare,
    28: vkontakteIcons.Icon28UserSquareOnSquare,
    32: vkontakteIcons.Icon32UserSquareOnSquare,
  },
  vertical_rectangle_4x5_outline: {
    24: vkontakteIcons.Icon24VerticalRectangle4x5Outline,
  },
  vertical_rectangle_9x16_outline: {
    24: vkontakteIcons.Icon24VerticalRectangle9x16Outline,
  },
  video_arrow_square_outline: {
    24: vkontakteIcons.Icon24VideoArrowSquareOutline,
  },
  video_fill: {
    24: vkontakteIcons.Icon24VideoFill,
  },
  video_fill_none: {
    24: vkontakteIcons.Icon24VideoFillNone,
  },
  video_help_square_outline: {
    24: vkontakteIcons.Icon24VideoHelpSquareOutline,
  },
  videocam_2_slash_outline: {
    24: vkontakteIcons.Icon24Videocam2SlashOutline,
    28: vkontakteIcons.Icon28Videocam2SlashOutline,
  },
  videocam_add_outline: {
    24: vkontakteIcons.Icon24VideocamAddOutline,
    28: vkontakteIcons.Icon28VideocamAddOutline,
  },
  videocam_slash: {
    24: vkontakteIcons.Icon24VideocamSlash,
  },
  videocam_slash_color: {
    24: vkontakteIcons.Icon24VideocamSlashColor,
    28: vkontakteIcons.Icon28VideocamSlashColor,
  },
  vignette_outline: {
    24: vkontakteIcons.Icon24VignetteOutline,
  },
  voice_help_outline: {
    24: vkontakteIcons.Icon24VoiceHelpOutline,
  },
  volleyball_outline: {
    24: vkontakteIcons.Icon24VolleyballOutline,
  },
  work: {
    24: vkontakteIcons.Icon24Work,
  },
  zip: {
    24: vkontakteIcons.Icon24Zip,
  },
  add_award_outline: {
    28: vkontakteIcons.Icon28AddAwardOutline,
    48: vkontakteIcons.Icon48AddAwardOutline,
  },
  add_viewfinder_outline: {
    28: vkontakteIcons.Icon28AddViewfinderOutline,
  },
  airplay_audio_outline: {
    28: vkontakteIcons.Icon28AirplayAudioOutline,
  },
  all_categories_outline: {
    28: vkontakteIcons.Icon28AllCategoriesOutline,
  },
  archive_check_outline: {
    28: vkontakteIcons.Icon28ArchiveCheckOutline,
  },
  archive_circle_fill_gray: {
    28: vkontakteIcons.Icon28ArchiveCircleFillGray,
  },
  arrow_pop_down_outline: {
    28: vkontakteIcons.Icon28ArrowPopDownOutline,
  },
  arrow_pop_up_outline: {
    28: vkontakteIcons.Icon28ArrowPopUpOutline,
  },
  arrow_up_circle_outline: {
    28: vkontakteIcons.Icon28ArrowUpCircleOutline,
  },
  articles_slash_outline: {
    28: vkontakteIcons.Icon28ArticlesSlashOutline,
  },
  attach_circle_fill_blue: {
    28: vkontakteIcons.Icon28AttachCircleFillBlue,
  },
  attach_outline: {
    28: vkontakteIcons.Icon28AttachOutline,
  },
  backspace: {
    28: vkontakteIcons.Icon28Backspace,
  },
  backspace_outline: {
    28: vkontakteIcons.Icon28BackspaceOutline,
    56: vkontakteIcons.Icon56BackspaceOutline,
  },
  basketball_ball_outline: {
    28: vkontakteIcons.Icon28BasketballBallOutline,
  },
  bill_separated_outline: {
    28: vkontakteIcons.Icon28BillSeparatedOutline,
  },
  block_circle_fill_gray: {
    28: vkontakteIcons.Icon28BlockCircleFillGray,
  },
  bookmark_add_outline: {
    28: vkontakteIcons.Icon28BookmarkAddOutline,
  },
  bookmark_check: {
    28: vkontakteIcons.Icon28BookmarkCheck,
  },
  bookmark_circle_fill_yellow: {
    28: vkontakteIcons.Icon28BookmarkCircleFillYellow,
  },
  bookmark_slash_circle_fill_yellow: {
    28: vkontakteIcons.Icon28BookmarkSlashCircleFillYellow,
  },
  box_heart_outline: {
    28: vkontakteIcons.Icon28BoxHeartOutline,
  },
  brackets_slash_square_outline: {
    28: vkontakteIcons.Icon28BracketsSlashSquareOutline,
  },
  brackets_square_outline: {
    28: vkontakteIcons.Icon28BracketsSquareOutline,
  },
  bus_outline: {
    28: vkontakteIcons.Icon28BusOutline,
  },
  camera_add_outline: {
    28: vkontakteIcons.Icon28CameraAddOutline,
  },
  camera_slash_outline: {
    28: vkontakteIcons.Icon28CameraSlashOutline,
  },
  cancel_alt_outline: {
    28: vkontakteIcons.Icon28CancelAltOutline,
  },
  cancel_shield_outline: {
    28: vkontakteIcons.Icon28CancelShieldOutline,
  },
  chain_circle_fill_blue: {
    28: vkontakteIcons.Icon28ChainCircleFillBlue,
  },
  chats_outline: {
    28: vkontakteIcons.Icon28ChatsOutline,
  },
  check_circle_device_outline: {
    28: vkontakteIcons.Icon28CheckCircleDeviceOutline,
    56: vkontakteIcons.Icon56CheckCircleDeviceOutline,
  },
  check_shield_device_outline: {
    28: vkontakteIcons.Icon28CheckShieldDeviceOutline,
  },
  chevron_back: {
    28: vkontakteIcons.Icon28ChevronBack,
  },
  chevron_down_outline: {
    28: vkontakteIcons.Icon28ChevronDownOutline,
    36: vkontakteIcons.Icon36ChevronDownOutline,
    48: vkontakteIcons.Icon48ChevronDownOutline,
  },
  chevron_left_circle: {
    28: vkontakteIcons.Icon28ChevronLeftCircle,
  },
  chevrons_2_left_outline: {
    28: vkontakteIcons.Icon28Chevrons2LeftOutline,
  },
  clapperboard_outline: {
    28: vkontakteIcons.Icon28ClapperboardOutline,
  },
  clock_rectangle_stack_outline: {
    28: vkontakteIcons.Icon28ClockRectangleStackOutline,
  },
  coffee_steam_outline: {
    28: vkontakteIcons.Icon28CoffeeSteamOutline,
  },
  comment_circle_fill_blue: {
    28: vkontakteIcons.Icon28CommentCircleFillBlue,
  },
  compass_circle_fill_blue: {
    28: vkontakteIcons.Icon28CompassCircleFillBlue,
  },
  compass_circle_fill_purple: {
    28: vkontakteIcons.Icon28CompassCircleFillPurple,
    56: vkontakteIcons.Icon56CompassCircleFillPurple,
  },
  computer_mouse_arrows_outline: {
    28: vkontakteIcons.Icon28ComputerMouseArrowsOutline,
  },
  cross_large_outline: {
    28: vkontakteIcons.Icon28CrossLargeOutline,
  },
  devices_outline: {
    28: vkontakteIcons.Icon28DevicesOutline,
    56: vkontakteIcons.Icon56DevicesOutline,
  },
  dice_1_outline: {
    28: vkontakteIcons.Icon28Dice1Outline,
  },
  dice_2_outline: {
    28: vkontakteIcons.Icon28Dice2Outline,
  },
  dice_3_outline: {
    28: vkontakteIcons.Icon28Dice3Outline,
  },
  dice_4_outline: {
    28: vkontakteIcons.Icon28Dice4Outline,
  },
  dice_6_outline: {
    28: vkontakteIcons.Icon28Dice6Outline,
  },
  discussions_circle_fill: {
    28: vkontakteIcons.Icon28DiscussionsCircleFill,
  },
  discussions_circle_fill_green: {
    28: vkontakteIcons.Icon28DiscussionsCircleFillGreen,
  },
  door_enter_arrow_right_circle_fill_green: {
    28: vkontakteIcons.Icon28DoorEnterArrowRightCircleFillGreen,
  },
  download_cancel_outline: {
    28: vkontakteIcons.Icon28DownloadCancelOutline,
  },
  edit_outline: {
    28: vkontakteIcons.Icon28EditOutline,
  },
  education_circle_fill_gray: {
    28: vkontakteIcons.Icon28EducationCircleFillGray,
  },
  emblem_outline: {
    28: vkontakteIcons.Icon28EmblemOutline,
  },
  error_outline: {
    28: vkontakteIcons.Icon28ErrorOutline,
    56: vkontakteIcons.Icon56ErrorOutline,
  },
  error_shield_outline: {
    28: vkontakteIcons.Icon28ErrorShieldOutline,
  },
  explicit_outline: {
    28: vkontakteIcons.Icon28ExplicitOutline,
  },
  face_id_outline: {
    28: vkontakteIcons.Icon28FaceIdOutline,
    56: vkontakteIcons.Icon56FaceIdOutline,
  },
  face_recognition_outline: {
    28: vkontakteIcons.Icon28FaceRecognitionOutline,
  },
  favorite_add_outline: {
    28: vkontakteIcons.Icon28FavoriteAddOutline,
  },
  film_strip_circle_fill_red: {
    28: vkontakteIcons.Icon28FilmStripCircleFillRed,
  },
  film_strip_rss_outline: {
    28: vkontakteIcons.Icon28FilmStripRssOutline,
  },
  fire_outline: {
    28: vkontakteIcons.Icon28FireOutline,
    56: vkontakteIcons.Icon56FireOutline,
  },
  flash_circle_fill_gray: {
    28: vkontakteIcons.Icon28FlashCircleFillGray,
  },
  flash_circle_outline: {
    28: vkontakteIcons.Icon28FlashCircleOutline,
  },
  flip_horizontal_outline: {
    28: vkontakteIcons.Icon28FlipHorizontalOutline,
  },
  flip_vertical_outline: {
    28: vkontakteIcons.Icon28FlipVerticalOutline,
  },
  fortune_cookie_outline: {
    28: vkontakteIcons.Icon28FortuneCookieOutline,
  },
  forward_10_outline: {
    28: vkontakteIcons.Icon28Forward10Outline,
  },
  ghost_simple_outline: {
    28: vkontakteIcons.Icon28GhostSimpleOutline,
    36: vkontakteIcons.Icon36GhostSimpleOutline,
  },
  globe_circle_fill_blue: {
    28: vkontakteIcons.Icon28GlobeCircleFillBlue,
  },
  globe_circle_fill_yellow: {
    28: vkontakteIcons.Icon28GlobeCircleFillYellow,
  },
  grid_circle_fill_blue: {
    28: vkontakteIcons.Icon28GridCircleFillBlue,
  },
  grid_layout_outline: {
    28: vkontakteIcons.Icon28GridLayoutOutline,
  },
  grid_rectangle_up_square_2_down_outline: {
    28: vkontakteIcons.Icon28GridRectangleUpSquare2DownOutline,
  },
  grid_square_outline: {
    28: vkontakteIcons.Icon28GridSquareOutline,
  },
  hand_heart_circle_fill_red: {
    28: vkontakteIcons.Icon28HandHeartCircleFillRed,
  },
  hand_heart_outline: {
    28: vkontakteIcons.Icon28HandHeartOutline,
  },
  hand_slash_outline: {
    28: vkontakteIcons.Icon28HandSlashOutline,
  },
  happy_face_outline: {
    28: vkontakteIcons.Icon28HappyFaceOutline,
  },
  headphones_check_outline: {
    28: vkontakteIcons.Icon28HeadphonesCheckOutline,
  },
  heart_circle_outline: {
    28: vkontakteIcons.Icon28HeartCircleOutline,
  },
  help_circle_outline: {
    28: vkontakteIcons.Icon28HelpCircleOutline,
  },
  hide_circle_fill_black: {
    28: vkontakteIcons.Icon28HideCircleFillBlack,
  },
  history_forward_substract_outline: {
    28: vkontakteIcons.Icon28HistoryForwardSubstractOutline,
  },
  horizontal_rectangle_2_vertical_left_fill_outline: {
    28: vkontakteIcons.Icon28HorizontalRectangle2VerticalLeftFillOutline,
  },
  horizontal_rectangle_2_vertical_left_outline: {
    28: vkontakteIcons.Icon28HorizontalRectangle2VerticalLeftOutline,
  },
  hourglass_error_badge_outline: {
    28: vkontakteIcons.Icon28HourglassErrorBadgeOutline,
    56: vkontakteIcons.Icon56HourglassErrorBadgeOutline,
  },
  hourglass_outline: {
    28: vkontakteIcons.Icon28HourglassOutline,
    56: vkontakteIcons.Icon56HourglassOutline,
  },
  inbox_outline: {
    28: vkontakteIcons.Icon28InboxOutline,
    56: vkontakteIcons.Icon56InboxOutline,
  },
  incognito_circle_fill_gray: {
    28: vkontakteIcons.Icon28IncognitoCircleFillGray,
  },
  ipad_outline: {
    28: vkontakteIcons.Icon28IpadOutline,
  },
  key_square_outline: {
    28: vkontakteIcons.Icon28KeySquareOutline,
  },
  like_fill_red: {
    28: vkontakteIcons.Icon28LikeFillRed,
  },
  list_arrow_left_outline: {
    28: vkontakteIcons.Icon28ListArrowLeftOutline,
  },
  list_arrow_right_outline: {
    28: vkontakteIcons.Icon28ListArrowRightOutline,
  },
  list_hand_alt: {
    28: vkontakteIcons.Icon28ListHandAlt,
  },
  list_like_circle_fill_gray: {
    28: vkontakteIcons.Icon28ListLikeCircleFillGray,
  },
  list_outline: {
    28: vkontakteIcons.Icon28ListOutline,
  },
  logo_vk_adblogger_outline: {
    28: vkontakteIcons.Icon28LogoVkAdbloggerOutline,
  },
  logo_wink: {
    28: vkontakteIcons.Icon28LogoWink,
  },
  loudspeaker_slash_outline: {
    28: vkontakteIcons.Icon28LoudspeakerSlashOutline,
  },
  magic_hat_outline: {
    28: vkontakteIcons.Icon28MagicHatOutline,
  },
  magnet_outline: {
    28: vkontakteIcons.Icon28MagnetOutline,
  },
  magnifier_minus: {
    28: vkontakteIcons.Icon28MagnifierMinus,
  },
  magnifier_plus: {
    28: vkontakteIcons.Icon28MagnifierPlus,
  },
  mail_circle_fill_gray: {
    28: vkontakteIcons.Icon28MailCircleFillGray,
  },
  market_add_badge_outline: {
    28: vkontakteIcons.Icon28MarketAddBadgeOutline,
  },
  market_circle_fill_blue: {
    28: vkontakteIcons.Icon28MarketCircleFillBlue,
  },
  market_like_outline: {
    28: vkontakteIcons.Icon28MarketLikeOutline,
    56: vkontakteIcons.Icon56MarketLikeOutline,
  },
  market_slash_outline: {
    28: vkontakteIcons.Icon28MarketSlashOutline,
  },
  menu: {
    28: vkontakteIcons.Icon28Menu,
  },
  message_question_circle_fill_violet: {
    28: vkontakteIcons.Icon28MessageQuestionCircleFillViolet,
  },
  message_request_circle_fill_blue: {
    28: vkontakteIcons.Icon28MessageRequestCircleFillBlue,
  },
  message_star_outline: {
    28: vkontakteIcons.Icon28MessageStarOutline,
  },
  message_unread_top: {
    28: vkontakteIcons.Icon28MessageUnreadTop,
  },
  messages: {
    28: vkontakteIcons.Icon28Messages,
  },
  messages_circle_fill_gray: {
    28: vkontakteIcons.Icon28MessagesCircleFillGray,
  },
  messages_circle_fill_yellow: {
    28: vkontakteIcons.Icon28MessagesCircleFillYellow,
  },
  mic_slash_outline: {
    28: vkontakteIcons.Icon28MicSlashOutline,
  },
  microchip_outline: {
    28: vkontakteIcons.Icon28MicrochipOutline,
  },
  microphone_alt: {
    28: vkontakteIcons.Icon28MicrophoneAlt,
  },
  microphone_circle_fill_red: {
    28: vkontakteIcons.Icon28MicrophoneCircleFillRed,
  },
  microphone_slash_alt: {
    28: vkontakteIcons.Icon28MicrophoneSlashAlt,
  },
  microphone_slash_color_alt: {
    28: vkontakteIcons.Icon28MicrophoneSlashColorAlt,
  },
  microphone_videocam_outline: {
    28: vkontakteIcons.Icon28MicrophoneVideocamOutline,
    56: vkontakteIcons.Icon56MicrophoneVideocamOutline,
  },
  microphone_videocam_slash_outline: {
    28: vkontakteIcons.Icon28MicrophoneVideocamSlashOutline,
  },
  monetization_authors_fund_outline: {
    28: vkontakteIcons.Icon28MonetizationAuthorsFundOutline,
  },
  money_history_backward_outline: {
    28: vkontakteIcons.Icon28MoneyHistoryBackwardOutline,
    56: vkontakteIcons.Icon56MoneyHistoryBackwardOutline,
  },
  money_wad_outline: {
    28: vkontakteIcons.Icon28MoneyWadOutline,
  },
  more_horizontal_circle_fill_gray: {
    28: vkontakteIcons.Icon28MoreHorizontalCircleFillGray,
  },
  movie_reel_outline: {
    28: vkontakteIcons.Icon28MovieReelOutline,
  },
  music_circle_fill_raspberry_pink: {
    28: vkontakteIcons.Icon28MusicCircleFillRaspberryPink,
  },
  name_tag_outline: {
    28: vkontakteIcons.Icon28NameTagOutline,
  },
  newsfeed_lines_outline: {
    28: vkontakteIcons.Icon28NewsfeedLinesOutline,
  },
  no_smoking_sign_outline: {
    28: vkontakteIcons.Icon28NoSmokingSignOutline,
  },
  note_circle_fill_gray: {
    28: vkontakteIcons.Icon28NoteCircleFillGray,
  },
  notebook_add_badge_outline: {
    28: vkontakteIcons.Icon28NotebookAddBadgeOutline,
  },
  notification_add_outline: {
    28: vkontakteIcons.Icon28NotificationAddOutline,
  },
  notification_circle_fill_gray: {
    28: vkontakteIcons.Icon28NotificationCircleFillGray,
  },
  notification_disable_outline: {
    28: vkontakteIcons.Icon28NotificationDisableOutline,
  },
  notifications: {
    28: vkontakteIcons.Icon28Notifications,
  },
  palette_fill_blue: {
    28: vkontakteIcons.Icon28PaletteFillBlue,
  },
  paperplane_outline: {
    28: vkontakteIcons.Icon28PaperplaneOutline,
  },
  pause_circle_fill_azure: {
    28: vkontakteIcons.Icon28PauseCircleFillAzure,
  },
  payment_card_add_outline: {
    28: vkontakteIcons.Icon28PaymentCardAddOutline,
  },
  pen_keyhole_outline: {
    28: vkontakteIcons.Icon28PenKeyholeOutline,
  },
  pencil_square: {
    28: vkontakteIcons.Icon28PencilSquare,
  },
  phone_circle_fill_blue: {
    28: vkontakteIcons.Icon28PhoneCircleFillBlue,
  },
  phone_down_filled: {
    28: vkontakteIcons.Icon28PhoneDownFilled,
  },
  phone_spam_outline: {
    28: vkontakteIcons.Icon28PhoneSpamOutline,
  },
  phone_wave_outline: {
    28: vkontakteIcons.Icon28PhoneWaveOutline,
  },
  picture_circle_fill: {
    28: vkontakteIcons.Icon28PictureCircleFill,
  },
  picture_in_picture_9x16_outline: {
    28: vkontakteIcons.Icon28PictureInPicture9x16Outline,
  },
  picture_pen_outline: {
    28: vkontakteIcons.Icon28PicturePenOutline,
  },
  pill_outline: {
    28: vkontakteIcons.Icon28PillOutline,
  },
  pin_circle_fill_blue: {
    28: vkontakteIcons.Icon28PinCircleFillBlue,
  },
  pin_dot_slash_outline: {
    28: vkontakteIcons.Icon28PinDotSlashOutline,
  },
  pincode_lock_outline: {
    28: vkontakteIcons.Icon28PincodeLockOutline,
  },
  pincode_outline: {
    28: vkontakteIcons.Icon28PincodeOutline,
  },
  play_auto_outline: {
    28: vkontakteIcons.Icon28PlayAutoOutline,
  },
  play_circle_fill_red: {
    28: vkontakteIcons.Icon28PlayCircleFillRed,
    32: vkontakteIcons.Icon32PlayCircleFillRed,
  },
  play_speed_outline: {
    28: vkontakteIcons.Icon28PlaySpeedOutline,
  },
  podcast_circle_fill_raspberry_pink: {
    28: vkontakteIcons.Icon28PodcastCircleFillRaspberryPink,
  },
  poll_square_outline: {
    28: vkontakteIcons.Icon28PollSquareOutline,
    36: vkontakteIcons.Icon36PollSquareOutline,
  },
  poster_icon: {
    28: vkontakteIcons.Icon28PosterIcon,
  },
  power_socket_outline: {
    28: vkontakteIcons.Icon28PowerSocketOutline,
  },
  privacy_outline: {
    28: vkontakteIcons.Icon28PrivacyOutline,
    56: vkontakteIcons.Icon56PrivacyOutline,
  },
  profile: {
    28: vkontakteIcons.Icon28Profile,
  },
  quote_outline: {
    28: vkontakteIcons.Icon28QuoteOutline,
  },
  radio_outline: {
    28: vkontakteIcons.Icon28RadioOutline,
  },
  radiowaves_around_outline: {
    28: vkontakteIcons.Icon28RadiowavesAroundOutline,
    96: vkontakteIcons.Icon96RadiowavesAroundOutline,
  },
  radiowaves_left_and_right_outline: {
    28: vkontakteIcons.Icon28RadiowavesLeftAndRightOutline,
  },
  recorder_tape_slash_outline: {
    28: vkontakteIcons.Icon28RecorderTapeSlashOutline,
  },
  rectangle_2_outline: {
    28: vkontakteIcons.Icon28Rectangle2Outline,
  },
  replay_10_outline: {
    28: vkontakteIcons.Icon28Replay10Outline,
  },
  rotate_left_outline: {
    28: vkontakteIcons.Icon28RotateLeftOutline,
  },
  rotate_right_outline: {
    28: vkontakteIcons.Icon28RotateRightOutline,
  },
  rss_feed_outline: {
    28: vkontakteIcons.Icon28RssFeedOutline,
  },
  rude_message_outline: {
    28: vkontakteIcons.Icon28RudeMessageOutline,
    56: vkontakteIcons.Icon56RudeMessageOutline,
  },
  safari_outline: {
    28: vkontakteIcons.Icon28SafariOutline,
  },
  school_outline: {
    28: vkontakteIcons.Icon28SchoolOutline,
    56: vkontakteIcons.Icon56SchoolOutline,
  },
  screen_grid_horizon_2_line_outline: {
    28: vkontakteIcons.Icon28ScreenGridHorizon2LineOutline,
  },
  screen_grid_horizon_line_outline: {
    28: vkontakteIcons.Icon28ScreenGridHorizonLineOutline,
  },
  screen_grid_tile_outline: {
    28: vkontakteIcons.Icon28ScreenGridTileOutline,
  },
  screen_grid_vertical_line_outline: {
    28: vkontakteIcons.Icon28ScreenGridVerticalLineOutline,
  },
  send_circle_clock: {
    28: vkontakteIcons.Icon28SendCircleClock,
    32: vkontakteIcons.Icon32SendCircleClock,
  },
  send_circle_fill_gray: {
    28: vkontakteIcons.Icon28SendCircleFillGray,
  },
  services_circle_fill_turquoise: {
    28: vkontakteIcons.Icon28ServicesCircleFillTurquoise,
  },
  services_gibdd: {
    28: vkontakteIcons.Icon28ServicesGibdd,
  },
  settings_outline: {
    28: vkontakteIcons.Icon28SettingsOutline,
    56: vkontakteIcons.Icon56SettingsOutline,
  },
  shield_keyhole_outline: {
    28: vkontakteIcons.Icon28ShieldKeyholeOutline,
    56: vkontakteIcons.Icon56ShieldKeyholeOutline,
  },
  smartphone_share_outline: {
    28: vkontakteIcons.Icon28SmartphoneShareOutline,
  },
  smartphone_stars_outline: {
    28: vkontakteIcons.Icon28SmartphoneStarsOutline,
  },
  smiles_2_outline: {
    28: vkontakteIcons.Icon28Smiles2Outline,
  },
  sound_wave_outline: {
    28: vkontakteIcons.Icon28SoundWaveOutline,
    36: vkontakteIcons.Icon36SoundWaveOutline,
  },
  space_filled: {
    28: vkontakteIcons.Icon28SpaceFilled,
  },
  speedometer_max_outline: {
    28: vkontakteIcons.Icon28SpeedometerMaxOutline,
  },
  speedometer_start_outline: {
    28: vkontakteIcons.Icon28SpeedometerStartOutline,
  },
  stop_circle_outline: {
    28: vkontakteIcons.Icon28StopCircleOutline,
  },
  stopwatch_outline: {
    28: vkontakteIcons.Icon28StopwatchOutline,
    56: vkontakteIcons.Icon56StopwatchOutline,
  },
  story_circle_fill_violet: {
    28: vkontakteIcons.Icon28StoryCircleFillViolet,
  },
  story_circle_fill_yellow: {
    28: vkontakteIcons.Icon28StoryCircleFillYellow,
    56: vkontakteIcons.Icon56StoryCircleFillYellow,
  },
  story_question_circle_fill_violet: {
    28: vkontakteIcons.Icon28StoryQuestionCircleFillViolet,
  },
  subscription_outline: {
    28: vkontakteIcons.Icon28SubscriptionOutline,
  },
  sunglasses_circle_fill_gray: {
    28: vkontakteIcons.Icon28SunglassesCircleFillGray,
    48: vkontakteIcons.Icon48SunglassesCircleFillGray,
  },
  switch_outline: {
    28: vkontakteIcons.Icon28SwitchOutline,
    56: vkontakteIcons.Icon56SwitchOutline,
  },
  switch_outline_alt: {
    28: vkontakteIcons.Icon28SwitchOutlineAlt,
  },
  sync_outline: {
    28: vkontakteIcons.Icon28SyncOutline,
  },
  tablecells_outline: {
    28: vkontakteIcons.Icon28TablecellsOutline,
  },
  tear_off_flyer_fill_blue: {
    28: vkontakteIcons.Icon28TearOffFlyerFillBlue,
  },
  text_circle_fill_gray: {
    28: vkontakteIcons.Icon28TextCircleFillGray,
  },
  text_circle_outline: {
    28: vkontakteIcons.Icon28TextCircleOutline,
  },
  text_left_outline: {
    28: vkontakteIcons.Icon28TextLeftOutline,
  },
  text_style_1: {
    28: vkontakteIcons.Icon28TextStyle1,
  },
  text_style_2: {
    28: vkontakteIcons.Icon28TextStyle2,
  },
  text_style_3: {
    28: vkontakteIcons.Icon28TextStyle3,
  },
  train_outline: {
    28: vkontakteIcons.Icon28TrainOutline,
  },
  tv_alt_outline: {
    28: vkontakteIcons.Icon28TvAltOutline,
  },
  ugc_chat_sticker_circle_fill_blue: {
    28: vkontakteIcons.Icon28UgcChatStickerCircleFillBlue,
    48: vkontakteIcons.Icon48UgcChatStickerCircleFillBlue,
  },
  unpin_outline: {
    28: vkontakteIcons.Icon28UnpinOutline,
  },
  user_add_badge_outline: {
    28: vkontakteIcons.Icon28UserAddBadgeOutline,
    56: vkontakteIcons.Icon56UserAddBadgeOutline,
  },
  user_card_outline: {
    28: vkontakteIcons.Icon28UserCardOutline,
  },
  user_incoming_outline: {
    28: vkontakteIcons.Icon28UserIncomingOutline,
  },
  user_minus_outline: {
    28: vkontakteIcons.Icon28UserMinusOutline,
  },
  user_outgoing_outline: {
    28: vkontakteIcons.Icon28UserOutgoingOutline,
  },
  user_rectangle_horizontal_outline: {
    28: vkontakteIcons.Icon28UserRectangleHorizontalOutline,
    48: vkontakteIcons.Icon48UserRectangleHorizontalOutline,
  },
  user_star_slash_outline: {
    28: vkontakteIcons.Icon28UserStarSlashOutline,
  },
  user_text_rectangle_horizontal_outline: {
    28: vkontakteIcons.Icon28UserTextRectangleHorizontalOutline,
  },
  users_circle_fill_gray: {
    28: vkontakteIcons.Icon28UsersCircleFillGray,
  },
  users_circle_fill_yellow: {
    28: vkontakteIcons.Icon28UsersCircleFillYellow,
  },
  video_fill_outline: {
    28: vkontakteIcons.Icon28VideoFillOutline,
  },
  videocam_alt: {
    28: vkontakteIcons.Icon28VideocamAlt,
  },
  videocam_arrow_up_outline: {
    28: vkontakteIcons.Icon28VideocamArrowUpOutline,
  },
  videocam_arrow_up_slash_outline: {
    28: vkontakteIcons.Icon28VideocamArrowUpSlashOutline,
  },
  videocam_slash_alt: {
    28: vkontakteIcons.Icon28VideocamSlashAlt,
  },
  volume_alt: {
    28: vkontakteIcons.Icon28VolumeAlt,
  },
  volume_circle_fill_gray: {
    28: vkontakteIcons.Icon28VolumeCircleFillGray,
  },
  votes_transfer_circle_fill_turquoise: {
    28: vkontakteIcons.Icon28VotesTransferCircleFillTurquoise,
  },
  waves_4_right_outline: {
    28: vkontakteIcons.Icon28Waves4RightOutline,
  },
  window_check: {
    28: vkontakteIcons.Icon28WindowCheck,
  },
  wrist_watch_outline: {
    28: vkontakteIcons.Icon28WristWatchOutline,
  },
  zero_ruble_outline: {
    28: vkontakteIcons.Icon28ZeroRubleOutline,
  },
  checkbit_outline: {
    32: vkontakteIcons.Icon32CheckbitOutline,
  },
  graffiti: {
    32: vkontakteIcons.Icon32Graffiti,
  },
  image_format: {
    32: vkontakteIcons.Icon32ImageFormat,
  },
  image_rotate: {
    32: vkontakteIcons.Icon32ImageRotate,
  },
  privacy_circle_fill_purple: {
    32: vkontakteIcons.Icon32PrivacyCircleFillPurple,
  },
  send_circle: {
    32: vkontakteIcons.Icon32SendCircle,
  },
  videos: {
    32: vkontakteIcons.Icon32Videos,
  },
  coins_stack_high_outline: {
    36: vkontakteIcons.Icon36CoinsStackHighOutline,
    56: vkontakteIcons.Icon56CoinsStackHighOutline,
  },
  coins_stack_outline: {
    36: vkontakteIcons.Icon36CoinsStackOutline,
  },
  coins_stacks_2_outline: {
    36: vkontakteIcons.Icon36CoinsStacks2Outline,
  },
  coins_stacks_3_outline: {
    36: vkontakteIcons.Icon36CoinsStacks3Outline,
    56: vkontakteIcons.Icon56CoinsStacks3Outline,
  },
  gift_circe_filled: {
    36: vkontakteIcons.Icon36GiftCirceFilled,
  },
  heart_unlock: {
    36: vkontakteIcons.Icon36HeartUnlock,
  },
  playlist_cached: {
    36: vkontakteIcons.Icon36PlaylistCached,
  },
  podcasts_outline: {
    36: vkontakteIcons.Icon36PodcastsOutline,
    56: vkontakteIcons.Icon56PodcastsOutline,
  },
  app_gallery_button_en: {
    40: vkontakteIcons.Icon40AppGalleryButtonEn,
  },
  app_gallery_button_ru: {
    40: vkontakteIcons.Icon40AppGalleryButtonRu,
  },
  clips_circle: {
    40: vkontakteIcons.Icon40ClipsCircle,
  },
  comment_circle: {
    40: vkontakteIcons.Icon40CommentCircle,
  },
  cross_circle: {
    40: vkontakteIcons.Icon40CrossCircle,
  },
  document_circle: {
    40: vkontakteIcons.Icon40DocumentCircle,
  },
  download_circle: {
    40: vkontakteIcons.Icon40DownloadCircle,
  },
  galaxy_store_button_en: {
    40: vkontakteIcons.Icon40GalaxyStoreButtonEn,
  },
  galaxy_store_button_ru: {
    40: vkontakteIcons.Icon40GalaxyStoreButtonRu,
  },
  podcast_circle: {
    40: vkontakteIcons.Icon40PodcastCircle,
  },
  poll_circle: {
    40: vkontakteIcons.Icon40PollCircle,
  },
  videocam_circle: {
    40: vkontakteIcons.Icon40VideocamCircle,
  },
  film_strip_play: {
    48: vkontakteIcons.Icon48FilmStripPlay,
  },
  hide_circle_fill_purple: {
    48: vkontakteIcons.Icon48HideCircleFillPurple,
  },
  lock_circle_fill_green: {
    48: vkontakteIcons.Icon48LockCircleFillGreen,
  },
  market_fill_blue: {
    48: vkontakteIcons.Icon48MarketFillBlue,
  },
  notebook_circle_fill_blue: {
    48: vkontakteIcons.Icon48NotebookCircleFillBlue,
  },
  swipe_up: {
    48: vkontakteIcons.Icon48SwipeUp,
  },
  user_add_circle_fill_blue: {
    48: vkontakteIcons.Icon48UserAddCircleFillBlue,
  },
  users_circle_fill_violet: {
    48: vkontakteIcons.Icon48UsersCircleFillViolet,
  },
  writebar_done: {
    48: vkontakteIcons.Icon48WritebarDone,
  },
  writebar_send: {
    48: vkontakteIcons.Icon48WritebarSend,
  },
  android_device_outline: {
    56: vkontakteIcons.Icon56AndroidDeviceOutline,
  },
  apple_device_outline: {
    56: vkontakteIcons.Icon56AppleDeviceOutline,
  },
  arrow_right_door_outline: {
    56: vkontakteIcons.Icon56ArrowRightDoorOutline,
  },
  arrow_up_rectangle_play_outline: {
    56: vkontakteIcons.Icon56ArrowUpRectanglePlayOutline,
  },
  camera_off_outline: {
    56: vkontakteIcons.Icon56CameraOffOutline,
  },
  comments_outline: {
    56: vkontakteIcons.Icon56CommentsOutline,
  },
  cup_music_note_outline: {
    56: vkontakteIcons.Icon56CupMusicNoteOutline,
  },
  data_stack_lock_outline: {
    56: vkontakteIcons.Icon56DataStackLockOutline,
  },
  delete_outline_ios: {
    56: vkontakteIcons.Icon56DeleteOutlineIos,
  },
  do_not_disturb_outline: {
    56: vkontakteIcons.Icon56DoNotDisturbOutline,
  },
  download_square_outline: {
    56: vkontakteIcons.Icon56DownloadSquareOutline,
  },
  duration_outline: {
    56: vkontakteIcons.Icon56DurationOutline,
  },
  edit_circle_fill_turquoise: {
    56: vkontakteIcons.Icon56EditCircleFillTurquoise,
  },
  error_triangle_outline: {
    56: vkontakteIcons.Icon56ErrorTriangleOutline,
  },
  event_outline: {
    56: vkontakteIcons.Icon56EventOutline,
  },
  file_broken_outline: {
    56: vkontakteIcons.Icon56FileBrokenOutline,
  },
  flip_album_outline: {
    56: vkontakteIcons.Icon56FlipAlbumOutline,
  },
  flip_portrait_outline: {
    56: vkontakteIcons.Icon56FlipPortraitOutline,
  },
  folder_plus_badge_outline: {
    56: vkontakteIcons.Icon56FolderPlusBadgeOutline,
  },
  fragments_outline: {
    56: vkontakteIcons.Icon56FragmentsOutline,
  },
  gallery_outline: {
    56: vkontakteIcons.Icon56GalleryOutline,
  },
  grid_circle_fill_yellow: {
    56: vkontakteIcons.Icon56GridCircleFillYellow,
  },
  hand_point_up_left_outline: {
    56: vkontakteIcons.Icon56HandPointUpLeftOutline,
  },
  hand_tap_outline: {
    56: vkontakteIcons.Icon56HandTapOutline,
  },
  history_outline: {
    56: vkontakteIcons.Icon56HistoryOutline,
  },
  location_pin: {
    56: vkontakteIcons.Icon56LocationPin,
  },
  mail_plus_outline: {
    56: vkontakteIcons.Icon56MailPlusOutline,
  },
  message_missing_outline: {
    56: vkontakteIcons.Icon56MessageMissingOutline,
  },
  message_read_outline: {
    56: vkontakteIcons.Icon56MessageReadOutline,
  },
  message_story_outline: {
    56: vkontakteIcons.Icon56MessageStoryOutline,
  },
  microphone_outline: {
    56: vkontakteIcons.Icon56MicrophoneOutline,
  },
  money_circle_fill_blue: {
    56: vkontakteIcons.Icon56MoneyCircleFillBlue,
  },
  money_circle_fill_gray: {
    56: vkontakteIcons.Icon56MoneyCircleFillGray,
  },
  nft_heptagon_dashed_outline: {
    56: vkontakteIcons.Icon56NftHeptagonDashedOutline,
  },
  note_pen_outline: {
    56: vkontakteIcons.Icon56NotePenOutline,
    96: vkontakteIcons.Icon96NotePenOutline,
  },
  payment_card_cross_outline: {
    56: vkontakteIcons.Icon56PaymentCardCrossOutline,
  },
  phone_add_circle_fill_blue: {
    56: vkontakteIcons.Icon56PhoneAddCircleFillBlue,
  },
  picture_circle_fill_purple: {
    56: vkontakteIcons.Icon56PictureCircleFillPurple,
  },
  picture_in_picture: {
    56: vkontakteIcons.Icon56PictureInPicture,
  },
  play_gesture: {
    56: vkontakteIcons.Icon56PlayGesture,
  },
  rss_video_outline: {
    56: vkontakteIcons.Icon56RssVideoOutline,
  },
  stars_3_outline: {
    56: vkontakteIcons.Icon56Stars3Outline,
  },
  story_fill_circle_pink: {
    56: vkontakteIcons.Icon56StoryFillCirclePink,
  },
  tablet_outline: {
    56: vkontakteIcons.Icon56TabletOutline,
  },
  ugc_chat_sticker_outline: {
    56: vkontakteIcons.Icon56UgcChatStickerOutline,
  },
  unnamed_device_outline: {
    56: vkontakteIcons.Icon56UnnamedDeviceOutline,
  },
  user_microphone_outline: {
    56: vkontakteIcons.Icon56UserMicrophoneOutline,
  },
  user_square_on_square_slash_outline: {
    56: vkontakteIcons.Icon56UserSquareOnSquareSlashOutline,
  },
  video_slash_outline: {
    56: vkontakteIcons.Icon56VideoSlashOutline,
  },
  web_device_outline: {
    56: vkontakteIcons.Icon56WebDeviceOutline,
  },
  windows_device_outline: {
    56: vkontakteIcons.Icon56WindowsDeviceOutline,
  },
} as const;

export const additionalIconsMap = {
  vkhrtek_code: {
    16: additionalIcons.CodeIcon,
  },
  vkhrtek_code_block: {
    16: additionalIcons.CodeBlockIcon,
  },
  vkhrtek_justify_format: {
    16: additionalIcons.JustifyFormatIcon,
  },
  vkhrtek_omega: {
    16: additionalIcons.OmegaIcon,
  },
  vkhrtek_reference: {
    16: additionalIcons.ReferenceIcon,
  },
  vkhrtek_subscript: {
    16: additionalIcons.SubscriptIcon,
  },
  vkhrtek_superscript: {
    16: additionalIcons.SuperscriptIcon,
  },
  vkhrtek_video_link: {
    20: additionalIcons.VideoLinkIcon,
  },
  vkhrtek_company_page: {
    20: additionalIcons.SidebarCompanyPageIcon,
  },
  vkhrtek_vacations_page: {
    20: additionalIcons.SidebarVacationsPageIcon,
  },
  vkhrtek_vacation: {
    14: additionalIcons.VacationIcon,
  },
  vkhrtek_visibility_off: {
    16: additionalIcons.VisibilityOffIcon,
  },
  vkhrtek_maternity_leave: {
    16: additionalIcons.MaternityLeaveIcon,
  },
  vkhrtek_medical: {
    16: additionalIcons.MedicalIcon,
  },
  vkhrtek_absence: {
    16: additionalIcons.AbsenceIcon,
  },
  vkhrtek_separate_unit: {
    16: additionalIcons.SeparateUnitIcon,
  },
  vkhrtek_schedule_syncron: {
    16: additionalIcons.ScheduleSyncronIcon,
  },
  vkhrtek_file: {
    56: additionalIcons.FileIcon,
  },
  vkhrtek_award: {
    48: additionalIcons.AwardIcon,
  },
  vkhrtek_gender: {
    48: additionalIcons.GenderIcon,
  },
  vkhrtek_man: {
    48: additionalIcons.ManIcon,
  },
  vkhrtek_woman: {
    48: additionalIcons.WomanIcon,
  },
  vkhrtek_task_list: {
    40: additionalIcons.TaskListIcon,
  },
  vkhrtek_system_message: {
    24: additionalIcons.SystemMessageIcon,
  },
  vkhrtek_download_file: {
    16: additionalIcons.DownloadFileIcon,
  },
  vkhrtek_error_file: {
    16: additionalIcons.ErrorFileIcon,
  },
  vkhrtek_calendar: {
    14: additionalIcons.CalendarIcon,
  },
  vkhrtek_gosuslugi: {
    24: additionalIcons.GosUslugiIcon,
  },
  vkhrtek_done_bordered: {
    64: additionalIcons.DoneBorderedIcon,
  },
  vkhrtek_vk_pointer: {
    56: additionalIcons.VkPointerIcon,
  },
  vkhrtek_xml_file: {
    95: additionalIcons.XmlFileIcon,
  },
  vkhrtek_sig_file: {
    95: additionalIcons.SigFileIcon,
  },
  vkhrtek_flow_document: {
    24: additionalIcons.DocumentIcon,
  },
  vkhrtek_export_xlsx: {
    16: additionalIcons.ExportXlsxIcon,
  },
  vkhrtek_energy_important: {
    20: additionalIcons.EnergyImportantIcon,
  },
  vkhrtek_dots_vertical_disabled: {
    24: additionalIcons.DotsVerticalDisabledIcon,
  },
  vkhrtek_add_link_item: {
    20: additionalIcons.AddLinkIcon,
  },
  vkhrtek_add_section_item: {
    20: additionalIcons.AddSectionIcon,
  },
  vkhrtek_drag_disabled: {
    24: additionalIcons.DragDisabledIcon,
  },
  vkhrtek_at: {
    16: additionalIcons.AtIcon,
  },
  vkhrtek_stage_error: {
    16: additionalIcons.StageErrorIcon,
  },
  vkhrtek_stage_checked: {
    16: additionalIcons.StageCheckedIcon,
  },
  vkhrtek_slider_outline: {
    16: additionalIcons.SliderOutlineIcon,
  },
  vkhrtek_edit_circle_outline: {
    16: additionalIcons.EditCircleOutlineIcon,
  },
  vkhrtek_circle_outline: {
    16: additionalIcons.CircleOutlineIcon,
  },
};

export default { ...vkIconsMap, ...additionalIconsMap };
